export const DEFAULT_FONT = {
		id: "font_n23KxuTNynAlBkw_gntrs",
		family: "Aguafina Script",
		fullName: "Gunterz Black",
		postScriptName: "gunters",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jiQ5l0GWiJ4ke1XIf74qdQVo.png",
		style: "gunters",
		url: "/assets/fonts/Gunterz-Black.otf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
};
export const SECONDARY_FONT = {
	id: "font_n23KxuTNynAlBkw_geistregular",
	family: "geist-regular",
	fullName: "Geist Regular",
	postScriptName: "geist-regular",
	preview: "https://ik.imagekit.io/lh/fonts/v2/jiQ5l0GWiJ4ke1XIf74qdQVo.png",
	style: "geist-regular",
	url: "/assets/fonts/Geist-SemiBold.ttf",
	category: "display",
	createdAt: "2023-06-20T04:42:55.909Z",
	updatedAt: "2023-06-20T04:42:55.909Z",
	userId: null,
};

export const DEFAULT_WEIGHT = "Regular";
export const FONTS = [
	{
		id: "font_n23KxuTNynAlBkw_y0GLEBdc",
		family: "Aguafina Script",
		fullName: "Aguafina Script Regular",
		postScriptName: "AguafinaScript-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jiQ5l0GWiJ4ke1XIf74qdQVo.png",
		style: "AguafinaScript-Regular",
		url: "https://fonts.gstatic.com/s/aguafinascript/v9/If2QXTv_ZzSxGIO30LemWEOmt1bHqs4pgicOrg.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Q9Ks4SS8cdOO7dyEQm0rM075",
		family: "Palette Mosaic",
		fullName: "Palette Mosaic Regular",
		postScriptName: "PaletteMosaic-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZtRhKxgtpYrSUwxWIV56LBm7.png",
		style: "PaletteMosaic-Regular",
		url: "https://fonts.gstatic.com/s/palettemosaic/v1/AMOIz4aBvWuBFe3TohdW6YZ9MFiy4dxL4jSr.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dPgqNaXGEhj4b6lELZorieZO",
		family: "Bebas Neue",
		fullName: "Bebas Neue Regular",
		postScriptName: "BebasNeue-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hGQwQ2K3CK0AADRCloTylZKV.png",
		style: "BebasNeue-Regular",
		url: "https://fonts.gstatic.com/s/bebasneue/v2/JTUSjIg69CK48gW7PXooxW5rygbi49c.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kCv2D_XxkMja7yXkasWC9dWG",
		family: "Anonymous Pro",
		fullName: "Anonymous Pro Bold",
		postScriptName: "AnonymousPro-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/l5K743JaYh4u0QjxQHlA7Uap.png",
		style: "AnonymousPro-Bold",
		url: "https://fonts.gstatic.com/s/anonymouspro/v14/rP2cp2a15UIB7Un-bOeISG3pFuAT0CnW7KOywKo.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_45IBO7bq9UtOspMEWBuXOsbg",
		family: "Anonymous Pro",
		fullName: "Anonymous Pro Regular",
		postScriptName: "AnonymousPro-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3VSDJx_95Ok4VA8tQRRjZeHw.png",
		style: "AnonymousPro-Regular",
		url: "https://fonts.gstatic.com/s/anonymouspro/v14/rP2Bp2a15UIB7Un-bOeISG3pLlw89CH98Ko.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZzVJyDmk7OLMR1Xxj9W_UjHN",
		family: "Anonymous Pro",
		fullName: "Anonymous Pro Italic",
		postScriptName: "AnonymousPro-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MGaXvLRdmff3Aq9sWRiqZsFB.png",
		style: "AnonymousPro-Italic",
		url: "https://fonts.gstatic.com/s/anonymouspro/v14/rP2fp2a15UIB7Un-bOeISG3pHl428AP44Kqr2Q.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Ob14uylgmcH0EMMds9PjYj1p",
		family: "Anonymous Pro",
		fullName: "Anonymous Pro Bold Italic",
		postScriptName: "AnonymousPro-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/a8QIFLkZux4O1u0wWNIvb8_8.png",
		style: "AnonymousPro-BoldItalic",
		url: "https://fonts.gstatic.com/s/anonymouspro/v14/rP2ap2a15UIB7Un-bOeISG3pHl4OTCzc6IG30KqB9Q.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HoGF6Cokww_Tyh9pF4VuNQZe",
		family: "Bangers",
		fullName: "Bangers Regular",
		postScriptName: "Bangers-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OSwZ6pwdFVuNifRVRzwizqPI.png",
		style: "Bangers-Regular",
		url: "https://fonts.gstatic.com/s/bangers/v13/FeVQS0BTqb0h60ACL5la2bxii28.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wM8WqF2NlQWYzQyuQeaWiz0t",
		family: "Cabin Condensed",
		fullName: "Cabin Condensed Medium",
		postScriptName: "CabinCondensed-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/CiQTH8nYbBiJLej8zHYh7BFD.png",
		style: "CabinCondensed-Medium",
		url: "https://fonts.gstatic.com/s/cabincondensed/v14/nwpJtK6mNhBK2err_hqkYhHRqmwilMH97F15-K1oqQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_c0VLeMKlVoqu2tV5bejljgSO",
		family: "Cabin Condensed",
		fullName: "Cabin Condensed SemiBold",
		postScriptName: "CabinCondensed-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ahWUMI9_F7xcM95TgGOlY7aM.png",
		style: "CabinCondensed-SemiBold",
		url: "https://fonts.gstatic.com/s/cabincondensed/v14/nwpJtK6mNhBK2err_hqkYhHRqmwiuMb97F15-K1oqQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Wb9K91dS9rgHfo48OzgT_uuN",
		family: "Cabin Condensed",
		fullName: "Cabin Condensed Bold",
		postScriptName: "CabinCondensed-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WpQS5ecxsa1OjsDrOaW3Zvwi.png",
		style: "CabinCondensed-Bold",
		url: "https://fonts.gstatic.com/s/cabincondensed/v14/nwpJtK6mNhBK2err_hqkYhHRqmwi3Mf97F15-K1oqQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Re0iEsp7ss2uU48hV6tE0y99",
		family: "Cabin Condensed",
		fullName: "Cabin Condensed Regular",
		postScriptName: "CabinCondensed-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BnJBI9f9KcwfpgjWAvrtVB3X.png",
		style: "CabinCondensed-Regular",
		url: "https://fonts.gstatic.com/s/cabincondensed/v14/nwpMtK6mNhBK2err_hqkYhHRqmwaYOjZ5HZl8Q.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_yIPpID0mmOkSSHX9xvFjveBY",
		family: "Chelsea Market",
		fullName: "Chelsea Market Regular",
		postScriptName: "ChelseaMarket-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7_0u979TuV33AYeej8fyOd3a.png",
		style: "ChelseaMarket-Regular",
		url: "https://fonts.gstatic.com/s/chelseamarket/v8/BCawqZsHqfr89WNP_IApC8tzKBhlLA4uKkWk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_1eo9fno4_FNEfGOvI3msKGE2",
		family: "Chivo",
		fullName: "Chivo Light",
		postScriptName: "Chivo-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5ukbQ6OeWieeH54b__24P4ex.png",
		style: "Chivo-Light",
		url: "https://fonts.gstatic.com/s/chivo/v12/va9F4kzIxd1KFrjDY8Z_uqzGQC_-.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_VIVX__vAp_maSKenSbnMVswT",
		family: "Chivo",
		fullName: "Chivo Bold",
		postScriptName: "Chivo-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vQilMD84BFtTPv6u7tT18P1n.png",
		style: "Chivo-Bold",
		url: "https://fonts.gstatic.com/s/chivo/v12/va9F4kzIxd1KFrjTZMZ_uqzGQC_-.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vRwhEW64ajarVJ4P7CH8Qz9O",
		family: "Chivo",
		fullName: "Chivo Black",
		postScriptName: "Chivo-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ylBSRRaJXHmAmI_FjCYVHS23.png",
		style: "Chivo-Black",
		url: "https://fonts.gstatic.com/s/chivo/v12/va9F4kzIxd1KFrjrZsZ_uqzGQC_-.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_VkrclKZ3H0t8rI3gKgx9A8I_",
		family: "Chivo",
		fullName: "Chivo Light Italic",
		postScriptName: "Chivo-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hfrDAhCNv8oa9_tWT9CUSxBZ.png",
		style: "Chivo-LightItalic",
		url: "https://fonts.gstatic.com/s/chivo/v12/va9D4kzIxd1KFrBteUp9sKjkRT_-bF0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nAwBsxSEHN1MVbbrTmnmFzv3",
		family: "Chivo",
		fullName: "Chivo Regular",
		postScriptName: "Chivo-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SaJ9pBZ6UUab11fOm1ojDpI8.png",
		style: "Chivo-Regular",
		url: "https://fonts.gstatic.com/s/chivo/v12/va9I4kzIxd1KFoBvS-J3kbDP.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5sEBJPfHgsirUUJIBX8O1j1Y",
		family: "Chivo",
		fullName: "Chivo Italic",
		postScriptName: "Chivo-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/U3KhCkCSi5ZOfI_bjSvss_XF.png",
		style: "Chivo-Italic",
		url: "https://fonts.gstatic.com/s/chivo/v12/va9G4kzIxd1KFrBtQeZVlKDPWTY.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qADLf5CLUjUkDnHHSdfhBuNA",
		family: "Chivo",
		fullName: "Chivo Bold Italic",
		postScriptName: "Chivo-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fiMXbUGBjrAHpZ4obKzi3Ba_.png",
		style: "Chivo-BoldItalic",
		url: "https://fonts.gstatic.com/s/chivo/v12/va9D4kzIxd1KFrBteVp6sKjkRT_-bF0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3Tb0L_iFHJsr7AF1BCUtSjfa",
		family: "Chivo",
		fullName: "Chivo Black Italic",
		postScriptName: "Chivo-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/EVqPTk4wi243H50AIE5rFZIq.png",
		style: "Chivo-BlackItalic",
		url: "https://fonts.gstatic.com/s/chivo/v12/va9D4kzIxd1KFrBteWJ4sKjkRT_-bF0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KKhvqG55fm1n5NPpZ8DDF8b2",
		family: "Codystar",
		fullName: "Codystar Light",
		postScriptName: "Codystar-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5OorP97zIOHfAkg_6_9Dfm2F.png",
		style: "Codystar-Light",
		url: "https://fonts.gstatic.com/s/codystar/v10/FwZf7-Q1xVk-40qxOuYsyuyrj0e29bfC.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZJTMZTDNKEl1eIz8IUzmrDqd",
		family: "Codystar",
		fullName: "Codystar Regular",
		postScriptName: "Codystar",
		preview: "https://ik.imagekit.io/lh/fonts/v2/c7vZB6MFB4zYCjqkcA5J0E4z.png",
		style: "Codystar",
		url: "https://fonts.gstatic.com/s/codystar/v10/FwZY7-Q1xVk-40qxOt6A4sijpFu_.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_aUyRMG1ezt1SgKEJbviISrK7",
		family: "Didact Gothic",
		fullName: "Didact Gothic Regular",
		postScriptName: "DidactGothic-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Yt1h5eoPEdNo0AXDI4eLuW2f.png",
		style: "DidactGothic-Regular",
		url: "https://fonts.gstatic.com/s/didactgothic/v14/ahcfv8qz1zt6hCC5G4F_P4ASpUySp0LlcyQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_26UJj9oUyDXUBdZPhNisPo0G",
		family: "Encode Sans",
		fullName: "Encode Sans Thin",
		postScriptName: "EncodeSans-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bhrQnRdZ8R1DdskNByRQlD3N.png",
		style: "EncodeSans-Thin",
		url: "https://fonts.gstatic.com/s/encodesans/v8/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGGHiZtWP7FJCt2c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pqIleC7CWjXIqdD2fT_7GUv2",
		family: "Encode Sans",
		fullName: "Encode Sans ExtraLight",
		postScriptName: "EncodeSans-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jSphu8tRfLClVz1xcNKrMwFh.png",
		style: "EncodeSans-ExtraLight",
		url: "https://fonts.gstatic.com/s/encodesans/v8/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGOHjZtWP7FJCt2c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qeOCJ_rbjZxTqHLtpjiXktFy",
		family: "Encode Sans",
		fullName: "Encode Sans Light",
		postScriptName: "EncodeSans-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/k65rAicIeLRVeSDkgOcSMrTW.png",
		style: "EncodeSans-Light",
		url: "https://fonts.gstatic.com/s/encodesans/v8/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGD_jZtWP7FJCt2c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wvYnJegNrbhhBfi0UNpwaRhY",
		family: "Encode Sans",
		fullName: "Encode Sans Medium",
		postScriptName: "EncodeSans-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1XklmIsHtcX_qw2C4PJu0E73.png",
		style: "EncodeSans-Medium",
		url: "https://fonts.gstatic.com/s/encodesans/v8/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGFPjZtWP7FJCt2c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Jbj8xXAVqKXwq7z17AOUO5Y0",
		family: "Encode Sans",
		fullName: "Encode Sans SemiBold",
		postScriptName: "EncodeSans-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/40BKwtq_gkcWn81YZPj3dK0N.png",
		style: "EncodeSans-SemiBold",
		url: "https://fonts.gstatic.com/s/encodesans/v8/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGL_kZtWP7FJCt2c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TbERdc_Vmb89MaLODRlGRD9r",
		family: "Encode Sans",
		fullName: "Encode Sans Bold",
		postScriptName: "EncodeSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/eKutVlrlHKiFXsVNHSlOtRgY.png",
		style: "EncodeSans-Bold",
		url: "https://fonts.gstatic.com/s/encodesans/v8/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGIbkZtWP7FJCt2c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KPlwmkipBgbOIz2mYwtTTpoa",
		family: "Encode Sans",
		fullName: "Encode Sans ExtraBold",
		postScriptName: "EncodeSans-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2rN4tQE4UH92YkORA_riN0au.png",
		style: "EncodeSans-ExtraBold",
		url: "https://fonts.gstatic.com/s/encodesans/v8/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGOHkZtWP7FJCt2c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MPvdEHQ8jzgh9QKx1TaWtIIQ",
		family: "Encode Sans",
		fullName: "Encode Sans Black",
		postScriptName: "EncodeSans-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZraWCR8c1jAaWbnX6vR75G0n.png",
		style: "EncodeSans-Black",
		url: "https://fonts.gstatic.com/s/encodesans/v8/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGMjkZtWP7FJCt2c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cInQIFSzBudDOI8lDebt1IYD",
		family: "Encode Sans",
		fullName: "Encode Sans Regular",
		postScriptName: "EncodeSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FlMfdQCoT5PcdV0p4rws3Uar.png",
		style: "EncodeSans-Regular",
		url: "https://fonts.gstatic.com/s/encodesans/v8/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGGHjZtWP7FJCt2c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4p_gI_maoH3CSA0PHeTddeHt",
		family: "Frijole",
		fullName: "Frijole Regular",
		postScriptName: "Frijole",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gvE2Irpfhf5pZUGoJx7Szr5o.png",
		style: "Frijole",
		url: "https://fonts.gstatic.com/s/frijole/v9/uU9PCBUR8oakM2BQ7xPb3vyHmlI.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KTQTFYYbYxIQQxzTKdbNEJUC",
		family: "Gaegu",
		fullName: "Gaegu Light",
		postScriptName: "Gaegu-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Qxoklgv3mbfNp6IZxMQhIitX.png",
		style: "Gaegu-Light",
		url: "https://fonts.gstatic.com/s/gaegu/v10/TuGSUVB6Up9NU57nifw74sdtBk0x.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_To09uQWgoLyrhnsCAqmKXDla",
		family: "Gaegu",
		fullName: "Gaegu Bold",
		postScriptName: "Gaegu-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/behLo7WIN_84ujK5I7a88QDh.png",
		style: "Gaegu-Bold",
		url: "https://fonts.gstatic.com/s/gaegu/v10/TuGSUVB6Up9NU573jvw74sdtBk0x.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MR28qx9t4rtgDLna8aAOOlla",
		family: "Gaegu",
		fullName: "Gaegu Regular",
		postScriptName: "Gaegu-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gdwq6DmyCVXJYFIndRaDBk0A.png",
		style: "Gaegu-Regular",
		url: "https://fonts.gstatic.com/s/gaegu/v10/TuGfUVB6Up9NU6ZLodgzydtk.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_g0lvyRBnnI91DxEcF5dROkMY",
		family: "Arima Madurai",
		fullName: "Arima Madurai Thin",
		postScriptName: "ArimaMadurai-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/H7MoJd1gPrkpsqu3VNurA20G.png",
		style: "ArimaMadurai-Thin",
		url: "https://fonts.gstatic.com/s/arimamadurai/v7/t5t4IRoeKYORG0WNMgnC3seB1V3PqrGCch4Drg.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YKhZBRCF26hrtn3UgYPSm_Sz",
		family: "Arima Madurai",
		fullName: "Arima Madurai ExtraLight",
		postScriptName: "ArimaMadurai-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jS1SMmKUvuY9E9ncI00FiPg7.png",
		style: "ArimaMadurai-ExtraLight",
		url: "https://fonts.gstatic.com/s/arimamadurai/v7/t5t7IRoeKYORG0WNMgnC3seB1fHuipusfhcat2c.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_f_GJeKT7dJKQi8oRg1jD8H3S",
		family: "Arima Madurai",
		fullName: "Arima Madurai Light",
		postScriptName: "ArimaMadurai-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wdz6Dd_Dt5hYao7toWy0umHF.png",
		style: "ArimaMadurai-Light",
		url: "https://fonts.gstatic.com/s/arimamadurai/v7/t5t7IRoeKYORG0WNMgnC3seB1ZXtipusfhcat2c.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_B5l1nJ41gxVvr0jYHYqTqf2w",
		family: "Arima Madurai",
		fullName: "Arima Madurai Medium",
		postScriptName: "ArimaMadurai-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Y12Qg4adKMFjNSeCTtCavmKW.png",
		style: "ArimaMadurai-Medium",
		url: "https://fonts.gstatic.com/s/arimamadurai/v7/t5t7IRoeKYORG0WNMgnC3seB1c3sipusfhcat2c.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zRHYEiAvSFoAgB5i7HIDym3j",
		family: "Arima Madurai",
		fullName: "Arima Madurai Bold",
		postScriptName: "ArimaMadurai-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gDkpDYqRBNaawwO6eZERMENM.png",
		style: "ArimaMadurai-Bold",
		url: "https://fonts.gstatic.com/s/arimamadurai/v7/t5t7IRoeKYORG0WNMgnC3seB1YXqipusfhcat2c.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_viY0FfElJCCLs4PeQrxVJ_BS",
		family: "Arima Madurai",
		fullName: "Arima Madurai ExtraBold",
		postScriptName: "ArimaMadurai-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VqaUxiTQ30cMg6ELD6buGHrx.png",
		style: "ArimaMadurai-ExtraBold",
		url: "https://fonts.gstatic.com/s/arimamadurai/v7/t5t7IRoeKYORG0WNMgnC3seB1Znpipusfhcat2c.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SKP_zDH_0sizYb4xNf5G_CWz",
		family: "Arima Madurai",
		fullName: "Arima Madurai Black",
		postScriptName: "ArimaMadurai-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/0IIDbeBbO51PI8RwIAgzhQlU.png",
		style: "ArimaMadurai-Black",
		url: "https://fonts.gstatic.com/s/arimamadurai/v7/t5t7IRoeKYORG0WNMgnC3seB1b3oipusfhcat2c.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FtTXF1MrqBlqO2cyEZvm_Dwa",
		family: "Arima Madurai",
		fullName: "Arima Madurai Regular",
		postScriptName: "ArimaMadurai-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/M1HQyl9skJ_2i7x40CegYdKQ.png",
		style: "ArimaMadurai-Regular",
		url: "https://fonts.gstatic.com/s/arimamadurai/v7/t5tmIRoeKYORG0WNMgnC3seB7TnFrpOHYh4.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8PWpnzAmcZ1mZ0LeKqBT6cKu",
		family: "Berkshire Swash",
		fullName: "Berkshire Swash Regular",
		postScriptName: "BerkshireSwash-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7SppWuBGF8grUyC_qQl9KM9L.png",
		style: "BerkshireSwash-Regular",
		url: "https://fonts.gstatic.com/s/berkshireswash/v9/ptRRTi-cavZOGqCvnNJDl5m5XmNPrcQybX4pQA.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_e0SnxxYyyH0nOQOlHMRV_OJX",
		family: "Bungee Inline",
		fullName: "Bungee Inline Regular",
		postScriptName: "BungeeInline-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/GkccLK4TBoLSpXLoDHMvelob.png",
		style: "BungeeInline-Regular",
		url: "https://fonts.gstatic.com/s/bungeeinline/v6/Gg8zN58UcgnlCweMrih332VuDGJ1-FEglsc.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ilP8cKrY94fscFkkGf07Hpbv",
		family: "Bungee Shade",
		fullName: "Bungee Shade Regular",
		postScriptName: "BungeeShade-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/0eeY_QCTXdda0Y0ZHOvZcx_2.png",
		style: "BungeeShade-Regular",
		url: "https://fonts.gstatic.com/s/bungeeshade/v6/DtVkJxarWL0t2KdzK3oI_jks7iLSrwFUlw.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_XPahZpxXbabGA7XKJXAIVVCy",
		family: "Courgette",
		fullName: "Courgette Regular",
		postScriptName: "Courgette-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WJedJx_7mJ_ill5HOudxBhj_.png",
		style: "Courgette-Regular",
		url: "https://fonts.gstatic.com/s/courgette/v8/wEO_EBrAnc9BLjLQAUkFUfAL3EsHiA.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_boiUbG61_SQasLHaUWfO6HfH",
		family: "Cuprum",
		fullName: "Cuprum Medium",
		postScriptName: "Cuprum-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kupps_6cFys7Sm8feqwONO_C.png",
		style: "Cuprum-Medium",
		url: "https://fonts.gstatic.com/s/cuprum/v14/dg45_pLmvrkcOkBnKsOzXyGWTBcmg9f6ZjzSJjQjgnU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4ENVXEoeENMICzEhobW1yYfx",
		family: "Cuprum",
		fullName: "Cuprum SemiBold",
		postScriptName: "Cuprum-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/QuV4ZVHx7RSx3YovDJcnfOXa.png",
		style: "Cuprum-SemiBold",
		url: "https://fonts.gstatic.com/s/cuprum/v14/dg45_pLmvrkcOkBnKsOzXyGWTBcmgzv9ZjzSJjQjgnU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9YjSM6IrKjR6U4lmBesiJoKE",
		family: "Cuprum",
		fullName: "Cuprum Bold",
		postScriptName: "Cuprum-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bcrBE5AF7W3EPsQgS15ADyuf.png",
		style: "Cuprum-Bold",
		url: "https://fonts.gstatic.com/s/cuprum/v14/dg45_pLmvrkcOkBnKsOzXyGWTBcmgwL9ZjzSJjQjgnU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_R72tekXSK1f9TXPBiVXIWIC7",
		family: "Cuprum",
		fullName: "Cuprum Regular",
		postScriptName: "Cuprum-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6E9izSckmNWNl2tVDx4T9lKF.png",
		style: "Cuprum-Regular",
		url: "https://fonts.gstatic.com/s/cuprum/v14/dg45_pLmvrkcOkBnKsOzXyGWTBcmg-X6ZjzSJjQjgnU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SElsSbK1EH28BLcOBUqZ9xip",
		family: "Cuprum",
		fullName: "Cuprum Italic",
		postScriptName: "Cuprum-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tlw18Ap58z1_3G1tGdtPnmF1.png",
		style: "Cuprum-Italic",
		url: "https://fonts.gstatic.com/s/cuprum/v14/dg47_pLmvrkcOkBNI_FMh0j91rkhli25jn_YIhYmknUPEA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_LKB2vkL8un0UiIW7pezWMxWs",
		family: "Cuprum",
		fullName: "Cuprum Medium Italic",
		postScriptName: "Cuprum-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/xz1zLODDTzJeDvAYRC9KU09u.png",
		style: "Cuprum-MediumItalic",
		url: "https://fonts.gstatic.com/s/cuprum/v14/dg47_pLmvrkcOkBNI_FMh0j91rkhli25vH_YIhYmknUPEA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Yg8HDg8Uh0m0KPjy9b4qgVmF",
		family: "Cuprum",
		fullName: "Cuprum SemiBold Italic",
		postScriptName: "Cuprum-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_BmJaB0_QjMtswgoTEW4fJ2h.png",
		style: "Cuprum-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/cuprum/v14/dg47_pLmvrkcOkBNI_FMh0j91rkhli25UHjYIhYmknUPEA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_byjcPlyrppW_8I2JSUKzjotZ",
		family: "Cuprum",
		fullName: "Cuprum Bold Italic",
		postScriptName: "Cuprum-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zBrrQG8hnSECCzv6jnSt85k9.png",
		style: "Cuprum-BoldItalic",
		url: "https://fonts.gstatic.com/s/cuprum/v14/dg47_pLmvrkcOkBNI_FMh0j91rkhli25aXjYIhYmknUPEA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0vWovP2PIRx339sk59Fj1nxl",
		family: "Domine",
		fullName: "Domine Medium",
		postScriptName: "Domine-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/0kMHi3KMFzYWe9Prt7iEzAji.png",
		style: "Domine-Medium",
		url: "https://fonts.gstatic.com/s/domine/v11/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X0DAI10VErGuW8Q.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ordzSlQDIHmslS598Ey2lXvG",
		family: "Domine",
		fullName: "Domine SemiBold",
		postScriptName: "Domine-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/EN1cGP5b88iFPjxAwRgAXej0.png",
		style: "Domine-SemiBold",
		url: "https://fonts.gstatic.com/s/domine/v11/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X6zHI10VErGuW8Q.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_czKzv2Zcq0Wniz3GaV417AlR",
		family: "Domine",
		fullName: "Domine Bold",
		postScriptName: "Domine-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/XPphUfdQL1LZ2EPWYIZTz3i7.png",
		style: "Domine-Bold",
		url: "https://fonts.gstatic.com/s/domine/v11/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X5XHI10VErGuW8Q.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5NOyCTw6Wuza0x8tf0Vmr6rz",
		family: "Domine",
		fullName: "Domine Regular",
		postScriptName: "Domine-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OLNhdNfJyMho3pIeu1UyYp0t.png",
		style: "Domine-Regular",
		url: "https://fonts.gstatic.com/s/domine/v11/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X3LAI10VErGuW8Q.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_oDtD68T_NjEYWzBw6S9cQ0kC",
		family: "Faustina",
		fullName: "Faustina Light",
		postScriptName: "Faustina-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/xaGLACuTj1l_nP6O3Lm_sgUB.png",
		style: "Faustina-Light",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHls3IEvGVWWe8tbEg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__jcMuxBQpUrOEZjra37XK3Xz",
		family: "Faustina",
		fullName: "Faustina Medium",
		postScriptName: "Faustina-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LAyMH9eG67dkQt3xHzP4M0eB.png",
		style: "Faustina-Medium",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlssIEvGVWWe8tbEg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_AS9O2y1V6Ynweo8lP3kn6WP8",
		family: "Faustina",
		fullName: "Faustina SemiBold",
		postScriptName: "Faustina-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KZndK4e0xwqgjGSfBuUNr7xZ.png",
		style: "Faustina-SemiBold",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsXIYvGVWWe8tbEg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UUodETJhyIwEgRJI18cQzjwJ",
		family: "Faustina",
		fullName: "Faustina Bold",
		postScriptName: "Faustina-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Ap_MGlJDwQ6DI9F0XkaFshjQ.png",
		style: "Faustina-Bold",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsZYYvGVWWe8tbEg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JidCgKbu0gOF2LmOM9ywWGg5",
		family: "Faustina",
		fullName: "Faustina ExtraBold",
		postScriptName: "Faustina-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SSIsWLBDCiiTGQFe3boANh62.png",
		style: "Faustina-ExtraBold",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsAoYvGVWWe8tbEg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7oBVaA5RehpMDFy9HzhgKBvE",
		family: "Faustina",
		fullName: "Faustina Regular",
		postScriptName: "Faustina-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AG20jt0Ad9vGjAO1ZO2kp0kG.png",
		style: "Faustina-Regular",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsgoEvGVWWe8tbEg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Y3gCB2fur5bydkU6LlCnVV2m",
		family: "Faustina",
		fullName: "Faustina Light Italic",
		postScriptName: "Faustina-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aeuGF1AL6rwnHc2_oNbVdyYr.png",
		style: "Faustina-LightItalic",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsKZWl-SWc5LEnoF.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_LrGXRYAXlLV54iQ8mjVJ4HCN",
		family: "Faustina",
		fullName: "Faustina Italic",
		postScriptName: "Faustina-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NfbdmpBv2_iQXPy4iB9wYnXP.png",
		style: "Faustina-Italic",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsLHWl-SWc5LEnoF.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hnWvdfSOWYAJyUecSvUp5plx",
		family: "Faustina",
		fullName: "Faustina Medium Italic",
		postScriptName: "Faustina-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jw72fcR9C0PNcySMbANsj2fu.png",
		style: "Faustina-MediumItalic",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsL1Wl-SWc5LEnoF.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NK6juaEZONY3Y0aTFZIrw47n",
		family: "Faustina",
		fullName: "Faustina SemiBold Italic",
		postScriptName: "Faustina-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/j6BkfoOdUPkTMRG9MjLS47Ql.png",
		style: "Faustina-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsIZXV-SWc5LEnoF.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3eodLppxUG3u5LSZssVecsl_",
		family: "Faustina",
		fullName: "Faustina Bold Italic",
		postScriptName: "Faustina-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/T0Lo5kEX3hlz8gD158V5TtZD.png",
		style: "Faustina-BoldItalic",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsIgXV-SWc5LEnoF.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_mVMtVSDT0uaJbXQMHpY6Wm74",
		family: "Faustina",
		fullName: "Faustina ExtraBold Italic",
		postScriptName: "Faustina-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bOpKzOPktE0d23GZOmcKWrNf.png",
		style: "Faustina-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/faustina/v11/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsJHXV-SWc5LEnoF.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EbckVEO02YEo_Mak_ktAzN5d",
		family: "Francois One",
		fullName: "Francois One Regular",
		postScriptName: "FrancoisOne-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/joDhazQ0kPRcXm7FlXaj1bhd.png",
		style: "FrancoisOne-Regular",
		url: "https://fonts.gstatic.com/s/francoisone/v15/_Xmr-H4zszafZw3A-KPSZutNxgKQu_avAg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_iwRxztttTrdpg6Ui7ZPdtKCn",
		family: "Allura",
		fullName: "Allura Regular",
		postScriptName: "Allura-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JzMGeQsZyTE2kSnslJhv5VjS.png",
		style: "Allura-Regular",
		url: "https://fonts.gstatic.com/s/allura/v15/9oRPNYsQpS4zjuAPjAIXPtrrGA.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IKkuKBSaTI1ysjLzUlBp7H5a",
		family: "B612",
		fullName: "B612 Bold",
		postScriptName: "B612-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HYquL8r7WP9Uvr8RCb27vD7S.png",
		style: "B612-Bold",
		url: "https://fonts.gstatic.com/s/b612/v5/3Jn9SDDxiSz34oWXPDCLTXUETuE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NmSNq4AzEsN5sIBazAMkXzYK",
		family: "B612",
		fullName: "B612 Regular",
		postScriptName: "B612-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bL3L3n4GCKpIj8yIF3UreK8F.png",
		style: "B612-Regular",
		url: "https://fonts.gstatic.com/s/b612/v5/3JnySDDxiSz32jm4GDigUXw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_P8VmjMhVDcsT0nvBO4GVgilm",
		family: "B612",
		fullName: "B612 Italic",
		postScriptName: "B612-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/trfYwet3L_Nd5SSJteHzbP1i.png",
		style: "B612-Italic",
		url: "https://fonts.gstatic.com/s/b612/v5/3Jn8SDDxiSz36juyHBqlQXwdVw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_mdrB3Obj51QBcvT29gsdnaXf",
		family: "B612",
		fullName: "B612 Bold Italic",
		postScriptName: "B612-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gvnJYer42_NgtfAbBoW3EUT_.png",
		style: "B612-BoldItalic",
		url: "https://fonts.gstatic.com/s/b612/v5/3Jn_SDDxiSz36juKoDWBSVcBXuFb0Q.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__wofhvubFo7VCvty4DdOyKMg",
		family: "Cabin",
		fullName: "Cabin Medium",
		postScriptName: "Cabin-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9Xv91kC7Ymg7_2iDmhgy_7MK.png",
		style: "Cabin-Medium",
		url: "https://fonts.gstatic.com/s/cabin/v18/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkW-EL7Gvxm7rE_s.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7OsZkaNY9THXKVCNFlXz5ul6",
		family: "Cabin",
		fullName: "Cabin SemiBold",
		postScriptName: "Cabin-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/sBvAC1F8AL46pgxZYiWzmXyh.png",
		style: "Cabin-SemiBold",
		url: "https://fonts.gstatic.com/s/cabin/v18/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkYODL7Gvxm7rE_s.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_OWK36BVUog3razoiH9N8nPhb",
		family: "Cabin",
		fullName: "Cabin Bold",
		postScriptName: "Cabin-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ax_b3U6qHHRjHJzM_6gfiX88.png",
		style: "Cabin-Bold",
		url: "https://fonts.gstatic.com/s/cabin/v18/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkbqDL7Gvxm7rE_s.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wsJDzaun2EIJnKKvqsaVsKKN",
		family: "Cabin",
		fullName: "Cabin Regular",
		postScriptName: "Cabin-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZMAd2C2Q9x7Jvj8tv11EuAo1.png",
		style: "Cabin-Regular",
		url: "https://fonts.gstatic.com/s/cabin/v18/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkV2EL7Gvxm7rE_s.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_w2Rxzah_YTXtFUYUKoJpTkCI",
		family: "Cabin",
		fullName: "Cabin Italic",
		postScriptName: "Cabin-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ywzCefuqJM3fRQjM2SVbo5_k.png",
		style: "Cabin-Italic",
		url: "https://fonts.gstatic.com/s/cabin/v18/u-4V0qWljRw-Pd815fNqc8T_wAFcX-c37MPiNYlWniJ2hJXHx_KlwkzuA_u1Bg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ibLNFUtsMnG64mRgobslF0_p",
		family: "Cabin",
		fullName: "Cabin Medium Italic",
		postScriptName: "Cabin-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mtrB2peCgkfRrdfgHnIpuwk9.png",
		style: "Cabin-MediumItalic",
		url: "https://fonts.gstatic.com/s/cabin/v18/u-4V0qWljRw-Pd815fNqc8T_wAFcX-c37MPiNYlWniJ2hJXH9fKlwkzuA_u1Bg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4905UnbdoXklPpHYS_KKgT7o",
		family: "Cabin",
		fullName: "Cabin SemiBold Italic",
		postScriptName: "Cabin-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SnGTDyF01v8OJcH0uIIkKGLZ.png",
		style: "Cabin-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/cabin/v18/u-4V0qWljRw-Pd815fNqc8T_wAFcX-c37MPiNYlWniJ2hJXHGfWlwkzuA_u1Bg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jr6QR3vTSMn8tSFRODkc0dJ4",
		family: "Cabin",
		fullName: "Cabin Bold Italic",
		postScriptName: "Cabin-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/C9W0kW92Xu7_5XBH87_MZwYy.png",
		style: "Cabin-BoldItalic",
		url: "https://fonts.gstatic.com/s/cabin/v18/u-4V0qWljRw-Pd815fNqc8T_wAFcX-c37MPiNYlWniJ2hJXHIPWlwkzuA_u1Bg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_s0mYMBQtp3JdLVBJKOzTK1AI",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond Light",
		postScriptName: "CormorantGaramond-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hf_0sBt0LhH1frn0PCIwqFWm.png",
		style: "CormorantGaramond-Light",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQAllvuQWJ5heb_w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_23X0GNbjcCIZEPXiMEChZ0yR",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond Medium",
		postScriptName: "CormorantGaramond-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/cuywhnbJ5oxfhl6c14_0qWOi.png",
		style: "CormorantGaramond-Medium",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQWlhvuQWJ5heb_w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FVPBsH7vrWD7S5gCXGjj1wL2",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond SemiBold",
		postScriptName: "CormorantGaramond-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/yQ0w2Acde2TTzEie6nYxyCWX.png",
		style: "CormorantGaramond-SemiBold",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQdl9vuQWJ5heb_w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_DSastll3tio3vWYe0bqgV99u",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond Bold",
		postScriptName: "CormorantGaramond-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Ii_ZAclQJphqdyUh5zxZZD8y.png",
		style: "CormorantGaramond-Bold",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQEl5vuQWJ5heb_w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_U0KyUzzDbcQ8yX0EYztYcHMT",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond Light Italic",
		postScriptName: "CormorantGaramond-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6lEiusYACVER7vTdQ2nXVbC2.png",
		style: "CormorantGaramond-LightItalic",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3WmX5slCNuHLi8bLeY9MK7whWMhyjYrEPjuw-NxBKL_y94.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fVKvsq_pE1D4HvH39dQSFpNo",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond Regular",
		postScriptName: "CormorantGaramond-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/sJ0Vye0hqvfGakMwYUsFYjFz.png",
		style: "CormorantGaramond-Regular",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3bmX5slCNuHLi8bLeY9MK7whWMhyjornFLsS6V7w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_mFq1LNGXLPO7sysFC5B7iLDJ",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond Italic",
		postScriptName: "CormorantGaramond-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/X0GBEnSJRz_omITxkn0jgvXw.png",
		style: "CormorantGaramond-Italic",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3ZmX5slCNuHLi8bLeY9MK7whWMhyjYrHtPkyuF7w6C.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_G9TgohUoo_7SwoYtCenYIjlz",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond Medium Italic",
		postScriptName: "CormorantGaramond-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Q4Eoq0uQrZBUx9898VbTAJ8I.png",
		style: "CormorantGaramond-MediumItalic",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3WmX5slCNuHLi8bLeY9MK7whWMhyjYrEO7ug-NxBKL_y94.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5OKlO5zNmMtCTRKi9BYizjCp",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond SemiBold Italic",
		postScriptName: "CormorantGaramond-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KYuq_5L1jaru8V5IWbIJV9wB.png",
		style: "CormorantGaramond-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3WmX5slCNuHLi8bLeY9MK7whWMhyjYrEOXvQ-NxBKL_y94.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8YzP911MgUme9pMErDNrwqAN",
		family: "Cormorant Garamond",
		fullName: "Cormorant Garamond Bold Italic",
		postScriptName: "CormorantGaramond-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/enH29eW9rfxXF2aMZpGbMOAO.png",
		style: "CormorantGaramond-BoldItalic",
		url: "https://fonts.gstatic.com/s/cormorantgaramond/v10/co3WmX5slCNuHLi8bLeY9MK7whWMhyjYrEPzvA-NxBKL_y94.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ou56saF5ryUyRG6MGZW_Zmjc",
		family: "Eater",
		fullName: "Eater Regular",
		postScriptName: "Eater-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hMKHmvPYIELU4uFUW9lGO0rx.png",
		style: "Eater-Regular",
		url: "https://fonts.gstatic.com/s/eater/v11/mtG04_FCK7bOvpu2u3FwsXsR.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wezUqkk55sUrt_LakadWZ2CJ",
		family: "Amiri",
		fullName: "Amiri Bold",
		postScriptName: "Amiri-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LL6JQAZh8xstSs_zFwAYWKYa.png",
		style: "Amiri-Bold",
		url: "https://fonts.gstatic.com/s/amiri/v17/J7acnpd8CGxBHp2VkZY4xJ9CGyAa.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__GRqVxfbDr_N8NU275FaLcOA",
		family: "Amiri",
		fullName: "Amiri Regular",
		postScriptName: "Amiri-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LhIFfEKy5WXIBCcKTfVWCGEH.png",
		style: "Amiri-Regular",
		url: "https://fonts.gstatic.com/s/amiri/v17/J7aRnpd8CGxBHqUpvrIw74NL.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_oMS3BNj2khgtn1ItUiFF4r08",
		family: "Amiri",
		fullName: "Amiri Italic",
		postScriptName: "Amiri-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bR0e8Bo6CEwqjkIH0hf47nfu.png",
		style: "Amiri-Italic",
		url: "https://fonts.gstatic.com/s/amiri/v17/J7afnpd8CGxBHpUrtLYS6pNLAjk.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3MahAcepKJEoQJbN83DCYmr0",
		family: "Amiri",
		fullName: "Amiri Bold Italic",
		postScriptName: "Amiri-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kRmfkooi3AQK0c2JEvz5mCXi.png",
		style: "Amiri-BoldItalic",
		url: "https://fonts.gstatic.com/s/amiri/v17/J7aanpd8CGxBHpUrjAo9zptgHjAavCA.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HYg55Pi6l1PkLLGv4AYdqplI",
		family: "Antic",
		fullName: "Antic Regular",
		postScriptName: "Antic-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HXGJr8WPzhKwYSjIa6j2W8Ck.png",
		style: "Antic-Regular",
		url: "https://fonts.gstatic.com/s/antic/v12/TuGfUVB8XY5DRaZLodgzydtk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_2FJGsLWnIuxx23b9JC_WP_lS",
		family: "Atma",
		fullName: "Atma Light",
		postScriptName: "Atma-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pPTY6GhWkqOexen2YMrd1jjM.png",
		style: "Atma-Light",
		url: "https://fonts.gstatic.com/s/atma/v8/uK_z4rqWc-Eoo8JzKjc9PvedRkM.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8sDy4tv_qa0T6XY7qnkq8kER",
		family: "Atma",
		fullName: "Atma Medium",
		postScriptName: "Atma-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jC94xqbC9IoJntoZxmyAIg3x.png",
		style: "Atma-Medium",
		url: "https://fonts.gstatic.com/s/atma/v8/uK_z4rqWc-Eoo5pyKjc9PvedRkM.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_g7A_jQPCAalpodWRuhoSvHFj",
		family: "Atma",
		fullName: "Atma SemiBold",
		postScriptName: "Atma-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/XYmj_A9kAkCeB03Y2j_yBga0.png",
		style: "Atma-SemiBold",
		url: "https://fonts.gstatic.com/s/atma/v8/uK_z4rqWc-Eoo7Z1Kjc9PvedRkM.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_moWZ7TPCoQJqiC8f6mBwv4ks",
		family: "Atma",
		fullName: "Atma Bold",
		postScriptName: "Atma-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RxKC4UZY91vfZLK8q5HJ8eHV.png",
		style: "Atma-Bold",
		url: "https://fonts.gstatic.com/s/atma/v8/uK_z4rqWc-Eoo9J0Kjc9PvedRkM.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_By_6sPObA2BVPeG6jwHkxRhR",
		family: "Atma",
		fullName: "Atma Regular",
		postScriptName: "Atma-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/y250wWN9CJZSkCmkhRmrFLTb.png",
		style: "Atma-Regular",
		url: "https://fonts.gstatic.com/s/atma/v8/uK_84rqWc-Eom25bDj8WIv4.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SY1PDXy2AcJYqSNaBpvEKP3A",
		family: "Barlow",
		fullName: "Barlow Thin",
		postScriptName: "Barlow-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tjUXW1ruDMNmTxj2wqdUIsbS.png",
		style: "Barlow-Thin",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHrv4kjgoGqM7E3b8s8yn4hnCci.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kjMjwAc7or3CfdLfpTvfama5",
		family: "Barlow",
		fullName: "Barlow ExtraLight",
		postScriptName: "Barlow-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5KMchaIPGr0HT3SzzczYi1d4.png",
		style: "Barlow-ExtraLight",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHqv4kjgoGqM7E3w-oc4FAtlT47dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qSxvjtyIzt212lDPYOuWJ7I3",
		family: "Barlow",
		fullName: "Barlow Light",
		postScriptName: "Barlow-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gnKZMcfIhOuTfS3g834Jvq3a.png",
		style: "Barlow-Light",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHqv4kjgoGqM7E3p-kc4FAtlT47dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fv4iJSX8sbrbAy_59JVImwDT",
		family: "Barlow",
		fullName: "Barlow Medium",
		postScriptName: "Barlow-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/icqNkVPC_OlBnyyKk0A2iCMa.png",
		style: "Barlow-Medium",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHqv4kjgoGqM7E3_-gc4FAtlT47dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TyeIVgGJ0hJm75m7pj_DtGiX",
		family: "Barlow",
		fullName: "Barlow SemiBold",
		postScriptName: "Barlow-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/12W5ceRd3XmhU6XmhC6zGRhJ.png",
		style: "Barlow-SemiBold",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHqv4kjgoGqM7E30-8c4FAtlT47dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6QI3n0mQfh1QFqReffpWtsBg",
		family: "Barlow",
		fullName: "Barlow Bold",
		postScriptName: "Barlow-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/W8mnV4bMPfG7ZPmaoJa06t2C.png",
		style: "Barlow-Bold",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHqv4kjgoGqM7E3t-4c4FAtlT47dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GMQDh9Fsh_cq5DUaskz0czUE",
		family: "Barlow",
		fullName: "Barlow ExtraBold",
		postScriptName: "Barlow-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4x7aQfoiG12giqaQilETJCo9.png",
		style: "Barlow-ExtraBold",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHqv4kjgoGqM7E3q-0c4FAtlT47dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ewwfnt2zjesXIPCwWMdkSg3r",
		family: "Barlow",
		fullName: "Barlow Black",
		postScriptName: "Barlow-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1Sepcvw5_4CbmTcHRm3jzD3g.png",
		style: "Barlow-Black",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHqv4kjgoGqM7E3j-wc4FAtlT47dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tUmCQD3ODchZ0AVzNVJx5WUD",
		family: "Barlow",
		fullName: "Barlow Thin Italic",
		postScriptName: "Barlow-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_6uhs7nC6hcLk4jPZXdc8JBL.png",
		style: "Barlow-ThinItalic",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHtv4kjgoGqM7E_CfNYwHoDmTcibrA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Meh0F56fVUOtBHNvJ90P_sLh",
		family: "Barlow",
		fullName: "Barlow ExtraLight Italic",
		postScriptName: "Barlow-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Onz69jeGrb_jlnUZNaoin6z6.png",
		style: "Barlow-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHsv4kjgoGqM7E_CfP04Voptzsrd6m9.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__dpJxGYHm4x_SJIQTGDoQPDK",
		family: "Barlow",
		fullName: "Barlow Light Italic",
		postScriptName: "Barlow-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/yFDohVEteFqGjFoUSMkMDc56.png",
		style: "Barlow-LightItalic",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHsv4kjgoGqM7E_CfOQ4loptzsrd6m9.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_x50ZczWMd9n1XN73CmLC_SzH",
		family: "Barlow",
		fullName: "Barlow Regular",
		postScriptName: "Barlow-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9fBkN6K1MSoMbdrFW05KJTeK.png",
		style: "Barlow-Regular",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHpv4kjgoGqM7EPC8E46HsxnA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xXv_aXmpVcjddpNOATmluXOF",
		family: "Barlow",
		fullName: "Barlow Italic",
		postScriptName: "Barlow-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hvbTuuG05Y4w8EwFOp_4RlGk.png",
		style: "Barlow-Italic",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHrv4kjgoGqM7E_Ccs8yn4hnCci.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jiRtojYp_yYWJSwZdQyYBlZT",
		family: "Barlow",
		fullName: "Barlow Medium Italic",
		postScriptName: "Barlow-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9Di6SIXl7LLnvN9g09rt0n1b.png",
		style: "Barlow-MediumItalic",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHsv4kjgoGqM7E_CfPI41optzsrd6m9.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EGOl3PBjg1OoDtNQw5yC0JGr",
		family: "Barlow",
		fullName: "Barlow SemiBold Italic",
		postScriptName: "Barlow-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qjvLXak3pCCeDQpuWe9L6WSF.png",
		style: "Barlow-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHsv4kjgoGqM7E_CfPk5Foptzsrd6m9.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3g713yPhJWOqkxk6fq69IFmE",
		family: "Barlow",
		fullName: "Barlow Bold Italic",
		postScriptName: "Barlow-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/inolMH2MLH8FgJZcRShaT2OK.png",
		style: "Barlow-BoldItalic",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHsv4kjgoGqM7E_CfOA5Voptzsrd6m9.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vPzluNMPlDnezXqT54sR_MYf",
		family: "Barlow",
		fullName: "Barlow ExtraBold Italic",
		postScriptName: "Barlow-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Z0bPdTfUIuxRg0uR05PFHdwk.png",
		style: "Barlow-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHsv4kjgoGqM7E_CfOc5loptzsrd6m9.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_bDgTWXAAOEOS5AU5ArjWGV7H",
		family: "Barlow",
		fullName: "Barlow Black Italic",
		postScriptName: "Barlow-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/y0whcqLA_5AGpjdn8h_s97Du.png",
		style: "Barlow-BlackItalic",
		url: "https://fonts.gstatic.com/s/barlow/v5/7cHsv4kjgoGqM7E_CfO451optzsrd6m9.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4Mi9SLN1H_IzhkU6N9u4tJEQ",
		family: "Black And White Picture",
		fullName: "Black And White Picture Regular",
		postScriptName: "BlackAndWhitePicture-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HIBHykQbT3zo3s_LKWUupoKl.png",
		style: "BlackAndWhitePicture-Regular",
		url: "https://fonts.gstatic.com/s/blackandwhitepicture/v10/TwMe-JAERlQd3ooUHBUXGmrmioKjjnRSFO-NqI5HbcMi-yWY.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8WY5bk4jOoXkDtieqlfZV2Qg",
		family: "Fjalla One",
		fullName: "Fjalla One Regular",
		postScriptName: "FjallaOne-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/YKQqaJiYqslGFK4xfL4YKs56.png",
		style: "FjallaOne-Regular",
		url: "https://fonts.gstatic.com/s/fjallaone/v8/Yq6R-LCAWCX3-6Ky7FAFnOZwkxgtUb8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_CZNzaqEPS7ueEcL03EqbdAmr",
		family: "Flavors",
		fullName: "Flavors Regular",
		postScriptName: "Flavors-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zn00mEl_WtwZWrTposZoUiKk.png",
		style: "Flavors-Regular",
		url: "https://fonts.gstatic.com/s/flavors/v12/FBV2dDrhxqmveJTpbkzlNqkG9UY.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zTxfQo75JEqU65OixOKes5La",
		family: "Fredericka the Great",
		fullName: "Fredericka the Great Regular",
		postScriptName: "FrederickatheGreat-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gJkMBDvVmIhtlcWyxJ9EPC2c.png",
		style: "FrederickatheGreat-Regular",
		url: "https://fonts.gstatic.com/s/frederickathegreat/v10/9Bt33CxNwt7aOctW2xjbCstzwVKsIBVV-9Skz7Ylch2L.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UuUROxd7E08W3MafVUIykLs5",
		family: "Abel",
		fullName: "Abel Regular",
		postScriptName: "Abel-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/236FBOhs2x0uD3DITbYiGHcp.png",
		style: "Abel-Regular",
		url: "https://fonts.gstatic.com/s/abel/v12/MwQ5bhbm2POE6VhLPJp6qGI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_w0AgplBPxMF6X1r977tZLmmE",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Thin",
		postScriptName: "AlegreyaSans-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7SNRw1aG5dTFpQPLagUuNvEf.png",
		style: "AlegreyaSans-Thin",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUt9_-1phKLFgshYDvh6Vwt5TltuGdShm5bsg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HmYf_rHrtnENoAncWf7ngfJR",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Light",
		postScriptName: "AlegreyaSans-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BHtYe6h8gz2iaJqm90ZZs1KH.png",
		style: "AlegreyaSans-Light",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUu9_-1phKLFgshYDvh6Vwt5fFPmE18imdCqxI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cURbCjDCTaIef8cmvpa_9gBt",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Medium",
		postScriptName: "AlegreyaSans-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Zks7h21SLX87teB8fDunsmMT.png",
		style: "AlegreyaSans-Medium",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUu9_-1phKLFgshYDvh6Vwt5alOmE18imdCqxI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4RjgiVkl6CLR7KaKT6vdSPg8",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Bold",
		postScriptName: "AlegreyaSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6wkP4CvjDi01xoOSzOARay9y.png",
		style: "AlegreyaSans-Bold",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUu9_-1phKLFgshYDvh6Vwt5eFImE18imdCqxI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_g9kOBFCrqUCsOtrKB9jVx88_",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans ExtraBold",
		postScriptName: "AlegreyaSans-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jpqGivMNwKnA6F0DGmgmyDv4.png",
		style: "AlegreyaSans-ExtraBold",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUu9_-1phKLFgshYDvh6Vwt5f1LmE18imdCqxI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_G5aRKEBqZeeCA8EngUl3TztS",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Black",
		postScriptName: "AlegreyaSans-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/iXtAFUuCBb9oLbXua2hNwK8K.png",
		style: "AlegreyaSans-Black",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUu9_-1phKLFgshYDvh6Vwt5dlKmE18imdCqxI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pmK752xK5ZC97U578omXubjU",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Thin Italic",
		postScriptName: "AlegreyaSans-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lmgVXBaVnHuflc7gS9_Kahtc.png",
		style: "AlegreyaSans-ThinItalic",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUv9_-1phKLFgshYDvh6Vwt7V9V3G1WpGtLsgu7.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dzmU4qzwNcD7aLi5n068skmC",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Light Italic",
		postScriptName: "AlegreyaSans-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/H8wKQ_q7fd0EFZ6CefTuHF70.png",
		style: "AlegreyaSans-LightItalic",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUo9_-1phKLFgshYDvh6Vwt7V9VFE92jkVHuxKiBA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wEG6y3HMNAK6tl882kqodS3T",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Regular",
		postScriptName: "AlegreyaSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LS3LbphCZVTgjj2JSkZoPe14.png",
		style: "AlegreyaSans-Regular",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUz9_-1phKLFgshYDvh6Vwt3V1nvEVXlm4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tPGqjQk_NQgHLH9G7S7R2iHZ",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Italic",
		postScriptName: "AlegreyaSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JL4MpACbtYcOjoosNnTaGHHd.png",
		style: "AlegreyaSans-Italic",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUt9_-1phKLFgshYDvh6Vwt7V9tuGdShm5bsg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9BPWfUpDh7gUwHZ9UCL2Rya8",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Medium Italic",
		postScriptName: "AlegreyaSans-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NGeRm0PRG3ZxnUw6bKUeLsvX.png",
		style: "AlegreyaSans-MediumItalic",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUo9_-1phKLFgshYDvh6Vwt7V9VTE52jkVHuxKiBA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fI3V_dKgPnyu0cZ37I5DpWJV",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Bold Italic",
		postScriptName: "AlegreyaSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RlG4FqpgxdbmKGVqytvyVBmp.png",
		style: "AlegreyaSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUo9_-1phKLFgshYDvh6Vwt7V9VBEh2jkVHuxKiBA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_e9ljFQtKRTN5nFk5fZKajt2z",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans ExtraBold Italic",
		postScriptName: "AlegreyaSans-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OQVra9S0hS0WQexhaupGtUUx.png",
		style: "AlegreyaSans-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUo9_-1phKLFgshYDvh6Vwt7V9VGEt2jkVHuxKiBA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_43XtS1t4ZCz15_1giTEZPOGo",
		family: "Alegreya Sans",
		fullName: "Alegreya Sans Black Italic",
		postScriptName: "AlegreyaSans-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MisEPCUM6X_kY1iBPN79GGUW.png",
		style: "AlegreyaSans-BlackItalic",
		url: "https://fonts.gstatic.com/s/alegreyasans/v14/5aUo9_-1phKLFgshYDvh6Vwt7V9VPEp2jkVHuxKiBA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lKqbQilAYEbbtHoqafI6Tmpu",
		family: "Acme",
		fullName: "Acme Regular",
		postScriptName: "Acme-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FHslAKR9DCmBGSrQjlCvmonl.png",
		style: "Acme-Regular",
		url: "https://fonts.gstatic.com/s/acme/v11/RrQfboBx-C5_bx3Lb23lzLk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8WT5E0zx7mBMc6PHzfJWa3jv",
		family: "Alfa Slab One",
		fullName: "Alfa Slab One Regular",
		postScriptName: "AlfaSlabOne-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8NkjYW15zORv5HR98nJNwpf_.png",
		style: "AlfaSlabOne-Regular",
		url: "https://fonts.gstatic.com/s/alfaslabone/v10/6NUQ8FmMKwSEKjnm5-4v-4Jh6dVretWvYmE.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_bMVevrcNq3sYk00rfRTw8ovW",
		family: "Amatic SC",
		fullName: "Amatic SC Bold",
		postScriptName: "AmaticSC-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4qGTRCMtaDFO7i3dirH_om7y.png",
		style: "AmaticSC-Bold",
		url: "https://fonts.gstatic.com/s/amaticsc/v16/TUZ3zwprpvBS1izr_vOMscG6eb8D3WTy-A.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_VwkAUZWqBHFPZs_G1IAo5UeN",
		family: "Amatic SC",
		fullName: "Amatic SC Regular",
		postScriptName: "AmaticSC-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JAHkYdxp5RE03VUtRaxGhe49.png",
		style: "AmaticSC-Regular",
		url: "https://fonts.gstatic.com/s/amaticsc/v16/TUZyzwprpvBS1izr_vO0De6ecZQf1A.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_98BVjzNa0WwIm_DtSY7O0qw5",
		family: "Arvo",
		fullName: "Arvo Bold",
		postScriptName: "Arvo-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/H0ZMQjaAOUVQbU6b5MrJ8Vl7.png",
		style: "Arvo-Bold",
		url: "https://fonts.gstatic.com/s/arvo/v14/tDbM2oWUg0MKoZw1yLTA8vL7lAE.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jmetXX5aaDpf5Ucp5aCy1VtG",
		family: "Arvo",
		fullName: "Arvo Regular",
		postScriptName: "Arvo",
		preview: "https://ik.imagekit.io/lh/fonts/v2/CPO_XpqtEzQ5O7uQ2RtZj1xU.png",
		style: "Arvo",
		url: "https://fonts.gstatic.com/s/arvo/v14/tDbD2oWUg0MKmSAa7Lzr7vs.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_RXIYtUJnwVJWHmQQXRZgCx01",
		family: "Arvo",
		fullName: "Arvo Italic",
		postScriptName: "Arvo-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4DCHS75Sl9n2pDeTeP9Ed8o8.png",
		style: "Arvo-Italic",
		url: "https://fonts.gstatic.com/s/arvo/v14/tDbN2oWUg0MKqSIQ6J7u_vvijQ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MtQ9I1SxOWHozX5YKb2Syolv",
		family: "Arvo",
		fullName: "Arvo Bold Italic",
		postScriptName: "Arvo-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Ga4y8Evh6B4HHos13uNnxMMa.png",
		style: "Arvo-BoldItalic",
		url: "https://fonts.gstatic.com/s/arvo/v14/tDbO2oWUg0MKqSIoVLHK9tD-hAHkGg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jkWVePR9KlcsTSQEm_JrVQqq",
		family: "Asap Condensed",
		fullName: "Asap Condensed Medium",
		postScriptName: "AsapCondensed-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZjO5lt_SQzQsxuD4mvMNcEy8.png",
		style: "AsapCondensed-Medium",
		url: "https://fonts.gstatic.com/s/asapcondensed/v8/pxieypY1o9NHyXh3WvSbGSggdO9_S2lEgGqgp-pO.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ezuqRI5Bj95Op8Mb_MN_mQLJ",
		family: "Asap Condensed",
		fullName: "Asap Condensed SemiBold",
		postScriptName: "AsapCondensed-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qlVl6SJCKcEHl2zHxFlbo7Mx.png",
		style: "AsapCondensed-SemiBold",
		url: "https://fonts.gstatic.com/s/asapcondensed/v8/pxieypY1o9NHyXh3WvSbGSggdO9TTGlEgGqgp-pO.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_paexFgbsC9z1xhj7KTpp6TrS",
		family: "Asap Condensed",
		fullName: "Asap Condensed Bold",
		postScriptName: "AsapCondensed-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aptTkzw1cG1jofCtEcbgH0jz.png",
		style: "AsapCondensed-Bold",
		url: "https://fonts.gstatic.com/s/asapcondensed/v8/pxieypY1o9NHyXh3WvSbGSggdO83TWlEgGqgp-pO.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SQk9RoH0OfDrdtHcEjlHe5dt",
		family: "Asap Condensed",
		fullName: "Asap Condensed Regular",
		postScriptName: "AsapCondensed-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Nq4zsWJ_q3W9vRTEqQ_xllnx.png",
		style: "AsapCondensed-Regular",
		url: "https://fonts.gstatic.com/s/asapcondensed/v8/pxidypY1o9NHyXh3WvSbGSggdNeLYk1Mq3ap.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KMViwXa3XqByaaJnPw8TUoTG",
		family: "Asap Condensed",
		fullName: "Asap Condensed Italic",
		postScriptName: "AsapCondensed-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/CrG_oNjszrgJfdqDI02d3DDd.png",
		style: "AsapCondensed-Italic",
		url: "https://fonts.gstatic.com/s/asapcondensed/v8/pxifypY1o9NHyXh3WvSbGSggdOeJaElurmapvvM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_i6ENW1AXxChaRK724QFDpsjZ",
		family: "Asap Condensed",
		fullName: "Asap Condensed Medium Italic",
		postScriptName: "AsapCondensed-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/s0ii1YUQ5NB7AT7qQLvqNPAA.png",
		style: "AsapCondensed-MediumItalic",
		url: "https://fonts.gstatic.com/s/asapcondensed/v8/pxiYypY1o9NHyXh3WvSbGSggdOeJUL1Him6CovpOkXA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_S9MC_JiqtcEvtgm9DBCqgRr4",
		family: "Asap Condensed",
		fullName: "Asap Condensed SemiBold Italic",
		postScriptName: "AsapCondensed-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hZ6IIKSKZya_SG7p0_qjjVzy.png",
		style: "AsapCondensed-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/asapcondensed/v8/pxiYypY1o9NHyXh3WvSbGSggdOeJUJFAim6CovpOkXA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_RG5hMvfxokPumYVERlZezNCa",
		family: "Asap Condensed",
		fullName: "Asap Condensed Bold Italic",
		postScriptName: "AsapCondensed-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gwDc01YdPtNQfAhRMr1Gy6J4.png",
		style: "AsapCondensed-BoldItalic",
		url: "https://fonts.gstatic.com/s/asapcondensed/v8/pxiYypY1o9NHyXh3WvSbGSggdOeJUPVBim6CovpOkXA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NWTiGSRRWPZlTSxmprJ3Ms94",
		family: "Caveat Brush",
		fullName: "Caveat Brush Regular",
		postScriptName: "CaveatBrush-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/odVamVqWVHKd41GgGmTTTjwo.png",
		style: "CaveatBrush-Regular",
		url: "https://fonts.gstatic.com/s/caveatbrush/v6/EYq0maZfwr9S9-ETZc3fKXtMW7mT03pdQw.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_eMXDlWZnhmhCu41ZY9zjAGjy",
		family: "Changa",
		fullName: "Changa ExtraLight",
		postScriptName: "Changa-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uYrwtisXLwHJvJS7X56ts8r0.png",
		style: "Changa-ExtraLight",
		url: "https://fonts.gstatic.com/s/changa/v14/2-c79JNi2YuVOUcOarRPgnNGooxCZy2xQjDp9htf1ZM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HOJzpSuwJvA5MoCnw_8yXMVq",
		family: "Changa",
		fullName: "Changa Light",
		postScriptName: "Changa-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zQuSa9Sl2yLhVRx2UunhRimm.png",
		style: "Changa-Light",
		url: "https://fonts.gstatic.com/s/changa/v14/2-c79JNi2YuVOUcOarRPgnNGooxCZ_OxQjDp9htf1ZM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_U1_HZEsKchu8XGUuJnE0cpH1",
		family: "Changa",
		fullName: "Changa Medium",
		postScriptName: "Changa-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vhDATVjHALUIqmN2S9p9mQN9.png",
		style: "Changa-Medium",
		url: "https://fonts.gstatic.com/s/changa/v14/2-c79JNi2YuVOUcOarRPgnNGooxCZ5-xQjDp9htf1ZM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZpSHdiMJ8argQTbtzImDivyd",
		family: "Changa",
		fullName: "Changa SemiBold",
		postScriptName: "Changa-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gtmIoCIfpygfxseL6Tt0zJbF.png",
		style: "Changa-SemiBold",
		url: "https://fonts.gstatic.com/s/changa/v14/2-c79JNi2YuVOUcOarRPgnNGooxCZ3O2QjDp9htf1ZM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xrPkizsoPrtv6rfyvkmMXsa8",
		family: "Changa",
		fullName: "Changa Bold",
		postScriptName: "Changa-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/XaFAlUc2MAJudaybQpt5ceju.png",
		style: "Changa-Bold",
		url: "https://fonts.gstatic.com/s/changa/v14/2-c79JNi2YuVOUcOarRPgnNGooxCZ0q2QjDp9htf1ZM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YUMrMdkFVmCJWduClMOCFDgJ",
		family: "Changa",
		fullName: "Changa ExtraBold",
		postScriptName: "Changa-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8Hb3_u6tippJeXhd8etlBQ09.png",
		style: "Changa-ExtraBold",
		url: "https://fonts.gstatic.com/s/changa/v14/2-c79JNi2YuVOUcOarRPgnNGooxCZy22QjDp9htf1ZM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3DfCyEEe1H5LcEUCGYge6mge",
		family: "Changa",
		fullName: "Changa Regular",
		postScriptName: "Changa-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wNy5i_5t33XK_fNRgIMc_Kv0.png",
		style: "Changa-Regular",
		url: "https://fonts.gstatic.com/s/changa/v14/2-c79JNi2YuVOUcOarRPgnNGooxCZ62xQjDp9htf1ZM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Rfklein7lkkJEXpt7vQIMcBa",
		family: "Changa One",
		fullName: "Changa One Regular",
		postScriptName: "ChangaOne",
		preview: "https://ik.imagekit.io/lh/fonts/v2/cxpBp_IyPtiYHCb6QB9NgcmP.png",
		style: "ChangaOne",
		url: "https://fonts.gstatic.com/s/changaone/v13/xfu00W3wXn3QLUJXhzq46AbouLfbK64.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qyx6YMayzlgcxpOAAO9Jnero",
		family: "Changa One",
		fullName: "Changa One Italic",
		postScriptName: "ChangaOne-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_xTulLo5gMuwfMAwLY36jYRf.png",
		style: "ChangaOne-Italic",
		url: "https://fonts.gstatic.com/s/changaone/v13/xfu20W3wXn3QLUJXhzq42ATivJXeO67ISw.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_yJccdPlEdAK1PQJRskgJ4wNq",
		family: "Cinzel",
		fullName: "Cinzel Medium",
		postScriptName: "Cinzel-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AG9pci9b4gbVHruXsIavvtvh.png",
		style: "Cinzel-Medium",
		url: "https://fonts.gstatic.com/s/cinzel/v11/8vIU7ww63mVu7gtR-kwKxNvkNOjw-uTnTYrvDE5ZdqU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zpoPBWXEkQ34ffEFDe_Hf5W0",
		family: "Cinzel",
		fullName: "Cinzel SemiBold",
		postScriptName: "Cinzel-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4SnkgnJBk7IreDAFBKwbJdzR.png",
		style: "Cinzel-SemiBold",
		url: "https://fonts.gstatic.com/s/cinzel/v11/8vIU7ww63mVu7gtR-kwKxNvkNOjw-gjgTYrvDE5ZdqU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vvhKY412Mwk0XZGw2W5p8yIQ",
		family: "Cinzel",
		fullName: "Cinzel Bold",
		postScriptName: "Cinzel-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hdBPeNZxXOqoXba3jYMuARPd.png",
		style: "Cinzel-Bold",
		url: "https://fonts.gstatic.com/s/cinzel/v11/8vIU7ww63mVu7gtR-kwKxNvkNOjw-jHgTYrvDE5ZdqU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ul0rXdvCvqvLz2TyNNne5knd",
		family: "Cinzel",
		fullName: "Cinzel ExtraBold",
		postScriptName: "Cinzel-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/b8z8ri2YhEyISU0amEuBzUBv.png",
		style: "Cinzel-ExtraBold",
		url: "https://fonts.gstatic.com/s/cinzel/v11/8vIU7ww63mVu7gtR-kwKxNvkNOjw-lbgTYrvDE5ZdqU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7Buyek63Ccf59I9NzgY3Zp0a",
		family: "Cinzel",
		fullName: "Cinzel Black",
		postScriptName: "Cinzel-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JntfZkpRFIRenvMEBswtdq2K.png",
		style: "Cinzel-Black",
		url: "https://fonts.gstatic.com/s/cinzel/v11/8vIU7ww63mVu7gtR-kwKxNvkNOjw-n_gTYrvDE5ZdqU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_XMpSMwO20hmTCrATQzPXE85O",
		family: "Cinzel",
		fullName: "Cinzel Regular",
		postScriptName: "Cinzel-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KMn_ugYS2bNqSWCUistMzFYU.png",
		style: "Cinzel-Regular",
		url: "https://fonts.gstatic.com/s/cinzel/v11/8vIU7ww63mVu7gtR-kwKxNvkNOjw-tbnTYrvDE5ZdqU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_rvpr4ZgmxkFWozhOEpKlmW0C",
		family: "Comic Neue",
		fullName: "Comic Neue Light",
		postScriptName: "ComicNeue-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RgToOWRw1UyIrAWSO4_upKDH.png",
		style: "ComicNeue-Light",
		url: "https://fonts.gstatic.com/s/comicneue/v3/4UaErEJDsxBrF37olUeD_wHLwpteLwtHJlc.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__F8sxHA58WAhTAagXjb7G3MR",
		family: "Comic Neue",
		fullName: "Comic Neue Bold",
		postScriptName: "ComicNeue-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Z_NndVUL1Vbl4aKSpPr0sjxA.png",
		style: "ComicNeue-Bold",
		url: "https://fonts.gstatic.com/s/comicneue/v3/4UaErEJDsxBrF37olUeD_xHMwpteLwtHJlc.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IirP0f0zVrcweBQ2xkC37PvG",
		family: "Comic Neue",
		fullName: "Comic Neue Light Italic",
		postScriptName: "ComicNeue-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vMTj4yYg5FBI5hkHvE1duQbS.png",
		style: "ComicNeue-LightItalic",
		url: "https://fonts.gstatic.com/s/comicneue/v3/4UaarEJDsxBrF37olUeD96_RTplUKylCNlcw_Q.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KTtSbgIbpsQDBWSwqOQ9E1va",
		family: "Comic Neue",
		fullName: "Comic Neue Regular",
		postScriptName: "ComicNeue-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zj0_SXzkEs81_MztxLmLb9VN.png",
		style: "ComicNeue-Regular",
		url: "https://fonts.gstatic.com/s/comicneue/v3/4UaHrEJDsxBrF37olUeDx63j5pN1MwI.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6H2J2ojQl_PlHZ8dGgtBq2v7",
		family: "Comic Neue",
		fullName: "Comic Neue Italic",
		postScriptName: "ComicNeue-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/yWoFyeHuYhJtyIGXI6CgTPit.png",
		style: "ComicNeue-Italic",
		url: "https://fonts.gstatic.com/s/comicneue/v3/4UaFrEJDsxBrF37olUeD96_p4rFwIwJePw.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_BTBVa3xv8I8PfdV0tNIn4Coy",
		family: "Comic Neue",
		fullName: "Comic Neue Bold Italic",
		postScriptName: "ComicNeue-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3TMVbhY3t0TAWO47pspDqLas.png",
		style: "ComicNeue-BoldItalic",
		url: "https://fonts.gstatic.com/s/comicneue/v3/4UaarEJDsxBrF37olUeD96_RXp5UKylCNlcw_Q.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Qne73hrU_KwtNOLazH37OPCo",
		family: "Encode Sans Expanded",
		fullName: "Encode Sans Expanded Thin",
		postScriptName: "EncodeSansExpanded-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OA9oLqSioPsZrQJI62OcQLd0.png",
		style: "EncodeSansExpanded-Thin",
		url: "https://fonts.gstatic.com/s/encodesansexpanded/v5/c4mx1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpJGKQNicoAbJlw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EIR5Tv8plbcCUHeZmxXG2irs",
		family: "Encode Sans Expanded",
		fullName: "Encode Sans Expanded ExtraLight",
		postScriptName: "EncodeSansExpanded-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4Dzzmlo7WN2wgsE5FZjKraQ9.png",
		style: "EncodeSansExpanded-ExtraLight",
		url: "https://fonts.gstatic.com/s/encodesansexpanded/v5/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpLqCCNIXIwSP0XD.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xtiYr320NH6aHH4sLvubd1Rn",
		family: "Encode Sans Expanded",
		fullName: "Encode Sans Expanded Light",
		postScriptName: "EncodeSansExpanded-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8LzRQu7J__pgxAiT39eUBi9l.png",
		style: "EncodeSansExpanded-Light",
		url: "https://fonts.gstatic.com/s/encodesansexpanded/v5/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKOCyNIXIwSP0XD.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8UCZ3bYViPnCMQ7OVbQ1H3Pw",
		family: "Encode Sans Expanded",
		fullName: "Encode Sans Expanded Medium",
		postScriptName: "EncodeSansExpanded-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/oAME56GIbetob3xat2PGheFB.png",
		style: "EncodeSansExpanded-Medium",
		url: "https://fonts.gstatic.com/s/encodesansexpanded/v5/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpLWCiNIXIwSP0XD.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_iB2TiAeXnisvN8PNfI1qxOW2",
		family: "Encode Sans Expanded",
		fullName: "Encode Sans Expanded SemiBold",
		postScriptName: "EncodeSansExpanded-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/olwpSbfgbjE5xCwlpQUQo7_0.png",
		style: "EncodeSansExpanded-SemiBold",
		url: "https://fonts.gstatic.com/s/encodesansexpanded/v5/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpL6DSNIXIwSP0XD.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8u5aSw5vTp8kfj0zU9WYZruH",
		family: "Encode Sans Expanded",
		fullName: "Encode Sans Expanded Bold",
		postScriptName: "EncodeSansExpanded-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uZlkGE35SYb5sYThnyoHGXtL.png",
		style: "EncodeSansExpanded-Bold",
		url: "https://fonts.gstatic.com/s/encodesansexpanded/v5/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKeDCNIXIwSP0XD.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WNMau2Pu5qWmsZd7W2THVdpJ",
		family: "Encode Sans Expanded",
		fullName: "Encode Sans Expanded ExtraBold",
		postScriptName: "EncodeSansExpanded-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nmWyP6l6QIeKiGmeMwgKCGe5.png",
		style: "EncodeSansExpanded-ExtraBold",
		url: "https://fonts.gstatic.com/s/encodesansexpanded/v5/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKCDyNIXIwSP0XD.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lBEmt0ALqAyc17j7xCnKFmZ2",
		family: "Encode Sans Expanded",
		fullName: "Encode Sans Expanded Black",
		postScriptName: "EncodeSansExpanded-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/iI2dVLKL7A4lRhOMH1I8URnv.png",
		style: "EncodeSansExpanded-Black",
		url: "https://fonts.gstatic.com/s/encodesansexpanded/v5/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKmDiNIXIwSP0XD.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_S4yHikbfw43Vg6KNtnOJ13nz",
		family: "Encode Sans Expanded",
		fullName: "Encode Sans Expanded Regular",
		postScriptName: "EncodeSansExpanded-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KUDIJSBRbR1IIc753JrT_q2J.png",
		style: "EncodeSansExpanded-Regular",
		url: "https://fonts.gstatic.com/s/encodesansexpanded/v5/c4m_1mF4GcnstG_Jh1QH6ac4hNLeNyeYUqoiIwdAd5Ab.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TTDtT9y9nWWuvIae_kZ4q0NT",
		family: "Exo 2",
		fullName: "Exo 2 Thin",
		postScriptName: "Exo2-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uvkMAYpFZ2oFm3g14WswE4Tu.png",
		style: "Exo2-Thin",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH1v4okm5zmbvwkAx_sfcEuiD8jvvOcPtq-rpvLpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_a3ouZz6mdL51vg5tHTmY9X21",
		family: "Exo 2",
		fullName: "Exo 2 ExtraLight",
		postScriptName: "Exo2-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fUIb7tCoNQiUxeRcPlNBsvtZ.png",
		style: "Exo2-ExtraLight",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH1v4okm5zmbvwkAx_sfcEuiD8jPvKcPtq-rpvLpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jjcIRFqlLHcdcB37kafrTvZn",
		family: "Exo 2",
		fullName: "Exo 2 Light",
		postScriptName: "Exo2-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NymXp0beCS7EYB5CehFXSYOm.png",
		style: "Exo2-Light",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH1v4okm5zmbvwkAx_sfcEuiD8j4PKcPtq-rpvLpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MYuCCr6SWM_ICYhRiPvwxAsp",
		family: "Exo 2",
		fullName: "Exo 2 Medium",
		postScriptName: "Exo2-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/D0Lx1IKSkzV3x7UIKoRKkUfQ.png",
		style: "Exo2-Medium",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH1v4okm5zmbvwkAx_sfcEuiD8jjPKcPtq-rpvLpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gpNf_kAO4oPZjG6PJ5e8qpi0",
		family: "Exo 2",
		fullName: "Exo 2 SemiBold",
		postScriptName: "Exo2-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MHOJzTriVIgUY5Wt0EdRDKnP.png",
		style: "Exo2-SemiBold",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH1v4okm5zmbvwkAx_sfcEuiD8jYPWcPtq-rpvLpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4GfZocREhtSyCjLUpDs9qsk3",
		family: "Exo 2",
		fullName: "Exo 2 Bold",
		postScriptName: "Exo2-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8g2Ct_QYyipPNXqBoLHud3lc.png",
		style: "Exo2-Bold",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH1v4okm5zmbvwkAx_sfcEuiD8jWfWcPtq-rpvLpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_68rERwFuLQveTsddMz5sGUAi",
		family: "Exo 2",
		fullName: "Exo 2 ExtraBold",
		postScriptName: "Exo2-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3E4BOpBl7qP1GrTvT9hNoi3Y.png",
		style: "Exo2-ExtraBold",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH1v4okm5zmbvwkAx_sfcEuiD8jPvWcPtq-rpvLpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Riol_eeVUY4fZhRrVvsYczGh",
		family: "Exo 2",
		fullName: "Exo 2 Black",
		postScriptName: "Exo2-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/yyfZc_RQ5MIBzZJ2z2tXBhP5.png",
		style: "Exo2-Black",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH1v4okm5zmbvwkAx_sfcEuiD8jF_WcPtq-rpvLpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Un1UzFE1OaeeoFgJRMzWcsTk",
		family: "Exo 2",
		fullName: "Exo 2 Regular",
		postScriptName: "Exo2-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kwOS6SN7OqXyDYL0GFh6w1cp.png",
		style: "Exo2-Regular",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH1v4okm5zmbvwkAx_sfcEuiD8jvvKcPtq-rpvLpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Db95EJAvJazdczXhCXysO1gF",
		family: "Exo 2",
		fullName: "Exo 2 Thin Italic",
		postScriptName: "Exo2-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BN7ouO9d03cAY_wuzVXAJZhD.png",
		style: "Exo2-ThinItalic",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drF0fNC6jJ7bpQBL.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_iAyLfFzal2ftzfbVFyre0rQt",
		family: "Exo 2",
		fullName: "Exo 2 ExtraLight Italic",
		postScriptName: "Exo2-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Duk9pClMmWIHnOcDoFhJAsCt.png",
		style: "Exo2-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drH0fdC6jJ7bpQBL.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_poMcTGwxDmbxBh5SFqPAhzNo",
		family: "Exo 2",
		fullName: "Exo 2 Light Italic",
		postScriptName: "Exo2-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jvTNYwoR3hyLkeOwWIhx0sJP.png",
		style: "Exo2-LightItalic",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drEqfdC6jJ7bpQBL.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_bLV4kL0JODIIZZ4DKWcrQdoT",
		family: "Exo 2",
		fullName: "Exo 2 Italic",
		postScriptName: "Exo2-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/sTPAqT_E6l3m6K1ZurnoFCze.png",
		style: "Exo2-Italic",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drF0fdC6jJ7bpQBL.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zvhyg7AFFtTQ9R4WFFxitsRU",
		family: "Exo 2",
		fullName: "Exo 2 Medium Italic",
		postScriptName: "Exo2-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/k0PFeYT1LUbgkN5erfCNg6Gq.png",
		style: "Exo2-MediumItalic",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drFGfdC6jJ7bpQBL.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hxlLpX322s8K1ZucJ2lfT9qn",
		family: "Exo 2",
		fullName: "Exo 2 SemiBold Italic",
		postScriptName: "Exo2-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gL6eJuckl2oafOLRY7TrySM5.png",
		style: "Exo2-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drGqetC6jJ7bpQBL.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__u_7XBi3uQofXiyUcB5ZgCbE",
		family: "Exo 2",
		fullName: "Exo 2 Bold Italic",
		postScriptName: "Exo2-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kJsqqcHulrCtOtKGj9Q9zVYQ.png",
		style: "Exo2-BoldItalic",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drGTetC6jJ7bpQBL.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8uJR86RRbzBznf2MAdb_wEEJ",
		family: "Exo 2",
		fullName: "Exo 2 ExtraBold Italic",
		postScriptName: "Exo2-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/i8_Yls39Q8JVaHgYxosNcrUl.png",
		style: "Exo2-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drH0etC6jJ7bpQBL.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__Hlxe1S6RepoQOCn7Vz3dWfu",
		family: "Exo 2",
		fullName: "Exo 2 Black Italic",
		postScriptName: "Exo2-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/m7QlU7N50tTThY0IAKI36nwS.png",
		style: "Exo2-BlackItalic",
		url: "https://fonts.gstatic.com/s/exo2/v15/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drHdetC6jJ7bpQBL.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6y8AUn3kzEGrowJjMr0RtzOO",
		family: "Gloria Hallelujah",
		fullName: "Gloria Hallelujah Regular",
		postScriptName: "GloriaHallelujah",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hwxePNJ6RkV5jn2X487DZ9gX.png",
		style: "GloriaHallelujah",
		url: "https://fonts.gstatic.com/s/gloriahallelujah/v12/LYjYdHv3kUk9BMV96EIswT9DIbW-MLSy3TKEvkCF.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_skLGQQIJKXQ0sgR3Z0IQNaOv",
		family: "Archivo Black",
		fullName: "Archivo Black Regular",
		postScriptName: "ArchivoBlack-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/PdABZpmZIE4BlLifU3IUiDjh.png",
		style: "ArchivoBlack-Regular",
		url: "https://fonts.gstatic.com/s/archivoblack/v10/HTxqL289NzCGg4MzN6KJ7eW6OYuP_x7yx3A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ir7Hh1C5Gthmy96i45SVf498",
		family: "Arimo",
		fullName: "Arimo Medium",
		postScriptName: "Arimo-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JeQQ6rEoKxaqG72IyDF6PKi2.png",
		style: "Arimo-Medium",
		url: "https://fonts.gstatic.com/s/arimo/v17/P5sfzZCDf9_T_3cV7NCUECyoxNk338xsBxDAVQI4aA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_eKztF79PlX0CjOotWyPDoIwq",
		family: "Arimo",
		fullName: "Arimo SemiBold",
		postScriptName: "Arimo-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mjB0JnCkgQN8rYCI0it0LcP2.png",
		style: "Arimo-SemiBold",
		url: "https://fonts.gstatic.com/s/arimo/v17/P5sfzZCDf9_T_3cV7NCUECyoxNk3M8tsBxDAVQI4aA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jOGUrrNKgAo8l3e6CU887wUc",
		family: "Arimo",
		fullName: "Arimo Bold",
		postScriptName: "Arimo-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hb1csMpTS8xo6fANT3TWlu58.png",
		style: "Arimo-Bold",
		url: "https://fonts.gstatic.com/s/arimo/v17/P5sfzZCDf9_T_3cV7NCUECyoxNk3CstsBxDAVQI4aA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YvJhujiYYcLgMSos2oi9i00H",
		family: "Arimo",
		fullName: "Arimo Regular",
		postScriptName: "Arimo-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/XaMR0UmLb0A93vFQewFYHvLt.png",
		style: "Arimo-Regular",
		url: "https://fonts.gstatic.com/s/arimo/v17/P5sfzZCDf9_T_3cV7NCUECyoxNk37cxsBxDAVQI4aA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__jFLmpty4Up1qiJflT4z1Svd",
		family: "Arimo",
		fullName: "Arimo Italic",
		postScriptName: "Arimo-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kWLs6Yp2EVe3ZoQFX78eJRDe.png",
		style: "Arimo-Italic",
		url: "https://fonts.gstatic.com/s/arimo/v17/P5sdzZCDf9_T_10c3i9MeUcyat4iJY-ERBrEdwcoaKww.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KjvinhoBjh2ZDcKntKhVr8qw",
		family: "Arimo",
		fullName: "Arimo Medium Italic",
		postScriptName: "Arimo-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SsUXPaYmlJV6ME71r4YYcvFT.png",
		style: "Arimo-MediumItalic",
		url: "https://fonts.gstatic.com/s/arimo/v17/P5sdzZCDf9_T_10c3i9MeUcyat4iJY-2RBrEdwcoaKww.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_rZKn_FcBPS6ZRdap3R2_ranN",
		family: "Arimo",
		fullName: "Arimo SemiBold Italic",
		postScriptName: "Arimo-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Q0ttDo4tEpAbT7hrNpE1VoYm.png",
		style: "Arimo-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/arimo/v17/P5sdzZCDf9_T_10c3i9MeUcyat4iJY9aQxrEdwcoaKww.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gejCy8hClcpQgiDvMzpkUcTd",
		family: "Arimo",
		fullName: "Arimo Bold Italic",
		postScriptName: "Arimo-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/XewoiYcyeDK1y8cjLRrmivAf.png",
		style: "Arimo-BoldItalic",
		url: "https://fonts.gstatic.com/s/arimo/v17/P5sdzZCDf9_T_10c3i9MeUcyat4iJY9jQxrEdwcoaKww.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_i5oSrjXnxDQtzjsz55HPM9vL",
		family: "Asap",
		fullName: "Asap Medium",
		postScriptName: "Asap-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/xBriLX_RNnAVXqv2bjPMxVJZ.png",
		style: "Asap-Medium",
		url: "https://fonts.gstatic.com/s/asap/v15/KFO9CniXp96a4Tc2EZzSuDAoKsEI1qhOUX-8AEEe.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gGe7zC7CpXxrgTH60wzVQb03",
		family: "Asap",
		fullName: "Asap SemiBold",
		postScriptName: "Asap-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/S5elwLIjSlxty0uIbfpC1dlh.png",
		style: "Asap-SemiBold",
		url: "https://fonts.gstatic.com/s/asap/v15/KFO9CniXp96a4Tc2EZzSuDAoKsHk0ahOUX-8AEEe.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Mejwz0q7xjlFJgoYk4g5Nswx",
		family: "Asap",
		fullName: "Asap Bold",
		postScriptName: "Asap-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FqnqoHanIaoVsJTQ5ZREDmqe.png",
		style: "Asap-Bold",
		url: "https://fonts.gstatic.com/s/asap/v15/KFO9CniXp96a4Tc2EZzSuDAoKsHd0ahOUX-8AEEe.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_A7Rr0By1QvthT0MZS7_BY2tC",
		family: "Asap",
		fullName: "Asap Regular",
		postScriptName: "Asap-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FNFB0ykN8Mf3Z9QRRTD26xcU.png",
		style: "Asap-Regular",
		url: "https://fonts.gstatic.com/s/asap/v15/KFO9CniXp96a4Tc2EZzSuDAoKsE61qhOUX-8AEEe.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HozxwvSlANuLSGMbovxtSXNY",
		family: "Asap",
		fullName: "Asap Italic",
		postScriptName: "Asap-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/UWt2rzVnPeGV4OdwO5DUri3W.png",
		style: "Asap-Italic",
		url: "https://fonts.gstatic.com/s/asap/v15/KFO7CniXp96ayz4E7kS706qGLdTylUANW3ueBVEeezU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FT7PacGtlWOw4Lp86VaJQcJx",
		family: "Asap",
		fullName: "Asap Medium Italic",
		postScriptName: "Asap-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/xxBjfKXD2N7YSMVlJn1JuHlQ.png",
		style: "Asap-MediumItalic",
		url: "https://fonts.gstatic.com/s/asap/v15/KFO7CniXp96ayz4E7kS706qGLdTylXINW3ueBVEeezU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_23P0hUuLn_HAlh4sp7XiMOAW",
		family: "Asap",
		fullName: "Asap SemiBold Italic",
		postScriptName: "Asap-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jViCZJXM5nSqd0kSNMMOD7Mx.png",
		style: "Asap-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/asap/v15/KFO7CniXp96ayz4E7kS706qGLdTylZ4KW3ueBVEeezU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TG3DQYLTb9ncfCQsVTU6WNhU",
		family: "Asap",
		fullName: "Asap Bold Italic",
		postScriptName: "Asap-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6WX3MfMiYIn1Ih_Ye8yECDkL.png",
		style: "Asap-BoldItalic",
		url: "https://fonts.gstatic.com/s/asap/v15/KFO7CniXp96ayz4E7kS706qGLdTylacKW3ueBVEeezU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HGAh2B6jgrxFZXPYbORUdgSF",
		family: "Biryani",
		fullName: "Biryani ExtraLight",
		postScriptName: "Biryani-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ldUOR55qWYVxHaVCFGbGNyil.png",
		style: "Biryani-ExtraLight",
		url: "https://fonts.gstatic.com/s/biryani/v6/hv-TlzNxIFoO84YddYQyGTBSU-J-RxQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_aVHljq1EQL88FlV9L6sE_p_9",
		family: "Biryani",
		fullName: "Biryani Light",
		postScriptName: "Biryani-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/PSPPdwV4Rp6aa74oLs2nIOnj.png",
		style: "Biryani-Light",
		url: "https://fonts.gstatic.com/s/biryani/v6/hv-TlzNxIFoO84YddeAxGTBSU-J-RxQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_oPuaFjgscXsHlvJ4aFCfPXGw",
		family: "Biryani",
		fullName: "Biryani SemiBold",
		postScriptName: "Biryani-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tWKEVVc9rdvg4soBQz6tZCPY.png",
		style: "Biryani-SemiBold",
		url: "https://fonts.gstatic.com/s/biryani/v6/hv-TlzNxIFoO84YddZQ3GTBSU-J-RxQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cqFfcCAIbXpK42jU0BGLwmS_",
		family: "Biryani",
		fullName: "Biryani Bold",
		postScriptName: "Biryani-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Icz9k2eTQq8TYuhYJE2p2ytW.png",
		style: "Biryani-Bold",
		url: "https://fonts.gstatic.com/s/biryani/v6/hv-TlzNxIFoO84YddfA2GTBSU-J-RxQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hvfhHVRCjlPSFB9dCCckOtWr",
		family: "Biryani",
		fullName: "Biryani ExtraBold",
		postScriptName: "Biryani-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/y5hnx0aE42Oo37fl97iFOk0A.png",
		style: "Biryani-ExtraBold",
		url: "https://fonts.gstatic.com/s/biryani/v6/hv-TlzNxIFoO84Yddew1GTBSU-J-RxQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YdGsBiEsqiZvSfYrfYIT4NnG",
		family: "Biryani",
		fullName: "Biryani Black",
		postScriptName: "Biryani-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/x7bPon6MTYeN5LX36L6cxWl5.png",
		style: "Biryani-Black",
		url: "https://fonts.gstatic.com/s/biryani/v6/hv-TlzNxIFoO84Yddcg0GTBSU-J-RxQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_304rgZ96myyeDrrEaL85DFPX",
		family: "Biryani",
		fullName: "Biryani Regular",
		postScriptName: "Biryani-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/yMwtU1FbmuAqzJnsDzVZixMl.png",
		style: "Biryani-Regular",
		url: "https://fonts.gstatic.com/s/biryani/v6/hv-WlzNxIFoO84YdTUwZPTh5T-s.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_bml6akFpnKzfzYum8Ozh0h5Y",
		family: "Cairo",
		fullName: "Cairo ExtraLight",
		postScriptName: "Cairo-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/eslrYtcKfJXQTSPzMRQnNb7B.png",
		style: "Cairo-ExtraLight",
		url: "https://fonts.gstatic.com/s/cairo/v14/SLXVc1nY6HkvangtZmpcWmhzfH5l2WgsQSaT0J0vRQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IWXDWFOsDR8ruO2aEZl7vc34",
		family: "Cairo",
		fullName: "Cairo Light",
		postScriptName: "Cairo-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/M6TMK_lwnSc1LHpJpwFHrAK3.png",
		style: "Cairo-Light",
		url: "https://fonts.gstatic.com/s/cairo/v14/SLXVc1nY6HkvangtZmpcWmhzfH5lB2gsQSaT0J0vRQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8_uPaTJ5ACsk7nf7DaQlo3uh",
		family: "Cairo",
		fullName: "Cairo Medium",
		postScriptName: "Cairo-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LCOCnmiQqaOcq5y0eErIYiMJ.png",
		style: "Cairo-Medium",
		url: "https://fonts.gstatic.com/s/cairo/v14/SLXVc1nY6HkvangtZmpcWmhzfH5la2gsQSaT0J0vRQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FS7qsmoa81Gv_tl1JHpktuKV",
		family: "Cairo",
		fullName: "Cairo SemiBold",
		postScriptName: "Cairo-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/O8QFiTVPvZaRyh12NUW1HmGS.png",
		style: "Cairo-SemiBold",
		url: "https://fonts.gstatic.com/s/cairo/v14/SLXVc1nY6HkvangtZmpcWmhzfH5lh28sQSaT0J0vRQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cJBu0TepwXu6BNX0XOqSghpX",
		family: "Cairo",
		fullName: "Cairo Bold",
		postScriptName: "Cairo-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Gm6tiYFosp6CvkrY8EmiLUCP.png",
		style: "Cairo-Bold",
		url: "https://fonts.gstatic.com/s/cairo/v14/SLXVc1nY6HkvangtZmpcWmhzfH5lvm8sQSaT0J0vRQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_LpEnUrtS6ZxHIyNGZVCm8ncn",
		family: "Cairo",
		fullName: "Cairo ExtraBold",
		postScriptName: "Cairo-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ShOzwQQs4NtfWzafnC0o9eLe.png",
		style: "Cairo-ExtraBold",
		url: "https://fonts.gstatic.com/s/cairo/v14/SLXVc1nY6HkvangtZmpcWmhzfH5l2W8sQSaT0J0vRQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9QZvy4AaK_R7g3b4CDxnVa4M",
		family: "Cairo",
		fullName: "Cairo Black",
		postScriptName: "Cairo-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZC9pwH49J4_zbYxrXOJGeaKT.png",
		style: "Cairo-Black",
		url: "https://fonts.gstatic.com/s/cairo/v14/SLXVc1nY6HkvangtZmpcWmhzfH5l8G8sQSaT0J0vRQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_K5wF4nhRCw8kELjD4HwsBzHI",
		family: "Cairo",
		fullName: "Cairo Regular",
		postScriptName: "Cairo-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/A8yNc7zW0nrWEc0ddVUdsGg1.png",
		style: "Cairo-Regular",
		url: "https://fonts.gstatic.com/s/cairo/v14/SLXVc1nY6HkvangtZmpcWmhzfH5lWWgsQSaT0J0vRQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tK5TXluPgTiEeqRvz_VpKfAr",
		family: "Damion",
		fullName: "Damion Regular",
		postScriptName: "Damion",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qX8drRBUkVZeq8bx1rEyMKWs.png",
		style: "Damion",
		url: "https://fonts.gstatic.com/s/damion/v10/hv-XlzJ3KEUe_YZUbWY3MTFgVg.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__pGUsW6BBDLeG5iFZA_j4hvF",
		family: "Exo",
		fullName: "Exo Thin",
		postScriptName: "Exo-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/QTKwau5QBz2Wa9unOYJijVTJ.png",
		style: "Exo-Thin",
		url: "https://fonts.gstatic.com/s/exo/v15/4UaZrEtFpBI4f1ZSIK9d4LjJ4lM2CwNsOl4p5Is.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qsbmQiCkUQ0HB7kkyNkyH95Q",
		family: "Exo",
		fullName: "Exo ExtraLight",
		postScriptName: "Exo-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6cvT36DFYOjEo2gLWHNbmOFS.png",
		style: "Exo-ExtraLight",
		url: "https://fonts.gstatic.com/s/exo/v15/4UaZrEtFpBI4f1ZSIK9d4LjJ4tM3CwNsOl4p5Is.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qbtGbBqB7Vy9rA1R8LfGsnaV",
		family: "Exo",
		fullName: "Exo Light",
		postScriptName: "Exo-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/xiT7aF79PAA_xEqg05ApFqHi.png",
		style: "Exo-Light",
		url: "https://fonts.gstatic.com/s/exo/v15/4UaZrEtFpBI4f1ZSIK9d4LjJ4g03CwNsOl4p5Is.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8RLeKvAUqadgnzaKI8ixarAx",
		family: "Exo",
		fullName: "Exo Medium",
		postScriptName: "Exo-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/swJaFcVgUT8aWHH8rwJI9sMb.png",
		style: "Exo-Medium",
		url: "https://fonts.gstatic.com/s/exo/v15/4UaZrEtFpBI4f1ZSIK9d4LjJ4mE3CwNsOl4p5Is.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qO39dwIhpuirbLc3ltDBU1I2",
		family: "Exo",
		fullName: "Exo SemiBold",
		postScriptName: "Exo-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RxD6DsWiJC9J9kcTh1GNCLbw.png",
		style: "Exo-SemiBold",
		url: "https://fonts.gstatic.com/s/exo/v15/4UaZrEtFpBI4f1ZSIK9d4LjJ4o0wCwNsOl4p5Is.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Yn_rlef75KBO58wvBBW8wfFp",
		family: "Exo",
		fullName: "Exo Bold",
		postScriptName: "Exo-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5fzXRl3H3nFLnGcc4VkPmxuF.png",
		style: "Exo-Bold",
		url: "https://fonts.gstatic.com/s/exo/v15/4UaZrEtFpBI4f1ZSIK9d4LjJ4rQwCwNsOl4p5Is.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WZq2qNwkEF0t9NCMZ_QExIpR",
		family: "Exo",
		fullName: "Exo ExtraBold",
		postScriptName: "Exo-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Wy79HMefEfFt1x0xGqqt3aeJ.png",
		style: "Exo-ExtraBold",
		url: "https://fonts.gstatic.com/s/exo/v15/4UaZrEtFpBI4f1ZSIK9d4LjJ4tMwCwNsOl4p5Is.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_eSJuPeERPMjssU7ZoRrp1Ois",
		family: "Exo",
		fullName: "Exo Black",
		postScriptName: "Exo-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/A5GeBJ3F78b6GzpMIdYPZPN9.png",
		style: "Exo-Black",
		url: "https://fonts.gstatic.com/s/exo/v15/4UaZrEtFpBI4f1ZSIK9d4LjJ4vowCwNsOl4p5Is.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dTuTGuECbqnTG41gSNgCiAnO",
		family: "Exo",
		fullName: "Exo Regular",
		postScriptName: "Exo-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Ap9H5EH3TyouE_b1kmx4oQcl.png",
		style: "Exo-Regular",
		url: "https://fonts.gstatic.com/s/exo/v15/4UaZrEtFpBI4f1ZSIK9d4LjJ4lM3CwNsOl4p5Is.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UasMNrCidbLRLlnoFKTOqMKY",
		family: "Exo",
		fullName: "Exo Thin Italic",
		postScriptName: "Exo-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tUSOHWY0UzhOZemF53x6sHVu.png",
		style: "Exo-ThinItalic",
		url: "https://fonts.gstatic.com/s/exo/v15/4UafrEtFpBISdmSt-MY2ehbO95t040FmPnws9Iu-uA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UaoHuGkCSiI92cGljUIq8HFn",
		family: "Exo",
		fullName: "Exo ExtraLight Italic",
		postScriptName: "Exo-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KXLZvDz_hnZ78n0OVYrk5kZh.png",
		style: "Exo-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/exo/v15/4UafrEtFpBISdmSt-MY2ehbO95t0Y0BmPnws9Iu-uA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7v6NmQ2l9wX0cY5DKpoRRG4M",
		family: "Exo",
		fullName: "Exo Light Italic",
		postScriptName: "Exo-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KBtPsOSZq2nGKG9HsqJB7zYW.png",
		style: "Exo-LightItalic",
		url: "https://fonts.gstatic.com/s/exo/v15/4UafrEtFpBISdmSt-MY2ehbO95t0vUBmPnws9Iu-uA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qzMAdOv14OBKw6vPcQGbd69g",
		family: "Exo",
		fullName: "Exo Italic",
		postScriptName: "Exo-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HWrNUkTict2WCxJ8SVlWYBeK.png",
		style: "Exo-Italic",
		url: "https://fonts.gstatic.com/s/exo/v15/4UafrEtFpBISdmSt-MY2ehbO95t040BmPnws9Iu-uA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hPRM6FzD5f0JQoARS3OBl1Lu",
		family: "Exo",
		fullName: "Exo Medium Italic",
		postScriptName: "Exo-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Zjcz8bnQaqevX04F6akP8E0U.png",
		style: "Exo-MediumItalic",
		url: "https://fonts.gstatic.com/s/exo/v15/4UafrEtFpBISdmSt-MY2ehbO95t00UBmPnws9Iu-uA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SjHonDbmttoF0R1iDIU4Zunx",
		family: "Exo",
		fullName: "Exo SemiBold Italic",
		postScriptName: "Exo-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vfOmh1YkMdNiseIyvVCsi_oD.png",
		style: "Exo-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/exo/v15/4UafrEtFpBISdmSt-MY2ehbO95t0PUdmPnws9Iu-uA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dCTLYioW_m195ABE_KWkHfow",
		family: "Exo",
		fullName: "Exo Bold Italic",
		postScriptName: "Exo-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aB1GZhIxfmBEzC5nqLrP2yRw.png",
		style: "Exo-BoldItalic",
		url: "https://fonts.gstatic.com/s/exo/v15/4UafrEtFpBISdmSt-MY2ehbO95t0BEdmPnws9Iu-uA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HUCY95tfTlMA9jgEvPDIMvaj",
		family: "Exo",
		fullName: "Exo ExtraBold Italic",
		postScriptName: "Exo-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NipiZb3sFta1Wjrc_npis2HH.png",
		style: "Exo-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/exo/v15/4UafrEtFpBISdmSt-MY2ehbO95t0Y0dmPnws9Iu-uA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nVo1sgSRhELPVVopg1gJJR9F",
		family: "Exo",
		fullName: "Exo Black Italic",
		postScriptName: "Exo-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8PB_6qaohyJQKwO9dLyB4P2_.png",
		style: "Exo-BlackItalic",
		url: "https://fonts.gstatic.com/s/exo/v15/4UafrEtFpBISdmSt-MY2ehbO95t0SkdmPnws9Iu-uA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wTLQUpi4AizulQ1fSOHAQLQ8",
		family: "Akronim",
		fullName: "Akronim Regular",
		postScriptName: "Akronim-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jkz17qVvqf4XSCsVydW7P_90.png",
		style: "Akronim-Regular",
		url: "https://fonts.gstatic.com/s/akronim/v12/fdN-9sqWtWZZlHRp-gBxkFYN-a8.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZPpqC_K3ItrI8IRk2at0iEas",
		family: "Assistant",
		fullName: "Assistant ExtraLight",
		postScriptName: "Assistant-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tCP9ZpqwqePMBZr9JDHal4xV.png",
		style: "Assistant-ExtraLight",
		url: "https://fonts.gstatic.com/s/assistant/v8/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtmZnEGGf3qGuvM4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8ZayNpBNRtYNNENG1hoVUTKA",
		family: "Assistant",
		fullName: "Assistant Light",
		postScriptName: "Assistant-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/F0NzF1_K3q7K_mg_kjiOfp6G.png",
		style: "Assistant-Light",
		url: "https://fonts.gstatic.com/s/assistant/v8/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtrhnEGGf3qGuvM4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MOAZ95_99nzvCFIn0Tmhs9nf",
		family: "Assistant",
		fullName: "Assistant Medium",
		postScriptName: "Assistant-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/X4WeqcAv1eyqczJ2kzswg0Rz.png",
		style: "Assistant-Medium",
		url: "https://fonts.gstatic.com/s/assistant/v8/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQttRnEGGf3qGuvM4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5VLw6OWyYXkPZ7GCSXjnw8cN",
		family: "Assistant",
		fullName: "Assistant SemiBold",
		postScriptName: "Assistant-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jsIiqENhyseXvmO_1lkWxvtd.png",
		style: "Assistant-SemiBold",
		url: "https://fonts.gstatic.com/s/assistant/v8/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtjhgEGGf3qGuvM4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PQ_Iacu23jNKXefehSC6AUF9",
		family: "Assistant",
		fullName: "Assistant Bold",
		postScriptName: "Assistant-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zH_xjqN5QWT72Y38Zl9NapID.png",
		style: "Assistant-Bold",
		url: "https://fonts.gstatic.com/s/assistant/v8/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtgFgEGGf3qGuvM4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_R7RisJ3gHVb_oykRxoCtaw6m",
		family: "Assistant",
		fullName: "Assistant ExtraBold",
		postScriptName: "Assistant-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Fllm0H4CO8ujQhKLmBDADof9.png",
		style: "Assistant-ExtraBold",
		url: "https://fonts.gstatic.com/s/assistant/v8/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtmZgEGGf3qGuvM4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_rsluus7d7cNdb9bhmj039SzY",
		family: "Assistant",
		fullName: "Assistant Regular",
		postScriptName: "Assistant-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KRyi7UCk5x3ZJ2Xx0NcvLDZ8.png",
		style: "Assistant-Regular",
		url: "https://fonts.gstatic.com/s/assistant/v8/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtuZnEGGf3qGuvM4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nuFycygBOBvLxiCxNu1DIo9S",
		family: "Audiowide",
		fullName: "Audiowide Regular",
		postScriptName: "Audiowide-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/flPvLJqdA1TFqAUKRLjNeiHu.png",
		style: "Audiowide-Regular",
		url: "https://fonts.gstatic.com/s/audiowide/v9/l7gdbjpo0cum0ckerWCtkQXPExpQBw.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dx594SSTmrAjm4wuaguVxcZP",
		family: "Bitter",
		fullName: "Bitter Thin",
		postScriptName: "Bitter-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/PDmY8OvUlN86_9feKq2jRptW.png",
		style: "Bitter-Thin",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbeCL_EXFh2reU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KxqKGeSCNfLw_OU_QRxDEmrn",
		family: "Bitter",
		fullName: "Bitter ExtraLight",
		postScriptName: "Bitter-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jBD9J6c3DuPB8MjcurDhgTWm.png",
		style: "Bitter-ExtraLight",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8XbfCL_EXFh2reU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kGY0neNG4SvTb7JzjXibLQtv",
		family: "Bitter",
		fullName: "Bitter Light",
		postScriptName: "Bitter-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9m8lH6qgsdzqLtwpgQ6RgS3p.png",
		style: "Bitter-Light",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8ajfCL_EXFh2reU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_osiHe8REJsMOx7bMF8R__eQd",
		family: "Bitter",
		fullName: "Bitter Medium",
		postScriptName: "Bitter-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FuRWm9KKiiufNJnQlzWsdXOy.png",
		style: "Bitter-Medium",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8cTfCL_EXFh2reU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZnBSCCRt_MyStK6fdlke_YeX",
		family: "Bitter",
		fullName: "Bitter SemiBold",
		postScriptName: "Bitter-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Vf6Hj0eRUPpPlhIYAVN31WAq.png",
		style: "Bitter-SemiBold",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8SjYCL_EXFh2reU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qc5OzF5AP3Blpb7O18jwQLgL",
		family: "Bitter",
		fullName: "Bitter Bold",
		postScriptName: "Bitter-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/s09974X6KqyMnVplZcumpHgL.png",
		style: "Bitter-Bold",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8RHYCL_EXFh2reU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_k3LfoBzJisEJSz4dqPX6dGzE",
		family: "Bitter",
		fullName: "Bitter ExtraBold",
		postScriptName: "Bitter-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ezhNgMu3ckA5PTlopv_Q5g56.png",
		style: "Bitter-ExtraBold",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8XbYCL_EXFh2reU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_bst7ePPz2GMG1iJ4FQmKPMM_",
		family: "Bitter",
		fullName: "Bitter Black",
		postScriptName: "Bitter-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DgSKDfOWgCR5x9A1MnrV96bw.png",
		style: "Bitter-Black",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8V_YCL_EXFh2reU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0Um0OMmhv0YAc6U4_TXCsR3n",
		family: "Bitter",
		fullName: "Bitter Regular",
		postScriptName: "Bitter-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NIRD9ycz3yrsDqsrOI99vKSu.png",
		style: "Bitter-Regular",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbfCL_EXFh2reU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_RcgQyUQb9o3hNzUuB2FlHo0D",
		family: "Bitter",
		fullName: "Bitter Thin Italic",
		postScriptName: "Bitter-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/yE7YfpzkAbHL_GtRXwhRSdDt.png",
		style: "Bitter-ThinItalic",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6c4P3OWHpzveWxBw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PTGAyf9yhXEh3sW2IcRgjoNx",
		family: "Bitter",
		fullName: "Bitter ExtraLight Italic",
		postScriptName: "Bitter-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/0n2oodfjG0Sdq0keNSQ3P7U1.png",
		style: "Bitter-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cYPzOWHpzveWxBw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_CIVHSap2GHshqlbH0LsTK6ki",
		family: "Bitter",
		fullName: "Bitter Light Italic",
		postScriptName: "Bitter-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vWI_me18MV7YMOQgCEh3t7Gr.png",
		style: "Bitter-LightItalic",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cvvzOWHpzveWxBw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_AUVRRbhRS2eXwuhQYXOsGTVY",
		family: "Bitter",
		fullName: "Bitter Italic",
		postScriptName: "Bitter-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/z2JR4yjt2pQtRpHa0l_r_x6N.png",
		style: "Bitter-Italic",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6c4PzOWHpzveWxBw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Dye40j2Fzq3bkzBuDEBwfIeh",
		family: "Bitter",
		fullName: "Bitter Medium Italic",
		postScriptName: "Bitter-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AwBuFALT32OCnwkejj9Ta0KH.png",
		style: "Bitter-MediumItalic",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6c0vzOWHpzveWxBw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QWn3vjoBtgL8LfMOosj4ojuS",
		family: "Bitter",
		fullName: "Bitter SemiBold Italic",
		postScriptName: "Bitter-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_DnnsKoQGXM1jnn0H6drt3Rv.png",
		style: "Bitter-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cPvvOWHpzveWxBw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7zSgBU3Xw3CK8Zn52f_Qxi3O",
		family: "Bitter",
		fullName: "Bitter Bold Italic",
		postScriptName: "Bitter-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aH9IvdHekEopwvGlkUdpzYXu.png",
		style: "Bitter-BoldItalic",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cB_vOWHpzveWxBw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4BIMsibh2Um478caDcEjpJ6k",
		family: "Bitter",
		fullName: "Bitter ExtraBold Italic",
		postScriptName: "Bitter-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/j1c8aZY51I1XKXv5CFR9UQ0S.png",
		style: "Bitter-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cYPvOWHpzveWxBw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_1xBIghoFKYwefGWEwymRILiA",
		family: "Bitter",
		fullName: "Bitter Black Italic",
		postScriptName: "Bitter-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5r81MS_vBfpV2KGYisG3USGQ.png",
		style: "Bitter-BlackItalic",
		url: "https://fonts.gstatic.com/s/bitter/v19/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cSfvOWHpzveWxBw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_g7s0YmASAkKF60Y5ialavFl1",
		family: "Caesar Dressing",
		fullName: "Caesar Dressing Regular",
		postScriptName: "CaesarDressing",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KAt2Pb8Ogbi2hlHTNpToydZ5.png",
		style: "CaesarDressing",
		url: "https://fonts.gstatic.com/s/caesardressing/v11/yYLx0hLa3vawqtwdswbotmK4vrR3cbb6LZttyg.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qxEQ_KUiuE4IZ9UAAFo0ngqV",
		family: "Candal",
		fullName: "Candal Regular",
		postScriptName: "Candal",
		preview: "https://ik.imagekit.io/lh/fonts/v2/G7P5uFxQDraQLddMfZEoeXXj.png",
		style: "Candal",
		url: "https://fonts.gstatic.com/s/candal/v10/XoHn2YH6T7-t_8cNAR4Jt9Yxlw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_imJCEeVxz95sWeto9Bj61vxQ",
		family: "Coda",
		fullName: "Coda ExtraBold",
		postScriptName: "Coda-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WxYgktPPlifNx53Dz844Toy7.png",
		style: "Coda-ExtraBold",
		url: "https://fonts.gstatic.com/s/coda/v16/SLXIc1jY5nQ8HeIgTp6mw9t1cX8.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wwvL1AM1VrqeHuWNVko8tXg4",
		family: "Coda",
		fullName: "Coda Regular",
		postScriptName: "Coda-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nCPsQovww97V2a_pjTHeRpcf.png",
		style: "Coda-Regular",
		url: "https://fonts.gstatic.com/s/coda/v16/SLXHc1jY5nQ8JUIMapaN39I.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hDPxEt5rLDXwkGAJaJw5MsRu",
		family: "Comfortaa",
		fullName: "Comfortaa Light",
		postScriptName: "Comfortaa-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/UH9KxaGixMqHI5zpjDSC_01p.png",
		style: "Comfortaa-Light",
		url: "https://fonts.gstatic.com/s/comfortaa/v34/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4TbMPrQVIT9c2c8.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pMVcJtQgnfIIJnfU7efGhguP",
		family: "Comfortaa",
		fullName: "Comfortaa Medium",
		postScriptName: "Comfortaa-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SAE_LE4zdUbUdlbt_p6JPVNd.png",
		style: "Comfortaa-Medium",
		url: "https://fonts.gstatic.com/s/comfortaa/v34/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4VrMPrQVIT9c2c8.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ODYGHRBKMrAIUhidssqIKEuS",
		family: "Comfortaa",
		fullName: "Comfortaa SemiBold",
		postScriptName: "Comfortaa-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tPlcAtAdBVYd8GTOqL1OuLU5.png",
		style: "Comfortaa-SemiBold",
		url: "https://fonts.gstatic.com/s/comfortaa/v34/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4bbLPrQVIT9c2c8.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tEieOInJlI3I7G9L3feLSttn",
		family: "Comfortaa",
		fullName: "Comfortaa Bold",
		postScriptName: "Comfortaa-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/i0bmqeqxyRH1YL_w6stqCtHm.png",
		style: "Comfortaa-Bold",
		url: "https://fonts.gstatic.com/s/comfortaa/v34/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4Y_LPrQVIT9c2c8.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_CvHvgMSbkZpj8ijW4cx8GRhI",
		family: "Comfortaa",
		fullName: "Comfortaa Regular",
		postScriptName: "Comfortaa-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/dErCdTTYL88UEzLO1CoOgLeK.png",
		style: "Comfortaa-Regular",
		url: "https://fonts.gstatic.com/s/comfortaa/v34/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4WjMPrQVIT9c2c8.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_VWn1a0PRIgHX1f9BQCutV76S",
		family: "Comforter",
		fullName: "Comforter Regular",
		postScriptName: "Comforter-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1OYseo7JOfKzpE4oFdGjkhN4.png",
		style: "Comforter-Regular",
		url: "https://fonts.gstatic.com/s/comforter/v3/H4clBXOCl8nQnlaql3Qa6JG8iqeuag.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TWtr_DmL7RssxN8zpNO4hWsf",
		family: "Creepster",
		fullName: "Creepster Regular",
		postScriptName: "Creepster-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uoehvkh4ZPU4at3jPX7CEJ3e.png",
		style: "Creepster-Regular",
		url: "https://fonts.gstatic.com/s/creepster/v9/AlZy_zVUqJz4yMrniH4hdXf4XB0Tow.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GBfBJCWQBxeyTaIzs_MedHnT",
		family: "Cutive Mono",
		fullName: "Cutive Mono Regular",
		postScriptName: "CutiveMono-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/33VUdrotb9iFa9tD998qvTfx.png",
		style: "CutiveMono-Regular",
		url: "https://fonts.gstatic.com/s/cutivemono/v9/m8JWjfRfY7WVjVi2E-K9H5RFRG-K3Mud.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ukplsDlTKtQetECa3GKSIzZM",
		family: "Eczar",
		fullName: "Eczar Medium",
		postScriptName: "Eczar-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nPxaVueZ2mBPRBlwkveggPLz.png",
		style: "Eczar-Medium",
		url: "https://fonts.gstatic.com/s/eczar/v9/BXRovF3Pi-DLmzXWL8t622v9WNjW.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jcblA_XGVnLGc2JiZymX6lMc",
		family: "Eczar",
		fullName: "Eczar SemiBold",
		postScriptName: "Eczar-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/C_lysKMuVs6s9Y1BFFELMWWR.png",
		style: "Eczar-SemiBold",
		url: "https://fonts.gstatic.com/s/eczar/v9/BXRovF3Pi-DLmzX6KMt622v9WNjW.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_H1ZGcp1U0LhtkAWCO8gI6HD_",
		family: "Eczar",
		fullName: "Eczar Bold",
		postScriptName: "Eczar-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NA40NRJjzXiVYDIOcL1afair.png",
		style: "Eczar-Bold",
		url: "https://fonts.gstatic.com/s/eczar/v9/BXRovF3Pi-DLmzWeKct622v9WNjW.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JuhmeLZH3xF6hfXkU80BlZHS",
		family: "Eczar",
		fullName: "Eczar ExtraBold",
		postScriptName: "Eczar-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VUs8nA61hR8bjSCzRpt4n34U.png",
		style: "Eczar-ExtraBold",
		url: "https://fonts.gstatic.com/s/eczar/v9/BXRovF3Pi-DLmzWCKst622v9WNjW.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5AscxT91a1mAAAVyl0mKBTt0",
		family: "Eczar",
		fullName: "Eczar Regular",
		postScriptName: "Eczar-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DbmY1d_cafaKIedALKbWnDNp.png",
		style: "Eczar-Regular",
		url: "https://fonts.gstatic.com/s/eczar/v9/BXRlvF3Pi-DLmw0iBu9y8Hf0.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8pRLQVCn5sNmbqSyKBCCtUdN",
		family: "Alegreya",
		fullName: "Alegreya Medium",
		postScriptName: "Alegreya-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bXzaYXonSD8XgoVBSIErVC2K.png",
		style: "Alegreya-Medium",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGxBUI_KCisSGVrw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xoQJxuQj0PIdRvDMUwoH2Wth",
		family: "Alegreya",
		fullName: "Alegreya SemiBold",
		postScriptName: "Alegreya-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/q93n4HejSqPS2wW2AslOjWp3.png",
		style: "Alegreya-SemiBold",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGKBII_KCisSGVrw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lNijb2nXPEamioGqVr8ocIL_",
		family: "Alegreya",
		fullName: "Alegreya Bold",
		postScriptName: "Alegreya-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/itA_DPrwQ0BGqaEvVimBPtV_.png",
		style: "Alegreya-Bold",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGERII_KCisSGVrw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_1aMtrpJ_4dqEmj0iNwKRxKPK",
		family: "Alegreya",
		fullName: "Alegreya ExtraBold",
		postScriptName: "Alegreya-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zuboK2QaY5MhuYW7xRIGmaBE.png",
		style: "Alegreya-ExtraBold",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGdhII_KCisSGVrw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_m4ONrhRm1Eav2G7Q4FHMlo9f",
		family: "Alegreya",
		fullName: "Alegreya Black",
		postScriptName: "Alegreya-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tiPcmCGingxtbluwmyd5QX22.png",
		style: "Alegreya-Black",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGXxII_KCisSGVrw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_avLUi4WzBtCqlyilP8MZ6uRb",
		family: "Alegreya",
		fullName: "Alegreya Regular",
		postScriptName: "Alegreya-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rTRCfXKXH85_ZkaCYJf6qWCJ.png",
		style: "Alegreya-Regular",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNG9hUI_KCisSGVrw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qS0ilW96BevAQ68G_9Muwg3Y",
		family: "Alegreya",
		fullName: "Alegreya Italic",
		postScriptName: "Alegreya-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ImMvGON0ffTELJvivzkW9AM7.png",
		style: "Alegreya-Italic",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlbgv6qmkySFr9V9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hNePcoxxP1uMIW4g7rPd5eAx",
		family: "Alegreya",
		fullName: "Alegreya Medium Italic",
		postScriptName: "Alegreya-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/18YRNR1siOtEftqHj10HpKt8.png",
		style: "Alegreya-MediumItalic",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlbSv6qmkySFr9V9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pIdFIW64rxw5kwpFArXRegeL",
		family: "Alegreya",
		fullName: "Alegreya SemiBold Italic",
		postScriptName: "Alegreya-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/o8m9knQdttpzEp81cgzxanyn.png",
		style: "Alegreya-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlY-uKqmkySFr9V9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cKDrlZgJlRLomyD0xICidW_8",
		family: "Alegreya",
		fullName: "Alegreya Bold Italic",
		postScriptName: "Alegreya-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/t0a3bniI_ksN32yVEda5f25j.png",
		style: "Alegreya-BoldItalic",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlYHuKqmkySFr9V9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_RUJCPJYgK6q3LLklSu0BgVW7",
		family: "Alegreya",
		fullName: "Alegreya ExtraBold Italic",
		postScriptName: "Alegreya-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7kCf7H86uhJ8OaIWtaKios2x.png",
		style: "Alegreya-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlZguKqmkySFr9V9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7iBLWwbMTqNI0KlFFy1ommf5",
		family: "Alegreya",
		fullName: "Alegreya Black Italic",
		postScriptName: "Alegreya-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9z0r9nJX7jFhfD06G4Mb1pno.png",
		style: "Alegreya-BlackItalic",
		url: "https://fonts.gstatic.com/s/alegreya/v19/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlZJuKqmkySFr9V9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_U_dEQP3FmMKLbgfaqg3Ij4IZ",
		family: "Allerta Stencil",
		fullName: "Allerta Stencil Regular",
		postScriptName: "AllertaStencil-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/M0pjM11tGIF5RvI4KlJPCof3.png",
		style: "AllertaStencil-Regular",
		url: "https://fonts.gstatic.com/s/allertastencil/v11/HTx0L209KT-LmIE9N7OR6eiycOeF-zz313DuvQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7jAaVy1AsZNxfAREQj64Y10_",
		family: "Anton",
		fullName: "Anton Regular",
		postScriptName: "Anton-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/PX2m3uTUsR5rz_lKNH5mluoO.png",
		style: "Anton-Regular",
		url: "https://fonts.gstatic.com/s/anton/v15/1Ptgg87LROyAm0K08i4gS7lu.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_sZ3EhsHe_mENZvzofoHijvDu",
		family: "Archivo Narrow",
		fullName: "Archivo Narrow Medium",
		postScriptName: "ArchivoNarrow-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2NGBWTGMrtfxILZr3tvi23dq.png",
		style: "ArchivoNarrow-Medium",
		url: "https://fonts.gstatic.com/s/archivonarrow/v18/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvHlGKpHOtFCQ76Q.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_CUArBC_zifAz5ml9UtEMQ3lJ",
		family: "Archivo Narrow",
		fullName: "Archivo Narrow SemiBold",
		postScriptName: "ArchivoNarrow-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_cyRK3cQEpzRAj6LLZIFtNpu.png",
		style: "ArchivoNarrow-SemiBold",
		url: "https://fonts.gstatic.com/s/archivonarrow/v18/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhv8laKpHOtFCQ76Q.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_USf7VATmurww5guiFQtcLAXb",
		family: "Archivo Narrow",
		fullName: "Archivo Narrow Bold",
		postScriptName: "ArchivoNarrow-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/H_tcB6Y7Q44ZuX11s5IiGr0l.png",
		style: "ArchivoNarrow-Bold",
		url: "https://fonts.gstatic.com/s/archivonarrow/v18/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvy1aKpHOtFCQ76Q.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4t33XqGrdbwCswBjsrwE3z_b",
		family: "Archivo Narrow",
		fullName: "Archivo Narrow Regular",
		postScriptName: "ArchivoNarrow-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2485kzQO2wVWJsMckh7yYDSY.png",
		style: "ArchivoNarrow-Regular",
		url: "https://fonts.gstatic.com/s/archivonarrow/v18/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvLFGKpHOtFCQ76Q.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_VgzUBAEBcJkgjBJZruvMKRqe",
		family: "Archivo Narrow",
		fullName: "Archivo Narrow Italic",
		postScriptName: "ArchivoNarrow-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fPWkfoPcQDyJ8dPPmzfxh6Nq.png",
		style: "ArchivoNarrow-Italic",
		url: "https://fonts.gstatic.com/s/archivonarrow/v18/tss7ApVBdCYD5Q7hcxTE1ArZ0bb1k3JSLwe1hB965BJi53mpNiEr6T6Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8pDqlEhsJBqDEmRxqEncdPFg",
		family: "Archivo Narrow",
		fullName: "Archivo Narrow Medium Italic",
		postScriptName: "ArchivoNarrow-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mRj4ygFpe75Fwrf_4uIgp3Qd.png",
		style: "ArchivoNarrow-MediumItalic",
		url: "https://fonts.gstatic.com/s/archivonarrow/v18/tss7ApVBdCYD5Q7hcxTE1ArZ0bb1k3JSLwe1hB965BJQ53mpNiEr6T6Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zv5PYJnUGCcmWzDUfZyx5qtJ",
		family: "Archivo Narrow",
		fullName: "Archivo Narrow SemiBold Italic",
		postScriptName: "ArchivoNarrow-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wyyJmjVHEfkxx7mvZReU_JUC.png",
		style: "ArchivoNarrow-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/archivonarrow/v18/tss7ApVBdCYD5Q7hcxTE1ArZ0bb1k3JSLwe1hB965BK84HmpNiEr6T6Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IFzMug5VwDVFuKXoMi6DHhhv",
		family: "Archivo Narrow",
		fullName: "Archivo Narrow Bold Italic",
		postScriptName: "ArchivoNarrow-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6kq__T90kyQRWAsHlH_uvlqR.png",
		style: "ArchivoNarrow-BoldItalic",
		url: "https://fonts.gstatic.com/s/archivonarrow/v18/tss7ApVBdCYD5Q7hcxTE1ArZ0bb1k3JSLwe1hB965BKF4HmpNiEr6T6Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QaO6F35k0C9JOBD7YQAqEud6",
		family: "Dancing Script",
		fullName: "Dancing Script Medium",
		postScriptName: "DancingScript-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/54Pyiy_JX0Il6SJ95zplFQNg.png",
		style: "DancingScript-Medium",
		url: "https://fonts.gstatic.com/s/dancingscript/v19/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7BAyoHTeB9ptDqpw.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jke52U3oDsxImMYXNvE5S9sc",
		family: "Dancing Script",
		fullName: "Dancing Script SemiBold",
		postScriptName: "DancingScript-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nh0BTUZsTk3m00srLTCDzFud.png",
		style: "DancingScript-SemiBold",
		url: "https://fonts.gstatic.com/s/dancingscript/v19/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7B7y0HTeB9ptDqpw.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Pw9RBxGNly_uWGOM0wVyR6z3",
		family: "Dancing Script",
		fullName: "Dancing Script Bold",
		postScriptName: "DancingScript-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2J9xOJYOJPfi5B6gqHHitAGD.png",
		style: "DancingScript-Bold",
		url: "https://fonts.gstatic.com/s/dancingscript/v19/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7B1i0HTeB9ptDqpw.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_znGvSF8Le5F6lcFFYyFThfxh",
		family: "Dancing Script",
		fullName: "Dancing Script Regular",
		postScriptName: "DancingScript-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/XqDu1gfIAOHUPqRvkOkqu8iY.png",
		style: "DancingScript-Regular",
		url: "https://fonts.gstatic.com/s/dancingscript/v19/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7BMSoHTeB9ptDqpw.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Cysny0VqZ01z2N6O3U6_Ah0n",
		family: "Dosis",
		fullName: "Dosis ExtraLight",
		postScriptName: "Dosis-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3tatglt32VNHhE1dBmCBE8HV.png",
		style: "Dosis-ExtraLight",
		url: "https://fonts.gstatic.com/s/dosis/v22/HhyJU5sn9vOmLxNkIwRSjTVNWLEJt7MV3BkFTq4EPw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_25E9YF1TGQegLb3NeC0058eC",
		family: "Dosis",
		fullName: "Dosis Light",
		postScriptName: "Dosis-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tob36hfwGUg5nMfg4mVfqjIk.png",
		style: "Dosis-Light",
		url: "https://fonts.gstatic.com/s/dosis/v22/HhyJU5sn9vOmLxNkIwRSjTVNWLEJabMV3BkFTq4EPw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_DoKrlh67z97hSY07BQh3Kdfd",
		family: "Dosis",
		fullName: "Dosis Medium",
		postScriptName: "Dosis-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7_qgKq8I41Skjbjnnf58aRDL.png",
		style: "Dosis-Medium",
		url: "https://fonts.gstatic.com/s/dosis/v22/HhyJU5sn9vOmLxNkIwRSjTVNWLEJBbMV3BkFTq4EPw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0Z1ezQ6gGSh9zNQMxSNhvyEM",
		family: "Dosis",
		fullName: "Dosis SemiBold",
		postScriptName: "Dosis-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/azS0YIuP7udhNsZJ90j5eZPl.png",
		style: "Dosis-SemiBold",
		url: "https://fonts.gstatic.com/s/dosis/v22/HhyJU5sn9vOmLxNkIwRSjTVNWLEJ6bQV3BkFTq4EPw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4KHwsUjRSGwKuKOa18TvON4B",
		family: "Dosis",
		fullName: "Dosis Bold",
		postScriptName: "Dosis-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OKfCKRDwcUw3Gjlq_89SL0gZ.png",
		style: "Dosis-Bold",
		url: "https://fonts.gstatic.com/s/dosis/v22/HhyJU5sn9vOmLxNkIwRSjTVNWLEJ0LQV3BkFTq4EPw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gB0enjvfUgk5_AMPSXkxCIKi",
		family: "Dosis",
		fullName: "Dosis ExtraBold",
		postScriptName: "Dosis-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Xhu8o9MD9aBZoUD1DFCE_891.png",
		style: "Dosis-ExtraBold",
		url: "https://fonts.gstatic.com/s/dosis/v22/HhyJU5sn9vOmLxNkIwRSjTVNWLEJt7QV3BkFTq4EPw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_K_eJ1pOrHX3NhEvmG4IrWYlF",
		family: "Dosis",
		fullName: "Dosis Regular",
		postScriptName: "Dosis-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pfZpaFaXRJjjnLwAcqtCibJl.png",
		style: "Dosis-Regular",
		url: "https://fonts.gstatic.com/s/dosis/v22/HhyJU5sn9vOmLxNkIwRSjTVNWLEJN7MV3BkFTq4EPw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_oMiFOCZ0HU_eS6L_3I3Ql031",
		family: "Fira Sans",
		fullName: "Fira Sans Thin",
		postScriptName: "FiraSans-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/a9ZHnUNj2icqmo9tXNkXBJob.png",
		style: "FiraSans-Thin",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9C4kDNxMZdWfMOD5Vn9IjOazP3dUTP.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qbnZyCUwwy0ioTtrhsj4Wy_C",
		family: "Fira Sans",
		fullName: "Fira Sans ExtraLight",
		postScriptName: "FiraSans-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kDOC24v7JT5ZUyzKezeEAeHz.png",
		style: "FiraSans-ExtraLight",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnWKnuQR37fF3Wlg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_OJ_yef_twSZDZmA6JnRR1Vpx",
		family: "Fira Sans",
		fullName: "Fira Sans Light",
		postScriptName: "FiraSans-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8PkkNTcUB3NHDzchBEaoZssT.png",
		style: "FiraSans-Light",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnPKruQR37fF3Wlg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UZPkm_uKo5tEoGtgwNLgLIge",
		family: "Fira Sans",
		fullName: "Fira Sans Medium",
		postScriptName: "FiraSans-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VrlfnOSFIWYIsPZ8_JDBMAwy.png",
		style: "FiraSans-Medium",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnZKvuQR37fF3Wlg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gVIjNME12jqDxZkWQKjFLe8J",
		family: "Fira Sans",
		fullName: "Fira Sans SemiBold",
		postScriptName: "FiraSans-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mSR5ioQiGXlbTfdgnRl5hL_c.png",
		style: "FiraSans-SemiBold",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnSKzuQR37fF3Wlg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_m9hpbuiEGQbABwiAKJhawBEK",
		family: "Fira Sans",
		fullName: "Fira Sans Bold",
		postScriptName: "FiraSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Iyc2wbrza0CGr57P0JGRp4Zc.png",
		style: "FiraSans-Bold",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnLK3uQR37fF3Wlg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_U1BYJBVRzXF_uq7HsutLfVoc",
		family: "Fira Sans",
		fullName: "Fira Sans ExtraBold",
		postScriptName: "FiraSans-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/22EsYyab13lR5eMl7Cs3MX8o.png",
		style: "FiraSans-ExtraBold",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnMK7uQR37fF3Wlg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tyK8lKv31vLD0XuqQr4EnahK",
		family: "Fira Sans",
		fullName: "Fira Sans Black",
		postScriptName: "FiraSans-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qJKt3zoufxLFIjBFrByoCYXd.png",
		style: "FiraSans-Black",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnFK_uQR37fF3Wlg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_mBzFNC0GDsgUNw2aVgNqNhva",
		family: "Fira Sans",
		fullName: "Fira Sans Thin Italic",
		postScriptName: "FiraSans-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ICaYmW04FzPvBdvy1z5v3lg0.png",
		style: "FiraSans-ThinItalic",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9A4kDNxMZdWfMOD5VvkrCqYTfVcFTPj0s.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_2H51PGtmINltYCD4cJRpO4vv",
		family: "Fira Sans",
		fullName: "Fira Sans ExtraLight Italic",
		postScriptName: "FiraSans-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/GkkvYkike8seGbCo8Ebhfba7.png",
		style: "FiraSans-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrAGQBf_XljGllLX.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PqMaL8f9a5EQU2WNnkPBQyab",
		family: "Fira Sans",
		fullName: "Fira Sans Light Italic",
		postScriptName: "FiraSans-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/o65NsrLpiOIEvFjzbJb5a599.png",
		style: "FiraSans-LightItalic",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBiQxf_XljGllLX.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_rEByyEm5l6NyzhAS9R13P3e0",
		family: "Fira Sans",
		fullName: "Fira Sans Regular",
		postScriptName: "FiraSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rY4kJMgmHsaJWs7a4su3z05o.png",
		style: "FiraSans-Regular",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9E4kDNxMZdWfMOD5VfkILKSTbndQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_m1V1ho7l7gDjhQs3mdanFMA9",
		family: "Fira Sans",
		fullName: "Fira Sans Italic",
		postScriptName: "FiraSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/W1TO0B60QzaXwWkQznmJFdaD.png",
		style: "FiraSans-Italic",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9C4kDNxMZdWfMOD5VvkojOazP3dUTP.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ooniJuUJlo92TGgZsgTRFYND",
		family: "Fira Sans",
		fullName: "Fira Sans Medium Italic",
		postScriptName: "FiraSans-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/sHFJR5ZUnO9A397exHs4poU4.png",
		style: "FiraSans-MediumItalic",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrA6Qhf_XljGllLX.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IXdY7tQANbSmKDKZY2z8__Kz",
		family: "Fira Sans",
		fullName: "Fira Sans SemiBold Italic",
		postScriptName: "FiraSans-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mMSss_e82cA_EHZznw5YJVZz.png",
		style: "FiraSans-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrAWRRf_XljGllLX.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_58M8p97nTinJwdnIiHe0euPl",
		family: "Fira Sans",
		fullName: "Fira Sans Bold Italic",
		postScriptName: "FiraSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5LuAum4lwkRbHzBZskk9air3.png",
		style: "FiraSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrByRBf_XljGllLX.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9GYI8QlD7umBLSVWDcuVZGSO",
		family: "Fira Sans",
		fullName: "Fira Sans ExtraBold Italic",
		postScriptName: "FiraSans-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/EHR7Hb8EVynBhXPvdXzjGBX8.png",
		style: "FiraSans-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBuRxf_XljGllLX.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HpXvAIVVb_jnd8hEFMgRHBNA",
		family: "Fira Sans",
		fullName: "Fira Sans Black Italic",
		postScriptName: "FiraSans-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FG3AeL4tAVnJUVAqB0dHaWeb.png",
		style: "FiraSans-BlackItalic",
		url: "https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBKRhf_XljGllLX.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jDVWd7dqNokDjps8QLGsyqPR",
		family: "Hanalei",
		fullName: "Hanalei Regular",
		postScriptName: "Hanalei-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_s7AYaWFGD2400cKuK5xWKh5.png",
		style: "Hanalei-Regular",
		url: "https://fonts.gstatic.com/s/hanalei/v13/E21n_dD8iufIjBRHXzgmVydREus.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_aoKnZOSK52LpUMWPlyUcOVkU",
		family: "Hanalei Fill",
		fullName: "Hanalei Fill Regular",
		postScriptName: "HanaleiFill-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IqYbhrMvTkZrtsmZnQz5yu8g.png",
		style: "HanaleiFill-Regular",
		url: "https://fonts.gstatic.com/s/hanaleifill/v11/fC1mPYtObGbfyQznIaQzPQiMVwLBplm9aw.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_P5xrKRHUx535Tl4WxTp1Tgfa",
		family: "Jua",
		fullName: "Jua Regular",
		postScriptName: "Jua-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gxLqyxTCDLKXxBnfZByS4g8k.png",
		style: "Jua-Regular",
		url: "https://fonts.gstatic.com/s/jua/v8/co3KmW9ljjAjc-DZCsKgsg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cILj4ssEdCxKpuOG0pTUoncj",
		family: "Julius Sans One",
		fullName: "Julius Sans One Regular",
		postScriptName: "JuliusSansOne-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KCkgaJPwbaILbdh7BWmpH4Rw.png",
		style: "JuliusSansOne-Regular",
		url: "https://fonts.gstatic.com/s/juliussansone/v9/1Pt2g8TAX_SGgBGUi0tGOYEga5W-xXEW6aGXHw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0JrbNxmqqCBSOxn8oSxKCRli",
		family: "Just Me Again Down Here",
		fullName: "Just Me Again Down Here Regular",
		postScriptName: "JustMeAgainDownHere",
		preview: "https://ik.imagekit.io/lh/fonts/v2/alsGHoYTNX_RiPuAiRpNA_k0.png",
		style: "JustMeAgainDownHere",
		url: "https://fonts.gstatic.com/s/justmeagaindownhere/v14/MwQmbgXtz-Wc6RUEGNMc0QpRrfUh2hSdBBMoAuwHvqDwc_fg.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Fu5J7ZFmHEFIr8jd3RDMQ2Qm",
		family: "Lobster",
		fullName: "Lobster Regular",
		postScriptName: "Lobster-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qtK9B3rogiQ2hA3Y24dDTMxh.png",
		style: "Lobster-Regular",
		url: "https://fonts.gstatic.com/s/lobster/v23/neILzCirqoswsqX9_oWsMqEzSJQ.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_d1HR0JIjMft9uWh24f3ALu8B",
		family: "Notable",
		fullName: "Notable Regular",
		postScriptName: "Notable-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2VfpPGb1svswsEudXNcioA7V.png",
		style: "Notable-Regular",
		url: "https://fonts.gstatic.com/s/notable/v9/gNMEW3N_SIqx-WX9-HMoFIez5MI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SBDpZRQkXBjVxrTC7YdlDOJv",
		family: "Nunito Sans",
		fullName: "Nunito Sans ExtraLight",
		postScriptName: "NunitoSans-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BxqtJKazN6hzdwn_tuLR_UGE.png",
		style: "NunitoSans-ExtraLight",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe03MImSLYBIv1o4X1M8cc9yAv5qWVAgVol-.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_A8olxMmRVU70nNgzw0rrdWjX",
		family: "Nunito Sans",
		fullName: "Nunito Sans Light",
		postScriptName: "NunitoSans-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/V1Y6WshrjGNiOIrlm5zvyK6H.png",
		style: "NunitoSans-Light",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe03MImSLYBIv1o4X1M8cc8WAf5qWVAgVol-.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3N61ACPK8FD8rgcgokDaybsu",
		family: "Nunito Sans",
		fullName: "Nunito Sans SemiBold",
		postScriptName: "NunitoSans-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/cpdrLDqMOehqHhPlDh6koX9L.png",
		style: "NunitoSans-SemiBold",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe03MImSLYBIv1o4X1M8cc9iB_5qWVAgVol-.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_uzBQr8a2821nOU4s0gyXG4xs",
		family: "Nunito Sans",
		fullName: "Nunito Sans Bold",
		postScriptName: "NunitoSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/giVFAQweedIpbqdohwBFC5Mm.png",
		style: "NunitoSans-Bold",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe03MImSLYBIv1o4X1M8cc8GBv5qWVAgVol-.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_J83OdwIAy_24_ySpGm_CuNpa",
		family: "Nunito Sans",
		fullName: "Nunito Sans ExtraBold",
		postScriptName: "NunitoSans-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/A8_JUZZtXsZOpoo6LQ4DeJdY.png",
		style: "NunitoSans-ExtraBold",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe03MImSLYBIv1o4X1M8cc8aBf5qWVAgVol-.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_e5BbrotZ9pRPgLZ0ayyIS969",
		family: "Nunito Sans",
		fullName: "Nunito Sans Black",
		postScriptName: "NunitoSans-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/PkkCxau9yrLK8Su3BUJBrrg6.png",
		style: "NunitoSans-Black",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe03MImSLYBIv1o4X1M8cc8-BP5qWVAgVol-.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FaL8I6VYD_dxbIrTcdPosioQ",
		family: "Nunito Sans",
		fullName: "Nunito Sans ExtraLight Italic",
		postScriptName: "NunitoSans-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nGN4LPGovUisUKPP7D1c01hm.png",
		style: "NunitoSans-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe01MImSLYBIv1o4X1M8cce4GxZrU1QCU5l-06Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_r3oNDrHUcfmWuDzNDVPhN8tB",
		family: "Nunito Sans",
		fullName: "Nunito Sans Light Italic",
		postScriptName: "NunitoSans-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aPy7l41doOFFHRMGZ7COTA8P.png",
		style: "NunitoSans-LightItalic",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe01MImSLYBIv1o4X1M8cce4G3JoU1QCU5l-06Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UpcUs_TRvbT1ERIbANA8qYH8",
		family: "Nunito Sans",
		fullName: "Nunito Sans Regular",
		postScriptName: "NunitoSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/sTO2U1Hgmb3Lm2YrOAV969zt.png",
		style: "NunitoSans-Regular",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe0qMImSLYBIv1o4X1M8cfe6Kdpickwp.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_T28GPN1UEZEI_iUw0zupaaPC",
		family: "Nunito Sans",
		fullName: "Nunito Sans Italic",
		postScriptName: "NunitoSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/acTPRT8qxB00TAC8u97TM8J1.png",
		style: "NunitoSans-Italic",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe0oMImSLYBIv1o4X1M8cce4I95Ad1wpT5A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_I7WErhkgeRMD7rr7_keTllXf",
		family: "Nunito Sans",
		fullName: "Nunito Sans SemiBold Italic",
		postScriptName: "NunitoSans-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Wgb0npQTzPrDAR6SfNJmanWT.png",
		style: "NunitoSans-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe01MImSLYBIv1o4X1M8cce4GwZuU1QCU5l-06Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3Hl0KA5uaXiOHI_0CAYRxF2W",
		family: "Nunito Sans",
		fullName: "Nunito Sans Bold Italic",
		postScriptName: "NunitoSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IAEIeWjIJtceILknNf53luAr.png",
		style: "NunitoSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe01MImSLYBIv1o4X1M8cce4G2JvU1QCU5l-06Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UKhBb3HqB1TMPORFPI9wfkln",
		family: "Nunito Sans",
		fullName: "Nunito Sans ExtraBold Italic",
		postScriptName: "NunitoSans-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uib5XUzc8t0_9mRKniJVF_45.png",
		style: "NunitoSans-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe01MImSLYBIv1o4X1M8cce4G35sU1QCU5l-06Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_te1mO1sdeWPqmg02iRJ8Ny7E",
		family: "Nunito Sans",
		fullName: "Nunito Sans Black Italic",
		postScriptName: "NunitoSans-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vz0p8SIdaUucfTBhfUptPI2Z.png",
		style: "NunitoSans-BlackItalic",
		url: "https://fonts.gstatic.com/s/nunitosans/v8/pe01MImSLYBIv1o4X1M8cce4G1ptU1QCU5l-06Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EV0hQwhMXJRkgjnz8dzW_ORz",
		family: "Orbitron",
		fullName: "Orbitron Medium",
		postScriptName: "Orbitron-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SlGH_7lUY6iAWVsepmLDyBSO.png",
		style: "Orbitron-Medium",
		url: "https://fonts.gstatic.com/s/orbitron/v19/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyKS6xpmIyXjU1pg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_uacVYyakx9S5WPfaEDTZJROt",
		family: "Orbitron",
		fullName: "Orbitron SemiBold",
		postScriptName: "Orbitron-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wcOqXBqXY4vsamiMxUyxCfbN.png",
		style: "Orbitron-SemiBold",
		url: "https://fonts.gstatic.com/s/orbitron/v19/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyxSmxpmIyXjU1pg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MfB0oetxgxvOCXNMGcUTBsiV",
		family: "Orbitron",
		fullName: "Orbitron Bold",
		postScriptName: "Orbitron-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fbxmelbJox5zDGO5XMl96VDq.png",
		style: "Orbitron-Bold",
		url: "https://fonts.gstatic.com/s/orbitron/v19/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1ny_CmxpmIyXjU1pg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YFa0yJ6cWCTJdgDMWlfDTvUD",
		family: "Orbitron",
		fullName: "Orbitron ExtraBold",
		postScriptName: "Orbitron-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AZMz_29xO8q3xvwWgOaRWn9Q.png",
		style: "Orbitron-ExtraBold",
		url: "https://fonts.gstatic.com/s/orbitron/v19/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nymymxpmIyXjU1pg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ciQ9st8KNfmDGCAcuTWuR15W",
		family: "Orbitron",
		fullName: "Orbitron Black",
		postScriptName: "Orbitron-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KjvwS_h7oJpNYAlGGkKkv92K.png",
		style: "Orbitron-Black",
		url: "https://fonts.gstatic.com/s/orbitron/v19/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nysimxpmIyXjU1pg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HKJcRfjLIBYBB3FHB9bIuObe",
		family: "Orbitron",
		fullName: "Orbitron Regular",
		postScriptName: "Orbitron-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/iYOmjnzO6JOfhOYo3mnj8j82.png",
		style: "Orbitron-Regular",
		url: "https://fonts.gstatic.com/s/orbitron/v19/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6xpmIyXjU1pg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zQROyPAVbaIXti9cNH9ulo96",
		family: "Gluten",
		fullName: "Gluten Thin",
		postScriptName: "Gluten-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bTnZ_uVZzL8OM4lAz8VOGe5V.png",
		style: "Gluten-Thin",
		url: "https://fonts.gstatic.com/s/gluten/v4/HhyIU5gk9fW7OUdVIPh2wBPxSqQJ_zh3_DMrQqcdJrk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_XOQrhaQT_aQFjqnsm1Koz5HV",
		family: "Gluten",
		fullName: "Gluten ExtraLight",
		postScriptName: "Gluten-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jA72waAxFBoI0tthyf2V3ndi.png",
		style: "Gluten-ExtraLight",
		url: "https://fonts.gstatic.com/s/gluten/v4/HhyIU5gk9fW7OUdVIPh2wBPxSqQJ_7h2_DMrQqcdJrk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Xx5JZiaD8QTDHl6Yvv33VNgG",
		family: "Gluten",
		fullName: "Gluten Light",
		postScriptName: "Gluten-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vvi5AFKpHLNJ2Mlv2PMDK3vZ.png",
		style: "Gluten-Light",
		url: "https://fonts.gstatic.com/s/gluten/v4/HhyIU5gk9fW7OUdVIPh2wBPxSqQJ_2Z2_DMrQqcdJrk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7EgtgGyiHvj3JqSoD2RI_JKq",
		family: "Gluten",
		fullName: "Gluten Medium",
		postScriptName: "Gluten-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HEXo7WnUo5fjUQbLxpdUKFT_.png",
		style: "Gluten-Medium",
		url: "https://fonts.gstatic.com/s/gluten/v4/HhyIU5gk9fW7OUdVIPh2wBPxSqQJ_wp2_DMrQqcdJrk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IMT7YyLbIUiou2IVZbZ4iR1Q",
		family: "Gluten",
		fullName: "Gluten SemiBold",
		postScriptName: "Gluten-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_smSFsX49XPVkIuJhmrnyMb1.png",
		style: "Gluten-SemiBold",
		url: "https://fonts.gstatic.com/s/gluten/v4/HhyIU5gk9fW7OUdVIPh2wBPxSqQJ_-Zx_DMrQqcdJrk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5Hldt3cWHDst6w3KtbnXwuoV",
		family: "Gluten",
		fullName: "Gluten Bold",
		postScriptName: "Gluten-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/H_i_BcmDk9KZMO1KPbMYFm76.png",
		style: "Gluten-Bold",
		url: "https://fonts.gstatic.com/s/gluten/v4/HhyIU5gk9fW7OUdVIPh2wBPxSqQJ_99x_DMrQqcdJrk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5CPEgPBZOQuxPrDN_HaTELm8",
		family: "Gluten",
		fullName: "Gluten ExtraBold",
		postScriptName: "Gluten-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/60PLczv2ZFU9CZLfuFm_YnTk.png",
		style: "Gluten-ExtraBold",
		url: "https://fonts.gstatic.com/s/gluten/v4/HhyIU5gk9fW7OUdVIPh2wBPxSqQJ_7hx_DMrQqcdJrk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YJtAY6CqFpQJGerF9ieWqZyh",
		family: "Gluten",
		fullName: "Gluten Black",
		postScriptName: "Gluten-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/YXe_R3ATeowtFi6vthpePn8x.png",
		style: "Gluten-Black",
		url: "https://fonts.gstatic.com/s/gluten/v4/HhyIU5gk9fW7OUdVIPh2wBPxSqQJ_5Fx_DMrQqcdJrk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_sbxReBFUZLma_9XcwajbKBuJ",
		family: "Gluten",
		fullName: "Gluten Regular",
		postScriptName: "Gluten-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RX1Je8i8CRtasEoD4r6EZsVX.png",
		style: "Gluten-Regular",
		url: "https://fonts.gstatic.com/s/gluten/v4/HhyIU5gk9fW7OUdVIPh2wBPxSqQJ_zh2_DMrQqcdJrk.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ICUv7dkhyr29V7wXqDufisx8",
		family: "Hind",
		fullName: "Hind Light",
		postScriptName: "Hind-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ndeX3RsRj358W645QZyerpwN.png",
		style: "Hind-Light",
		url: "https://fonts.gstatic.com/s/hind/v11/5aU19_a8oxmIfMJaIRuYjDpf5Vw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tL9wppoiFsMreVq7d2I3s7la",
		family: "Hind",
		fullName: "Hind Medium",
		postScriptName: "Hind-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OAsCuivpFLAtDuEA7y8IrhXc.png",
		style: "Hind-Medium",
		url: "https://fonts.gstatic.com/s/hind/v11/5aU19_a8oxmIfJpbIRuYjDpf5Vw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_n2m1XpwTuElat_kYtX_gADfC",
		family: "Hind",
		fullName: "Hind SemiBold",
		postScriptName: "Hind-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/363P7v6mN5idbohYLASaKrWj.png",
		style: "Hind-SemiBold",
		url: "https://fonts.gstatic.com/s/hind/v11/5aU19_a8oxmIfLZcIRuYjDpf5Vw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_w3pcW_F2KOlfayDMCRNQg0bg",
		family: "Hind",
		fullName: "Hind Bold",
		postScriptName: "Hind-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lgmjGO5lGxicVHkaXc6HXnns.png",
		style: "Hind-Bold",
		url: "https://fonts.gstatic.com/s/hind/v11/5aU19_a8oxmIfNJdIRuYjDpf5Vw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HK8N1nLAnCzFGmVYpyz3Wd_g",
		family: "Hind",
		fullName: "Hind Regular",
		postScriptName: "Hind-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SP0ofODYDVf1xxnWkhDDMjvI.png",
		style: "Hind-Regular",
		url: "https://fonts.gstatic.com/s/hind/v11/5aU69_a8oxmIRG5yBROzkDM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dWU_hz7YsgJ1STDjJsbY5_3Z",
		family: "Hind Siliguri",
		fullName: "Hind Siliguri Light",
		postScriptName: "HindSiliguri-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BeDXRsBz0JFjBGudSZ3MiIvb.png",
		style: "HindSiliguri-Light",
		url: "https://fonts.gstatic.com/s/hindsiliguri/v7/ijwOs5juQtsyLLR5jN4cxBEoRDf44uEfKiGvxts.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_AUQn0jMabK39Ad2oDnegIt_P",
		family: "Hind Siliguri",
		fullName: "Hind Siliguri Medium",
		postScriptName: "HindSiliguri-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qGDMl4URCVe8c6_Sqg54OEhD.png",
		style: "HindSiliguri-Medium",
		url: "https://fonts.gstatic.com/s/hindsiliguri/v7/ijwOs5juQtsyLLR5jN4cxBEoRG_54uEfKiGvxts.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xIeCCSzqevcgOr0YcTAy81kT",
		family: "Hind Siliguri",
		fullName: "Hind Siliguri SemiBold",
		postScriptName: "HindSiliguri-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lighG2yi3KhncYzjHzCwHYoT.png",
		style: "HindSiliguri-SemiBold",
		url: "https://fonts.gstatic.com/s/hindsiliguri/v7/ijwOs5juQtsyLLR5jN4cxBEoREP-4uEfKiGvxts.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kcTcJ7DIaqazT70Wl0T9en6o",
		family: "Hind Siliguri",
		fullName: "Hind Siliguri Bold",
		postScriptName: "HindSiliguri-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wpdvyzmul3vgGxprp8dcVETA.png",
		style: "HindSiliguri-Bold",
		url: "https://fonts.gstatic.com/s/hindsiliguri/v7/ijwOs5juQtsyLLR5jN4cxBEoRCf_4uEfKiGvxts.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5z7cXfcnvxe0VD4vUXXLngs1",
		family: "Hind Siliguri",
		fullName: "Hind Siliguri Regular",
		postScriptName: "HindSiliguri-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/T4QJfsUstAq9p6kLOmQ0Czk5.png",
		style: "HindSiliguri-Regular",
		url: "https://fonts.gstatic.com/s/hindsiliguri/v7/ijwTs5juQtsyLLR5jN4cxBEofJvQxuk0Nig.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Aluj2ZZbDbV4C6i4mzZgS9ZR",
		family: "Indie Flower",
		fullName: "Indie Flower Regular",
		postScriptName: "IndieFlower",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3YDFz1tk3hI8lROSm445lDbY.png",
		style: "IndieFlower",
		url: "https://fonts.gstatic.com/s/indieflower/v12/m8JVjfNVeKWVnh3QMuKkFcZlbkGG1dKEDw.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lmUL_O1SYaVtYV36S28bL6YJ",
		family: "Karla",
		fullName: "Karla ExtraLight",
		postScriptName: "Karla-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OZboUgeaUK0W9Wlm_GlkzhFT.png",
		style: "Karla-ExtraLight",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBIXvYC6trAT55ZBi1ueQVIjQTDeJqqFENLR7fHGw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4AZsxiiiBqy2Mvd2o1m6hNjS",
		family: "Karla",
		fullName: "Karla Light",
		postScriptName: "Karla-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gxHXJlNGGV_3uNdtMC8tkmaT.png",
		style: "Karla-Light",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBIXvYC6trAT55ZBi1ueQVIjQTDppqqFENLR7fHGw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gSl7VYw9kN_vKo4IXc2WTkgg",
		family: "Karla",
		fullName: "Karla Medium",
		postScriptName: "Karla-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/eNbDRk0zskwfi3lcRTi9yTLH.png",
		style: "Karla-Medium",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBIXvYC6trAT55ZBi1ueQVIjQTDypqqFENLR7fHGw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_uSBTBvTYVP97YwTspZmOd3by",
		family: "Karla",
		fullName: "Karla SemiBold",
		postScriptName: "Karla-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zwpSTp5eUd44zhum06l1Cdt0.png",
		style: "Karla-SemiBold",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBIXvYC6trAT55ZBi1ueQVIjQTDJp2qFENLR7fHGw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4G7SQ4yeDJirPVHHMSaLu3Ha",
		family: "Karla",
		fullName: "Karla Bold",
		postScriptName: "Karla-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/11IaYM2tZVgDvtJ9oNQ_n2m5.png",
		style: "Karla-Bold",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBIXvYC6trAT55ZBi1ueQVIjQTDH52qFENLR7fHGw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9T6fScypEdo_wybAVKj_XRFp",
		family: "Karla",
		fullName: "Karla ExtraBold",
		postScriptName: "Karla-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/QgxOjkHbvFmSf21Me5VwRHws.png",
		style: "Karla-ExtraBold",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBIXvYC6trAT55ZBi1ueQVIjQTDeJ2qFENLR7fHGw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GLU1P3kyz3YhkINts82N0KRb",
		family: "Karla",
		fullName: "Karla Regular",
		postScriptName: "Karla-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HXfo2zSdlyHIe6wXxz1WtY0I.png",
		style: "Karla-Regular",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBIXvYC6trAT55ZBi1ueQVIjQTD-JqqFENLR7fHGw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_iKwzY0Y7jFno_xZgoynGOiiR",
		family: "Karla",
		fullName: "Karla ExtraLight Italic",
		postScriptName: "Karla-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qPAP9kNxP2MVreHGiqEAbyCO.png",
		style: "Karla-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNnCV0lPZbLXGxGR.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nwggHE3teaZ9H9sSj6A6T2Fo",
		family: "Karla",
		fullName: "Karla Light Italic",
		postScriptName: "Karla-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/GHG3FrG6zLivtpD23OgR3qi0.png",
		style: "Karla-LightItalic",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNkcV0lPZbLXGxGR.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_t1HC11Wtr7j5G8VilRViVuIk",
		family: "Karla",
		fullName: "Karla Italic",
		postScriptName: "Karla-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tUCeA2kQ4EqAZoja2jkTqsNf.png",
		style: "Karla-Italic",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNlCV0lPZbLXGxGR.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zxgEgPzS8VM_oPFLKtWutVzg",
		family: "Karla",
		fullName: "Karla Medium Italic",
		postScriptName: "Karla-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JNNCmPran8VmYntcJvfyAZk4.png",
		style: "Karla-MediumItalic",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNlwV0lPZbLXGxGR.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_LVhPG9dlxz84mFguI1MyZtvq",
		family: "Karla",
		fullName: "Karla SemiBold Italic",
		postScriptName: "Karla-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mxnSin4r_c0xWnRymg6D_uaG.png",
		style: "Karla-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNmcUElPZbLXGxGR.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_BMN1hUOQQwTVd6IXbdS2gKDI",
		family: "Karla",
		fullName: "Karla Bold Italic",
		postScriptName: "Karla-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NBQBHnYkwSM9lcO2PfxDnSqo.png",
		style: "Karla-BoldItalic",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNmlUElPZbLXGxGR.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tGF6mVQwqoQwrCt1iD_NEGyP",
		family: "Karla",
		fullName: "Karla ExtraBold Italic",
		postScriptName: "Karla-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qrvDYeW5Y_mH2OHgepraQ9yC.png",
		style: "Karla-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/karla/v15/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNnCUElPZbLXGxGR.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3EEj50CYEZIVXjgXTcrfZAWI",
		family: "Khand",
		fullName: "Khand Light",
		postScriptName: "Khand-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5XcZJOJ5eEXZu9Pb6PWAPkFE.png",
		style: "Khand-Light",
		url: "https://fonts.gstatic.com/s/khand/v9/TwMN-IINQlQQ0bL5cFE3ZwaH__-C.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_N9slf2hYuPK4nMgXhA8xz64d",
		family: "Khand",
		fullName: "Khand Medium",
		postScriptName: "Khand-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/PZRqa6WeLwsxsqsZyidrtRSI.png",
		style: "Khand-Medium",
		url: "https://fonts.gstatic.com/s/khand/v9/TwMN-IINQlQQ0bKhcVE3ZwaH__-C.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_p7rfGj_ryxi6jpksLQr8wS5X",
		family: "Khand",
		fullName: "Khand SemiBold",
		postScriptName: "Khand-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/l2u82upHJfAyZqwJzlgZzqmE.png",
		style: "Khand-SemiBold",
		url: "https://fonts.gstatic.com/s/khand/v9/TwMN-IINQlQQ0bKNdlE3ZwaH__-C.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_1cKxqg78egl1LkwntQYvEiLa",
		family: "Khand",
		fullName: "Khand Bold",
		postScriptName: "Khand-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/UMlFC22rm7nVZvQPWp_grhlT.png",
		style: "Khand-Bold",
		url: "https://fonts.gstatic.com/s/khand/v9/TwMN-IINQlQQ0bLpd1E3ZwaH__-C.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ubV_xlyi3vuGbb5FMExNEqBa",
		family: "Khand",
		fullName: "Khand Regular",
		postScriptName: "Khand-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ALZC0lUdoRfELwJp_qPaW696.png",
		style: "Khand-Regular",
		url: "https://fonts.gstatic.com/s/khand/v9/TwMA-IINQlQQ0YpVWHU_TBqO.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_sme6eVsGN9zv9Hh81jkIyAjH",
		family: "Lemonada",
		fullName: "Lemonada Light",
		postScriptName: "Lemonada-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MTiqMUCbGCs5SnTTIu9h13c5.png",
		style: "Lemonada-Light",
		url: "https://fonts.gstatic.com/s/lemonada/v14/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGJOt2mfWc3Z2pTg.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lbwPrZ9UlxlZZj0G2L6zLvna",
		family: "Lemonada",
		fullName: "Lemonada Medium",
		postScriptName: "Lemonada-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Q6KF_qvx86sirBfdBknY39tX.png",
		style: "Lemonada-Medium",
		url: "https://fonts.gstatic.com/s/lemonada/v14/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGSOt2mfWc3Z2pTg.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_B_cgojrHzRNpQ1UzQeFSiX0C",
		family: "Lemonada",
		fullName: "Lemonada SemiBold",
		postScriptName: "Lemonada-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/g4nxwJI7CzkQgdp9E9aYpfAp.png",
		style: "Lemonada-SemiBold",
		url: "https://fonts.gstatic.com/s/lemonada/v14/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGpOx2mfWc3Z2pTg.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FH1D_ovYEkWNWIqpeWe8Ddy6",
		family: "Lemonada",
		fullName: "Lemonada Bold",
		postScriptName: "Lemonada-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RSJLMEDIsOQ_ITDapOPV3cot.png",
		style: "Lemonada-Bold",
		url: "https://fonts.gstatic.com/s/lemonada/v14/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGnex2mfWc3Z2pTg.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NzH8DjHGTiVMBC1N2NV6wM1G",
		family: "Lemonada",
		fullName: "Lemonada Regular",
		postScriptName: "Lemonada-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/oMs146ULevjXNdH03Rm5EDff.png",
		style: "Lemonada-Regular",
		url: "https://fonts.gstatic.com/s/lemonada/v14/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGeut2mfWc3Z2pTg.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4z952pDw8UoEwd_wEoH8coN7",
		family: "Lexend Deca",
		fullName: "Lexend Deca Thin",
		postScriptName: "LexendDeca-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/38UFBo_AvVX2GTZKiC5627te.png",
		style: "LexendDeca-Thin",
		url: "https://fonts.gstatic.com/s/lexenddeca/v10/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U48MxArBPCqLNflg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0aWZ3CtN2RFSvU8HuP1JAcUM",
		family: "Lexend Deca",
		fullName: "Lexend Deca ExtraLight",
		postScriptName: "LexendDeca-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zQ4RqS8IcNCwQ0ggftsiCMih.png",
		style: "LexendDeca-ExtraLight",
		url: "https://fonts.gstatic.com/s/lexenddeca/v10/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4cM1ArBPCqLNflg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_I2XMX_310nPPJPeQyzeqdKft",
		family: "Lexend Deca",
		fullName: "Lexend Deca Light",
		postScriptName: "LexendDeca-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Mm99iKviAZADYNmz1l_k4oH5.png",
		style: "LexendDeca-Light",
		url: "https://fonts.gstatic.com/s/lexenddeca/v10/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4rs1ArBPCqLNflg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IAOsYkimNnhnWbAxBTjMQU8s",
		family: "Lexend Deca",
		fullName: "Lexend Deca Medium",
		postScriptName: "LexendDeca-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WsreXqBdgyaD3I4G6AubD_ws.png",
		style: "LexendDeca-Medium",
		url: "https://fonts.gstatic.com/s/lexenddeca/v10/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4ws1ArBPCqLNflg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_i3Lmbht5LVbPb6GJVx3LjkYj",
		family: "Lexend Deca",
		fullName: "Lexend Deca SemiBold",
		postScriptName: "LexendDeca-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/58c2HAArNWzHnTfxFZ3CvF4t.png",
		style: "LexendDeca-SemiBold",
		url: "https://fonts.gstatic.com/s/lexenddeca/v10/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4LspArBPCqLNflg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8frPyCRukcwj8DdYajtpbyFL",
		family: "Lexend Deca",
		fullName: "Lexend Deca Bold",
		postScriptName: "LexendDeca-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mY03ignEmqdI2AmdFyKIgkiK.png",
		style: "LexendDeca-Bold",
		url: "https://fonts.gstatic.com/s/lexenddeca/v10/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4F8pArBPCqLNflg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_aTR7d7w47t4Q4uwNLVNP5GsQ",
		family: "Lexend Deca",
		fullName: "Lexend Deca ExtraBold",
		postScriptName: "LexendDeca-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aCLZRosw207sWlXt4RM6Amf4.png",
		style: "LexendDeca-ExtraBold",
		url: "https://fonts.gstatic.com/s/lexenddeca/v10/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4cMpArBPCqLNflg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZOixHFHUcostshflHG_Z1zlC",
		family: "Lexend Deca",
		fullName: "Lexend Deca Black",
		postScriptName: "LexendDeca-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3fWmIIv_O9zZPiuI6IQiyBoF.png",
		style: "LexendDeca-Black",
		url: "https://fonts.gstatic.com/s/lexenddeca/v10/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4WcpArBPCqLNflg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__fwU5QUfQuy_LLf5S9lxGVDi",
		family: "Lexend Deca",
		fullName: "Lexend Deca Regular",
		postScriptName: "LexendDeca-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/33mPD0gZU7ZLc6ceCgDECRM7.png",
		style: "LexendDeca-Regular",
		url: "https://fonts.gstatic.com/s/lexenddeca/v10/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U48M1ArBPCqLNflg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kisyRVNh17ZhAE8pSvSej75Z",
		family: "Mada",
		fullName: "Mada ExtraLight",
		postScriptName: "Mada-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pZrALVEbYWKIV4u4aw7HSGCp.png",
		style: "Mada-ExtraLight",
		url: "https://fonts.gstatic.com/s/mada/v11/7Au_p_0qnzeSdf3nCCL8zkwMIFg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TpxoQDFVKlwVjXNgB1NH5K7t",
		family: "Mada",
		fullName: "Mada Light",
		postScriptName: "Mada-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ABkETh3bLoGFbzRNvFKjLzJC.png",
		style: "Mada-Light",
		url: "https://fonts.gstatic.com/s/mada/v11/7Au_p_0qnzeSdZnkCCL8zkwMIFg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MRslLJtEV6PAen0IM34U_9IO",
		family: "Mada",
		fullName: "Mada Medium",
		postScriptName: "Mada-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vjZhVoH8yl6p1pa3MqUN4DGK.png",
		style: "Mada-Medium",
		url: "https://fonts.gstatic.com/s/mada/v11/7Au_p_0qnzeSdcHlCCL8zkwMIFg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4YSCfntM0y91CBaEyshqan6_",
		family: "Mada",
		fullName: "Mada SemiBold",
		postScriptName: "Mada-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6sonY5u18U3d7bJhXdREV0VI.png",
		style: "Mada-SemiBold",
		url: "https://fonts.gstatic.com/s/mada/v11/7Au_p_0qnzeSde3iCCL8zkwMIFg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NHSA9HSguXYfYdZaGF8KatMD",
		family: "Mada",
		fullName: "Mada Bold",
		postScriptName: "Mada-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HJJofj26aCZohCyS4gcmYPpa.png",
		style: "Mada-Bold",
		url: "https://fonts.gstatic.com/s/mada/v11/7Au_p_0qnzeSdYnjCCL8zkwMIFg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fB4LNXobwSApMCR32AelcmQ6",
		family: "Mada",
		fullName: "Mada Black",
		postScriptName: "Mada-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fxbw454jGqdD1jmUy5uQldxm.png",
		style: "Mada-Black",
		url: "https://fonts.gstatic.com/s/mada/v11/7Au_p_0qnzeSdbHhCCL8zkwMIFg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_whlaG1TvEBdS2jcSuOblVQ71",
		family: "Mada",
		fullName: "Mada Regular",
		postScriptName: "Mada-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KKFrtscybXdFW7kZQPo3cvfU.png",
		style: "Mada-Regular",
		url: "https://fonts.gstatic.com/s/mada/v11/7Auwp_0qnzeSTTXMLCrX0kU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SCt6HFtBJ5W12Fdq4LhNLgwW",
		family: "Merriweather",
		fullName: "Merriweather Light",
		postScriptName: "Merriweather-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VgWZWv3rk9GgNxaVUD5hz1sE.png",
		style: "Merriweather-Light",
		url: "https://fonts.gstatic.com/s/merriweather/v27/u-4n0qyriQwlOrhSvowK_l521wRpX837pvjxPA.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Cqc_n1yQVwB01gqYTqzZQiwm",
		family: "Merriweather",
		fullName: "Merriweather Bold",
		postScriptName: "Merriweather-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kvcHEf60Zwn4l8CnyapC8Bgc.png",
		style: "Merriweather-Bold",
		url: "https://fonts.gstatic.com/s/merriweather/v27/u-4n0qyriQwlOrhSvowK_l52xwNpX837pvjxPA.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0F_6HYyAA90Rt9V1pgWFSvqm",
		family: "Merriweather",
		fullName: "Merriweather Black",
		postScriptName: "Merriweather-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/62MmHRWtzK643RARnOlNMFoT.png",
		style: "Merriweather-Black",
		url: "https://fonts.gstatic.com/s/merriweather/v27/u-4n0qyriQwlOrhSvowK_l52_wFpX837pvjxPA.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9mLPbI1fLXsCCgeLAMT5g3xS",
		family: "Merriweather",
		fullName: "Merriweather Light Italic",
		postScriptName: "Merriweather-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kD3SFtajvxaANGrH3Y04qqyp.png",
		style: "Merriweather-LightItalic",
		url: "https://fonts.gstatic.com/s/merriweather/v27/u-4l0qyriQwlOrhSvowK_l5-eR7lXcf_hP3hPGWH.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lZ1w_vXjRqIv9cMNIS8E6Fg2",
		family: "Merriweather",
		fullName: "Merriweather Regular",
		postScriptName: "Merriweather-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/S7R7CevR5pxBk_Px2d0t9eSQ.png",
		style: "Merriweather-Regular",
		url: "https://fonts.gstatic.com/s/merriweather/v27/u-440qyriQwlOrhSvowK_l5OeyxNV-bnrw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zjxpeyus38SJdOPRY0E8dnr9",
		family: "Merriweather",
		fullName: "Merriweather Italic",
		postScriptName: "Merriweather-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/naMlEcOWYT0oFiO2s0F6wDG0.png",
		style: "Merriweather-Italic",
		url: "https://fonts.gstatic.com/s/merriweather/v27/u-4m0qyriQwlOrhSvowK_l5-eSZJdeP3r-Ho.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_d7efo9M05orRaZwlknQn95Sg",
		family: "Merriweather",
		fullName: "Merriweather Bold Italic",
		postScriptName: "Merriweather-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/s_6xNR_DPgPaW9HbQ5g1WZnK.png",
		style: "Merriweather-BoldItalic",
		url: "https://fonts.gstatic.com/s/merriweather/v27/u-4l0qyriQwlOrhSvowK_l5-eR71Wsf_hP3hPGWH.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Vz_G8pQ96SwCEKOxvyapwsuR",
		family: "Merriweather",
		fullName: "Merriweather Black Italic",
		postScriptName: "Merriweather-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/47VYjbui9EQ_R4Q9Zdr_YT0v.png",
		style: "Merriweather-BlackItalic",
		url: "https://fonts.gstatic.com/s/merriweather/v27/u-4l0qyriQwlOrhSvowK_l5-eR7NWMf_hP3hPGWH.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_LC6SieXqvqPVwV5iiU6CPoCN",
		family: "Hammersmith One",
		fullName: "Hammersmith One Regular",
		postScriptName: "HammersmithOne-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RsDoneYHPgOStMGAmyCCMisl.png",
		style: "HammersmithOne-Regular",
		url: "https://fonts.gstatic.com/s/hammersmithone/v12/qWcyB624q4L_C4jGQ9IK0O_dFlnbshsks4MRXw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_N3uInsP9KWsnaZiTQISqGcYi",
		family: "Heebo",
		fullName: "Heebo Thin",
		postScriptName: "Heebo-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/C1Tmt0jkh6PdafHnVcXjfTIj.png",
		style: "Heebo-Thin",
		url: "https://fonts.gstatic.com/s/heebo/v12/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiS2cckOnz02SXQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8YmEkWyZpQ0Dhn7GIUmaJUDr",
		family: "Heebo",
		fullName: "Heebo ExtraLight",
		postScriptName: "Heebo-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ffyLdN_J_A9MKJZR9eoQfMPa.png",
		style: "Heebo-ExtraLight",
		url: "https://fonts.gstatic.com/s/heebo/v12/NGSpv5_NC0k9P_v6ZUCbLRAHxK1ECSycckOnz02SXQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0fwjeQDpIrQFCETPIiJqJVOF",
		family: "Heebo",
		fullName: "Heebo Light",
		postScriptName: "Heebo-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZsPr3RdPDnzwALkqYhst6aRX.png",
		style: "Heebo-Light",
		url: "https://fonts.gstatic.com/s/heebo/v12/NGSpv5_NC0k9P_v6ZUCbLRAHxK1E1yycckOnz02SXQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WFSqnWWyL2MDIs_w3A3DDBPs",
		family: "Heebo",
		fullName: "Heebo Medium",
		postScriptName: "Heebo-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/shBRCAWOBI582r5gKGNBizBA.png",
		style: "Heebo-Medium",
		url: "https://fonts.gstatic.com/s/heebo/v12/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EuyycckOnz02SXQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8NxYN_88mPFlPYckiXHN5vNZ",
		family: "Heebo",
		fullName: "Heebo SemiBold",
		postScriptName: "Heebo-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7ZP6A_B0zAfTiY7HWlFTHfak.png",
		style: "Heebo-SemiBold",
		url: "https://fonts.gstatic.com/s/heebo/v12/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EVyucckOnz02SXQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QQlEm2h_otAmiOmhAHNui5CR",
		family: "Heebo",
		fullName: "Heebo Bold",
		postScriptName: "Heebo-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1H0o29tWpwLb4PpeRA4yjfzR.png",
		style: "Heebo-Bold",
		url: "https://fonts.gstatic.com/s/heebo/v12/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EbiucckOnz02SXQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kpT8m3vyJEhtDgplZkoLjTk0",
		family: "Heebo",
		fullName: "Heebo ExtraBold",
		postScriptName: "Heebo-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qBBSKRdfrZe5Kv5cxxFtYKNa.png",
		style: "Heebo-ExtraBold",
		url: "https://fonts.gstatic.com/s/heebo/v12/NGSpv5_NC0k9P_v6ZUCbLRAHxK1ECSucckOnz02SXQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_yFzPS9hewpXfh7IjF_swroL6",
		family: "Heebo",
		fullName: "Heebo Black",
		postScriptName: "Heebo-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5gBOYiiHL9I1LgaYtkPXWUsm.png",
		style: "Heebo-Black",
		url: "https://fonts.gstatic.com/s/heebo/v12/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EICucckOnz02SXQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pngV5gnd8Fl2WhqMjTSHg7gw",
		family: "Heebo",
		fullName: "Heebo Regular",
		postScriptName: "Heebo-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lBAnQMK2wvR8OATt8rW53Hl7.png",
		style: "Heebo-Regular",
		url: "https://fonts.gstatic.com/s/heebo/v12/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSycckOnz02SXQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hbrMg0Ov2VNIFGu0tZ0UQ_KB",
		family: "Libre Baskerville",
		fullName: "Libre Baskerville Bold",
		postScriptName: "LibreBaskerville-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hgIESp20sDJypoOHtsuFQWNa.png",
		style: "LibreBaskerville-Bold",
		url: "https://fonts.gstatic.com/s/librebaskerville/v9/kmKiZrc3Hgbbcjq75U4uslyuy4kn0qviTjYwI8Gcw6Oi.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SMYnD_4dnmuiVffEfMEOrbMz",
		family: "Libre Baskerville",
		fullName: "Libre Baskerville Regular",
		postScriptName: "LibreBaskerville-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nUPL_ePA1eovuvcEQrA2RZA9.png",
		style: "LibreBaskerville-Regular",
		url: "https://fonts.gstatic.com/s/librebaskerville/v9/kmKnZrc3Hgbbcjq75U4uslyuy4kn0pNeYRI4CN2V.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zsk8eDnxsdRpf55Lmb6DbBoQ",
		family: "Libre Baskerville",
		fullName: "Libre Baskerville Italic",
		postScriptName: "LibreBaskerville-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/CcxO1dQ8NJv43kdS0oh_ja85.png",
		style: "LibreBaskerville-Italic",
		url: "https://fonts.gstatic.com/s/librebaskerville/v9/kmKhZrc3Hgbbcjq75U4uslyuy4kn0qNcaxYaDc2V2ro.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dFd_dy2fddZDJPhzAsXzy12c",
		family: "Oswald",
		fullName: "Oswald ExtraLight",
		postScriptName: "Oswald-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uw2ifI7jkXuscR7dg1k0VRWb.png",
		style: "Oswald-ExtraLight",
		url: "https://fonts.gstatic.com/s/oswald/v40/TK3_WkUHHAIjg75cFRf3bXL8LICs13FvgUFoZAaRliE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lmVnbTt5xHCUEfvHryrBmTJp",
		family: "Oswald",
		fullName: "Oswald Light",
		postScriptName: "Oswald-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/So4455SCk1MUXmsCpNIUh7VY.png",
		style: "Oswald-Light",
		url: "https://fonts.gstatic.com/s/oswald/v40/TK3_WkUHHAIjg75cFRf3bXL8LICs169vgUFoZAaRliE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7Tt0BFIAa8xzQmT2X0OzBKDb",
		family: "Oswald",
		fullName: "Oswald Medium",
		postScriptName: "Oswald-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mk2630WcApcpiHkriEpunTdd.png",
		style: "Oswald-Medium",
		url: "https://fonts.gstatic.com/s/oswald/v40/TK3_WkUHHAIjg75cFRf3bXL8LICs18NvgUFoZAaRliE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kG1DO8Z89G36Tdx1ozonrWrs",
		family: "Oswald",
		fullName: "Oswald SemiBold",
		postScriptName: "Oswald-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Y_RrXsX2F2MzCkTV4cHLeIyd.png",
		style: "Oswald-SemiBold",
		url: "https://fonts.gstatic.com/s/oswald/v40/TK3_WkUHHAIjg75cFRf3bXL8LICs1y9ogUFoZAaRliE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QV9P_MbcJ_5Ein9DsRcT2CVt",
		family: "Oswald",
		fullName: "Oswald Bold",
		postScriptName: "Oswald-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hCcmOCW6L7w_bA0ZkV3yBwQi.png",
		style: "Oswald-Bold",
		url: "https://fonts.gstatic.com/s/oswald/v40/TK3_WkUHHAIjg75cFRf3bXL8LICs1xZogUFoZAaRliE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NnHUhV42ROjdKIXxjaAIoYZL",
		family: "Oswald",
		fullName: "Oswald Regular",
		postScriptName: "Oswald-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IyBMYvpUIMyiLAxmKVgCcTP_.png",
		style: "Oswald-Regular",
		url: "https://fonts.gstatic.com/s/oswald/v40/TK3_WkUHHAIjg75cFRf3bXL8LICs1_FvgUFoZAaRliE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fFuP0zAMyoS3CU9MRWEOh7Li",
		family: "Oxygen",
		fullName: "Oxygen Light",
		postScriptName: "Oxygen-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3rcS6wsjRpeQXczDyV_NAELA.png",
		style: "Oxygen-Light",
		url: "https://fonts.gstatic.com/s/oxygen/v10/2sDcZG1Wl4LcnbuCJW8Db2-4C7wFZQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GfxEyMpz4hTmUd776zc5BBkN",
		family: "Oxygen",
		fullName: "Oxygen Bold",
		postScriptName: "Oxygen-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HUBON8dQHFYEqOVpJngFSJMa.png",
		style: "Oxygen-Bold",
		url: "https://fonts.gstatic.com/s/oxygen/v10/2sDcZG1Wl4LcnbuCNWgDb2-4C7wFZQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_J9nUuv5pfomKLXUjzkAHgQB1",
		family: "Oxygen",
		fullName: "Oxygen Regular",
		postScriptName: "Oxygen-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rn0sVKkOtgFq6UGb5ogCA1p6.png",
		style: "Oxygen-Regular",
		url: "https://fonts.gstatic.com/s/oxygen/v10/2sDfZG1Wl4Lcnbu6iUcnZ0SkAg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SV1I9Dk2Ry85Rf9Qsetatn0Z",
		family: "Pathway Gothic One",
		fullName: "Pathway Gothic One Regular",
		postScriptName: "PathwayGothicOne-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lMJTYp81WtYkIVo5WiKDUIDW.png",
		style: "PathwayGothicOne-Regular",
		url: "https://fonts.gstatic.com/s/pathwaygothicone/v9/MwQrbgD32-KAvjkYGNUUxAtW7pEBwx-dTFxeb80flQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_rvH_MV0Vw5SCCoAKCGNdXgLO",
		family: "Patrick Hand",
		fullName: "Patrick Hand Regular",
		postScriptName: "PatrickHand-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tj7qmgywuFEkuY265IDoXlL1.png",
		style: "PatrickHand-Regular",
		url: "https://fonts.gstatic.com/s/patrickhand/v14/LDI1apSQOAYtSuYWp8ZhfYeMWcjKm7sp8g.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9kfXbuEdB0tQ6czqW7TskjHH",
		family: "Istok Web",
		fullName: "Istok Web Bold",
		postScriptName: "IstokWeb-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8yESexNEhQgByKFtOSnjKFF9.png",
		style: "IstokWeb-Bold",
		url: "https://fonts.gstatic.com/s/istokweb/v15/3qTqojGmgSyUukBzKslhvU5a_mkUYBfcMw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ET08dvujB4KsgcGWWLgL3_3u",
		family: "Istok Web",
		fullName: "Istok Web Regular",
		postScriptName: "IstokWeb-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6TU7Ff_2qFaQMeXuYYMmXZcr.png",
		style: "IstokWeb-Regular",
		url: "https://fonts.gstatic.com/s/istokweb/v15/3qTvojGmgSyUukBzKslZAWF-9kIIaQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Dno18B0eIm3AFCHI6UCV066E",
		family: "Istok Web",
		fullName: "Istok Web Italic",
		postScriptName: "IstokWeb-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IK7eMP7VEwTGqjEPyMZOI5a3.png",
		style: "IstokWeb-Italic",
		url: "https://fonts.gstatic.com/s/istokweb/v15/3qTpojGmgSyUukBzKslpA2t61EcYaQ7F.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Jh5WBVW0nb6LybRtkPBQF4ZV",
		family: "Istok Web",
		fullName: "Istok Web Bold Italic",
		postScriptName: "IstokWeb-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AQXmtkj0MBpu4Hzkw7o1WDnJ.png",
		style: "IstokWeb-BoldItalic",
		url: "https://fonts.gstatic.com/s/istokweb/v15/3qT0ojGmgSyUukBzKslpA1PG-2MQQhLMMygN.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WZDJX3wQncovsTM2v4qf1PYH",
		family: "Kreon",
		fullName: "Kreon Light",
		postScriptName: "Kreon-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ODn8XaAXVAoaS17WMfueJHoj.png",
		style: "Kreon-Light",
		url: "https://fonts.gstatic.com/s/kreon/v27/t5t9IRIUKY-TFF_LW5lnMR3v2DnvPNimejUfp2dWNg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_J2a0ITyVfkdVdFr3R37PBf5j",
		family: "Kreon",
		fullName: "Kreon Medium",
		postScriptName: "Kreon-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AylsMIYWTT5dDaDYqkrMonUY.png",
		style: "Kreon-Medium",
		url: "https://fonts.gstatic.com/s/kreon/v27/t5t9IRIUKY-TFF_LW5lnMR3v2DnvUNimejUfp2dWNg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EshHWiUlfH4_r85v1TUL6he_",
		family: "Kreon",
		fullName: "Kreon SemiBold",
		postScriptName: "Kreon-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7nMCTJTqeQrnxEuE2c_5pyXz.png",
		style: "Kreon-SemiBold",
		url: "https://fonts.gstatic.com/s/kreon/v27/t5t9IRIUKY-TFF_LW5lnMR3v2DnvvN-mejUfp2dWNg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wsNnWYJEUXrABZjJaUZTHOIp",
		family: "Kreon",
		fullName: "Kreon Bold",
		postScriptName: "Kreon-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZpYE5tR9MvtFnkDuwNw9D6PM.png",
		style: "Kreon-Bold",
		url: "https://fonts.gstatic.com/s/kreon/v27/t5t9IRIUKY-TFF_LW5lnMR3v2Dnvhd-mejUfp2dWNg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4CeVRPhm0M3lA7OVoR1oFI7V",
		family: "Kreon",
		fullName: "Kreon Regular",
		postScriptName: "Kreon-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FGgb0l8esG6ZZCDn2clMo4Pl.png",
		style: "Kreon-Regular",
		url: "https://fonts.gstatic.com/s/kreon/v27/t5t9IRIUKY-TFF_LW5lnMR3v2DnvYtimejUfp2dWNg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_piS7O7VqtVyGHvScr1kbXIWF",
		family: "Metal Mania",
		fullName: "Metal Mania Regular",
		postScriptName: "MetalMania-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/iOWK0Q8zA0ZpLRD4NTdum1UT.png",
		style: "MetalMania-Regular",
		url: "https://fonts.gstatic.com/s/metalmania/v12/RWmMoKWb4e8kqMfBUdPFJeXCg6UKDXlq.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_BdjdlIjL26gSUySwxdyfSUzf",
		family: "Monofett",
		fullName: "Monofett Regular",
		postScriptName: "Monofett",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vYnLdTrN1iCTHMsXLb4oUzTe.png",
		style: "Monofett",
		url: "https://fonts.gstatic.com/s/monofett/v12/mFTyWbofw6zc9NtnW43SuRwr0VJ7.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3Vyk7Bgao0aCMCB8A0ktiTxA",
		family: "Montserrat",
		fullName: "Montserrat Thin",
		postScriptName: "Montserrat-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1hPwfx78PPtP_XXMNvGqYLmk.png",
		style: "Montserrat-Thin",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUQjIg1_i6t8kCHKm45_QphziTn89dtpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_59up95B6HILppM3eoAH4Eaqo",
		family: "Montserrat",
		fullName: "Montserrat ExtraLight",
		postScriptName: "Montserrat-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/UsT7biEWwO2UUM9SCfWvhHT9.png",
		style: "Montserrat-ExtraLight",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTURjIg1_i6t8kCHKm45_aZA7g7J_950vCo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_l70f93QcZtYMb_8mtpEvYkMv",
		family: "Montserrat",
		fullName: "Montserrat Light",
		postScriptName: "Montserrat-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/g5IG0XrXLWTLJ5Tac3zPCC4X.png",
		style: "Montserrat-Light",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTURjIg1_i6t8kCHKm45_cJD7g7J_950vCo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Ww1hnS1hVgvxI1FpnXFtJmXq",
		family: "Montserrat",
		fullName: "Montserrat Medium",
		postScriptName: "Montserrat-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bQ7E6ayOohpVoYNUOduYqn3j.png",
		style: "Montserrat-Medium",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTURjIg1_i6t8kCHKm45_ZpC7g7J_950vCo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_M0WNG8PVkRUAoLugx0ZSegcr",
		family: "Montserrat",
		fullName: "Montserrat SemiBold",
		postScriptName: "Montserrat-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uQFqEOjBzMbTsCTvl_DtUYEg.png",
		style: "Montserrat-SemiBold",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTURjIg1_i6t8kCHKm45_bZF7g7J_950vCo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_aNQO8ucjlWQKeVzISsri5v9u",
		family: "Montserrat",
		fullName: "Montserrat Bold",
		postScriptName: "Montserrat-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4gGaLmtHbDpgRuuNCjqMvw8u.png",
		style: "Montserrat-Bold",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTURjIg1_i6t8kCHKm45_dJE7g7J_950vCo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3q_5GsQHQZGxfZNRq3WmbEu5",
		family: "Montserrat",
		fullName: "Montserrat ExtraBold",
		postScriptName: "Montserrat-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Jt6xJ7jci1UxfGCT55Lgv3uf.png",
		style: "Montserrat-ExtraBold",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTURjIg1_i6t8kCHKm45_c5H7g7J_950vCo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nrbQ4t6Zns9FhjxoyUs_r_8Q",
		family: "Montserrat",
		fullName: "Montserrat Black",
		postScriptName: "Montserrat-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/33cIxP0i457XaADt_m5t2NoU.png",
		style: "Montserrat-Black",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTURjIg1_i6t8kCHKm45_epG7g7J_950vCo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WRDzTdVEWdZVNLrCTKJuKQmF",
		family: "Montserrat",
		fullName: "Montserrat Thin Italic",
		postScriptName: "Montserrat-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NkcJAPZGkQjsQLJLchXBh7Ik.png",
		style: "Montserrat-ThinItalic",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUOjIg1_i6t8kCHKm459WxZqi7j0dJ9pTOi.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_w2_55A9b7TLDvLwQK1Kh58Cr",
		family: "Montserrat",
		fullName: "Montserrat ExtraLight Italic",
		postScriptName: "Montserrat-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JR7IDRYjshwkjih_R8c9J232.png",
		style: "Montserrat-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUPjIg1_i6t8kCHKm459WxZBg_D-_xxrCq7qg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FXcCQM53mRLXyBPseem9fyeL",
		family: "Montserrat",
		fullName: "Montserrat Light Italic",
		postScriptName: "Montserrat-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9chvAJigMGtbaDe_hlzKTjJD.png",
		style: "Montserrat-LightItalic",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUPjIg1_i6t8kCHKm459WxZYgzD-_xxrCq7qg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_u4LrzTALngPZFGyUTlVnzgIq",
		family: "Montserrat",
		fullName: "Montserrat Regular",
		postScriptName: "Montserrat-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VcUNRjy0N1V3fwhIXj2tKZk1.png",
		style: "Montserrat-Regular",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUSjIg1_i6t8kCHKm45xW5rygbi49c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_mPD5RVsXj4mQH5zJOOCvgCaK",
		family: "Montserrat",
		fullName: "Montserrat Italic",
		postScriptName: "Montserrat-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RCtV2hRvv89YZExb3PJfu_J3.png",
		style: "Montserrat-Italic",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUQjIg1_i6t8kCHKm459WxhziTn89dtpQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KnmXi8XvYutZS13rELl5DbLe",
		family: "Montserrat",
		fullName: "Montserrat Medium Italic",
		postScriptName: "Montserrat-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/XLdH9vZ0pPs2445qXpX2boCN.png",
		style: "Montserrat-MediumItalic",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUPjIg1_i6t8kCHKm459WxZOg3D-_xxrCq7qg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vKf9jpE7VJKq6qsbpwn4Cya4",
		family: "Montserrat",
		fullName: "Montserrat SemiBold Italic",
		postScriptName: "Montserrat-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7MJjYXJQAXVoav9BRDKHTv6o.png",
		style: "Montserrat-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUPjIg1_i6t8kCHKm459WxZFgrD-_xxrCq7qg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_rsV2d2vsF5xWX2LGhG51MERu",
		family: "Montserrat",
		fullName: "Montserrat Bold Italic",
		postScriptName: "Montserrat-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Fxh89sIypOwCNxgUCPsDFkZD.png",
		style: "Montserrat-BoldItalic",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUPjIg1_i6t8kCHKm459WxZcgvD-_xxrCq7qg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_j1b5wUp0InzXCJTCncDc_Nyb",
		family: "Montserrat",
		fullName: "Montserrat ExtraBold Italic",
		postScriptName: "Montserrat-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ocKVO8rZwzYx79R8Y6FSU0kY.png",
		style: "Montserrat-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUPjIg1_i6t8kCHKm459WxZbgjD-_xxrCq7qg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_yszBUvRXdpxjwyJs_CXlbMOQ",
		family: "Montserrat",
		fullName: "Montserrat Black Italic",
		postScriptName: "Montserrat-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hZ3XULlUwbDTuft_UWyRtgPH.png",
		style: "Montserrat-BlackItalic",
		url: "https://fonts.gstatic.com/s/montserrat/v18/JTUPjIg1_i6t8kCHKm459WxZSgnD-_xxrCq7qg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nR5qawOIqgpke1dTW9OPVXg0",
		family: "Neucha",
		fullName: "Neucha Regular",
		postScriptName: "Neucha",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hdNVAfcyD1_gh56ow1WCCMcu.png",
		style: "Neucha",
		url: "https://fonts.gstatic.com/s/neucha/v12/q5uGsou0JOdh94bvugNsCxVEgA.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_mA0jlAFmlQj5Y0CJe_OaIgZ0",
		family: "Gudea",
		fullName: "Gudea Bold",
		postScriptName: "Gudea-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ieA4AgnL9vLnNFUtBlqFMyst.png",
		style: "Gudea-Bold",
		url: "https://fonts.gstatic.com/s/gudea/v10/neIIzCqgsI0mp9gz26WGHK06UY30.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_08utwDgoRG7ALItipn38iNNf",
		family: "Gudea",
		fullName: "Gudea Regular",
		postScriptName: "Gudea",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IqgBrPtCxBhYWkGy0dm7sofK.png",
		style: "Gudea",
		url: "https://fonts.gstatic.com/s/gudea/v10/neIFzCqgsI0mp-CP9IGON7Ez.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_DM6ySU9Cv64I4YoCs4F9tuav",
		family: "Gudea",
		fullName: "Gudea Italic",
		postScriptName: "Gudea-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jdohH_NDXiu28FFGuTjxtGCA.png",
		style: "Gudea-Italic",
		url: "https://fonts.gstatic.com/s/gudea/v10/neILzCqgsI0mp9CN_oWsMqEzSJQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_G0zS77tatFX4AU8CElGFz3N_",
		family: "Inconsolata",
		fullName: "Inconsolata ExtraLight",
		postScriptName: "Inconsolata-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/urrpye2DkTTLUCJ0_mt6DOki.png",
		style: "Inconsolata-ExtraLight",
		url: "https://fonts.gstatic.com/s/inconsolata/v21/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7LppwU8aRr8lleY2co.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_71SGYOGV8t3d6wpXK4DN0_wN",
		family: "Inconsolata",
		fullName: "Inconsolata Light",
		postScriptName: "Inconsolata-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nPXsF34X3ItunYvcAJISGthE.png",
		style: "Inconsolata-Light",
		url: "https://fonts.gstatic.com/s/inconsolata/v21/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp9s8aRr8lleY2co.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_sGm3bwC2aS2NR0KDM00IZJTI",
		family: "Inconsolata",
		fullName: "Inconsolata Medium",
		postScriptName: "Inconsolata-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vuR3aFRMv7UMui5cLbdd8_o_.png",
		style: "Inconsolata-Medium",
		url: "https://fonts.gstatic.com/s/inconsolata/v21/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp7c8aRr8lleY2co.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_mJKtIPmWaFHpiFNiefdFoPCY",
		family: "Inconsolata",
		fullName: "Inconsolata SemiBold",
		postScriptName: "Inconsolata-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JbYv7uyiIv8VeQhTH01Xf_vo.png",
		style: "Inconsolata-SemiBold",
		url: "https://fonts.gstatic.com/s/inconsolata/v21/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp1s7aRr8lleY2co.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_OqdnvPr0_5FlZWdVRIaxOrF2",
		family: "Inconsolata",
		fullName: "Inconsolata Bold",
		postScriptName: "Inconsolata-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZXyT0XOC_tWDnxZPCLuot9wu.png",
		style: "Inconsolata-Bold",
		url: "https://fonts.gstatic.com/s/inconsolata/v21/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp2I7aRr8lleY2co.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dr0bNk8Hl7K6AtHYskKe6LJ3",
		family: "Inconsolata",
		fullName: "Inconsolata ExtraBold",
		postScriptName: "Inconsolata-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/eo3i7YGM88eghRACoByI6ijv.png",
		style: "Inconsolata-ExtraBold",
		url: "https://fonts.gstatic.com/s/inconsolata/v21/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7LppwU7aRr8lleY2co.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3o0t4JKmzmhhGuJJCmO5Ptnc",
		family: "Inconsolata",
		fullName: "Inconsolata Black",
		postScriptName: "Inconsolata-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lVtBPj_Xurjjfx4OsyMAx6oX.png",
		style: "Inconsolata-Black",
		url: "https://fonts.gstatic.com/s/inconsolata/v21/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lppyw7aRr8lleY2co.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_q_Uf5tp1R3C79qcGCnsOqVXM",
		family: "Inconsolata",
		fullName: "Inconsolata Regular",
		postScriptName: "Inconsolata-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/yYnocTYYOZFDUXAyg6WdMoAs.png",
		style: "Inconsolata-Regular",
		url: "https://fonts.gstatic.com/s/inconsolata/v21/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp4U8aRr8lleY2co.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kS16lfUn6nVr5roQFLLPQKn8",
		family: "Magra",
		fullName: "Magra Bold",
		postScriptName: "Magra-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VuvaEjQDHAc8sRhQoDXEfdNl.png",
		style: "Magra-Bold",
		url: "https://fonts.gstatic.com/s/magra/v9/uK_w4ruaZus72nbNDxcXEPuUX1ow.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gydkn58BsyXn9OaRrWr_OGRT",
		family: "Magra",
		fullName: "Magra Regular",
		postScriptName: "Magra",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NFjJtfIw8pbjNQqrWiEoudHk.png",
		style: "Magra",
		url: "https://fonts.gstatic.com/s/magra/v9/uK_94ruaZus72k5xIDMfO-ed.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_weKdwN7U7zriPglekfGSU_j0",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans Light",
		postScriptName: "MerriweatherSans-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/dvKwMSZOS_8m3K5wJPJukOuV.png",
		style: "MerriweatherSans-Light",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZ_O4ljuEG7xFHnQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PAg5HwRKDvSszSll923BENsK",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans Medium",
		postScriptName: "MerriweatherSans-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/dXmRTBiScisU3keOBgORoGCy.png",
		style: "MerriweatherSans-Medium",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZkO4ljuEG7xFHnQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_V_p9luc3YD6DHwy1Xn7zN2EH",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans SemiBold",
		postScriptName: "MerriweatherSans-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ifmi96t7PlzVZf7EVagJaW2z.png",
		style: "MerriweatherSans-SemiBold",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZfOkljuEG7xFHnQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_2AsTydTVd9r5RHN4DZtl_ZnR",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans Bold",
		postScriptName: "MerriweatherSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OCfrMKHwt4dgC4WMp2TQsJpo.png",
		style: "MerriweatherSans-Bold",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZRekljuEG7xFHnQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Gkej3bhV3czPtAScQs_Szxg5",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans ExtraBold",
		postScriptName: "MerriweatherSans-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/B3luE8oYZfrOshitNAzwkqgR.png",
		style: "MerriweatherSans-ExtraBold",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZIukljuEG7xFHnQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WJBjtAAo37aLyS28eDeDzQuS",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans Regular",
		postScriptName: "MerriweatherSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/PzVCxDpXWW0pKGFIMcRL7BSh.png",
		style: "MerriweatherSans-Regular",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZou4ljuEG7xFHnQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0hpW8zu_GfsrY5rDCfaT3bDV",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans Light Italic",
		postScriptName: "MerriweatherSans-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/b5Yhw1pRFqsRz0CxE5gj3j_9.png",
		style: "MerriweatherSans-LightItalic",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq2TzesCzRRXnaur.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_36UPkMPWGek_wjYVE9wO74MQ",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans Italic",
		postScriptName: "MerriweatherSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/96BJTwzITvyaaalQTxUQLvcu.png",
		style: "MerriweatherSans-Italic",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq3NzesCzRRXnaur.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_eyC9l8uK6UGalSVFK3cC2o7D",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans Medium Italic",
		postScriptName: "MerriweatherSans-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/dPsBbp_pbuaS7SfccUXNJZAw.png",
		style: "MerriweatherSans-MediumItalic",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq3_zesCzRRXnaur.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6JVAjBs9jc_qdNHSZVn3Z5yn",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans SemiBold Italic",
		postScriptName: "MerriweatherSans-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OGwgDKGjKTZ_OXiAtRVbbBzO.png",
		style: "MerriweatherSans-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq0TyusCzRRXnaur.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lff9CQfFwsFFDA6kkKnghFg3",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans Bold Italic",
		postScriptName: "MerriweatherSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/z4dAxO1yFPMIumBlQR2DoG1o.png",
		style: "MerriweatherSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq0qyusCzRRXnaur.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_LydQ147AgYvXGrEAHI70SzWW",
		family: "Merriweather Sans",
		fullName: "Merriweather Sans ExtraBold Italic",
		postScriptName: "MerriweatherSans-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uai408fGu33fiVJl1RVMXTv9.png",
		style: "MerriweatherSans-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/merriweathersans/v14/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq1NyusCzRRXnaur.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nphpowoX7wgYx1HaapvjIPvD",
		family: "Nobile",
		fullName: "Nobile Medium",
		postScriptName: "Nobile-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Dcu66fQ5S50UO5btox_VttyV.png",
		style: "Nobile-Medium",
		url: "https://fonts.gstatic.com/s/nobile/v12/m8JQjflSeaOVl1iOqo7zcJ5BZmqa3A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Xy43U40_9XK2IAvrui1nwSL4",
		family: "Nobile",
		fullName: "Nobile Bold",
		postScriptName: "Nobile-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/h6uMR4joIJXogy819DrxMQid.png",
		style: "Nobile-Bold",
		url: "https://fonts.gstatic.com/s/nobile/v12/m8JQjflSeaOVl1iO4ojzcJ5BZmqa3A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kFcBbn4ZiP4Dh4QY_fuzfroB",
		family: "Nobile",
		fullName: "Nobile Regular",
		postScriptName: "Nobile-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8EJrA9pp4Ja0VENnf2ZKPrQa.png",
		style: "Nobile-Regular",
		url: "https://fonts.gstatic.com/s/nobile/v12/m8JTjflSeaOVl1i2XqfXeLVdbw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_28vyLIxbbRz8QfulqjOygutF",
		family: "Nobile",
		fullName: "Nobile Italic",
		postScriptName: "Nobile-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/21UHaZ5OKTYdmX9U8EVFj4Nb.png",
		style: "Nobile-Italic",
		url: "https://fonts.gstatic.com/s/nobile/v12/m8JRjflSeaOVl1iGXK3TWrBNb3OD.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_LvXeXkiv6UoOpWtcmnDgULlm",
		family: "Nobile",
		fullName: "Nobile Medium Italic",
		postScriptName: "Nobile-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SMxt1PXLZZb5msgsU3o6Uokg.png",
		style: "Nobile-MediumItalic",
		url: "https://fonts.gstatic.com/s/nobile/v12/m8JWjflSeaOVl1iGXJUnc5RFRG-K3Mud.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4iNHo1mQqOd1Z6AhsKLx74x0",
		family: "Nobile",
		fullName: "Nobile Bold Italic",
		postScriptName: "Nobile-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VE46mxzMnDu7XPcVP__NYIbc.png",
		style: "Nobile-BoldItalic",
		url: "https://fonts.gstatic.com/s/nobile/v12/m8JWjflSeaOVl1iGXJVvdZRFRG-K3Mud.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EWpyreE1U2Fj94i_kQ63wY9m",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Thin",
		postScriptName: "IBMPlexSans-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vnbDG3aBVZYGgC69Y_17hIa0.png",
		style: "IBMPlexSans-Thin",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX-KVElMYYaJe8bpLHnCwDKjbLeEKxIedbzDw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MOOBhYgGMYENW0XycYioqkbm",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans ExtraLight",
		postScriptName: "IBMPlexSans-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8dEPST6_U84qVojuiveJ1ndS.png",
		style: "IBMPlexSans-ExtraLight",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX9KVElMYYaJe8bpLHnCwDKjR7_MIZmdd_qFmo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PUrJ6hA09VhC9KPobJwACIWP",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Light",
		postScriptName: "IBMPlexSans-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nJvLYEq0sAtm0sFrYqng3yni.png",
		style: "IBMPlexSans-Light",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX9KVElMYYaJe8bpLHnCwDKjXr8MIZmdd_qFmo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_oituB1dJfpbgQhy27OW8ohNa",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Medium",
		postScriptName: "IBMPlexSans-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BapGI6AkpJgm6f2OTUZjCp85.png",
		style: "IBMPlexSans-Medium",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX9KVElMYYaJe8bpLHnCwDKjSL9MIZmdd_qFmo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vNAaKqubLZfirSQFX4niYpf5",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans SemiBold",
		postScriptName: "IBMPlexSans-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RgxQfYd_tgCN6PpRFrG0KPkw.png",
		style: "IBMPlexSans-SemiBold",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX9KVElMYYaJe8bpLHnCwDKjQ76MIZmdd_qFmo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Rhx0nMytC7VTvOMWAo0KGfhL",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Bold",
		postScriptName: "IBMPlexSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LNxnylfA3vgHiL8EOIjoS1PO.png",
		style: "IBMPlexSans-Bold",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX9KVElMYYaJe8bpLHnCwDKjWr7MIZmdd_qFmo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_eJu1qnpYK40oJHWq6CGyK2MA",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Thin Italic",
		postScriptName: "IBMPlexSans-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/TByXarcyefWg1EbvD0edrPqg.png",
		style: "IBMPlexSans-ThinItalic",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX8KVElMYYaJe8bpLHnCwDKhdTmdKZMW9PjD3N8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZvhuR6ffBv6efu6Lo461xIny",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans ExtraLight Italic",
		postScriptName: "IBMPlexSans-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/v9fr4xhjnsIVNCnNMDZoeKHN.png",
		style: "IBMPlexSans-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX7KVElMYYaJe8bpLHnCwDKhdTm2Idscf3vBmpl8A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZjFRPjgImqQGQWWY8eDwNvjZ",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Light Italic",
		postScriptName: "IBMPlexSans-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BedBSsClhGGrIQ1ZI8vCKrT3.png",
		style: "IBMPlexSans-LightItalic",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX7KVElMYYaJe8bpLHnCwDKhdTmvIRscf3vBmpl8A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WVXuBXPqiZFpRNjurH5xyPrb",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Regular",
		postScriptName: "IBMPlexSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WHDRyqZTBVBsM_l2ggptsjvL.png",
		style: "IBMPlexSans-Regular",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYXgKVElMYYaJe8bpLHnCwDKtdbUFI5NadY.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QyYlR0bKEsbjMCX0jvPR705i",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Italic",
		postScriptName: "IBMPlexSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fHQFG4Q1FMP0b4YuXp94QJVf.png",
		style: "IBMPlexSans-Italic",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX-KVElMYYaJe8bpLHnCwDKhdTeEKxIedbzDw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_RJxugZPVQG_qHWfIUmdAAmjz",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Medium Italic",
		postScriptName: "IBMPlexSans-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/0OIW7oYnCf6txCy_AhzcnCMM.png",
		style: "IBMPlexSans-MediumItalic",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX7KVElMYYaJe8bpLHnCwDKhdTm5IVscf3vBmpl8A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6g7AddlvM0g0Nu98eMzRWLfS",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans SemiBold Italic",
		postScriptName: "IBMPlexSans-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RwbBJiu4JgL5pO1tFkCaXjE1.png",
		style: "IBMPlexSans-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX7KVElMYYaJe8bpLHnCwDKhdTmyIJscf3vBmpl8A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EPHEmi3ieB4KmhG1lOgd6Ckz",
		family: "IBM Plex Sans",
		fullName: "IBM Plex Sans Bold Italic",
		postScriptName: "IBMPlexSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OKWyfjlSZAgkY76VLCFHbZQR.png",
		style: "IBMPlexSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/ibmplexsans/v9/zYX7KVElMYYaJe8bpLHnCwDKhdTmrINscf3vBmpl8A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EbFaw_KdlPM3ta5S5x_aMOht",
		family: "Lato",
		fullName: "Lato Thin",
		postScriptName: "Lato-Hairline",
		preview: "https://ik.imagekit.io/lh/fonts/v2/egArF3UGsqJw7FSJ2K7TdMWN.png",
		style: "Lato-Hairline",
		url: "https://fonts.gstatic.com/s/lato/v20/S6u8w4BMUTPHh30wWyWrFCbw7A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_uxTozJSYc7O29xj64mqgp_Pu",
		family: "Lato",
		fullName: "Lato Light",
		postScriptName: "Lato-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/q6HsbpZtx2dJwcTkp35fASKt.png",
		style: "Lato-Light",
		url: "https://fonts.gstatic.com/s/lato/v20/S6u9w4BMUTPHh7USew-FGC_p9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gRKX4jbLFwA3PS8_RtyNlSJ_",
		family: "Lato",
		fullName: "Lato Bold",
		postScriptName: "Lato-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DhXgZVZqbuD22D8gwQgdwliV.png",
		style: "Lato-Bold",
		url: "https://fonts.gstatic.com/s/lato/v20/S6u9w4BMUTPHh6UVew-FGC_p9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0Hwiz9WsgOj4LXuT8f6Nfu6F",
		family: "Lato",
		fullName: "Lato Black",
		postScriptName: "Lato-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/UJtbIt6H4pBhcMQ8X54sjzz2.png",
		style: "Lato-Black",
		url: "https://fonts.gstatic.com/s/lato/v20/S6u9w4BMUTPHh50Xew-FGC_p9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PBHW7dcCQ0ApXZrNXCbIO8Bu",
		family: "Lato",
		fullName: "Lato Thin Italic",
		postScriptName: "Lato-HairlineItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/oZAqQAuuDTdvRH1ELnKbNa4O.png",
		style: "Lato-HairlineItalic",
		url: "https://fonts.gstatic.com/s/lato/v20/S6u-w4BMUTPHjxsIPy-vNiPg7MU0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3aj5zP1NJdmK5rcv2RjkLU3r",
		family: "Lato",
		fullName: "Lato Light Italic",
		postScriptName: "Lato-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OZvhbkn0EHbVLV96aHrxRvtD.png",
		style: "Lato-LightItalic",
		url: "https://fonts.gstatic.com/s/lato/v20/S6u_w4BMUTPHjxsI9w2PHA3s5dwt7w.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PrEWuu7nWUZw7AMR4wyUnTB_",
		family: "Lato",
		fullName: "Lato Regular",
		postScriptName: "Lato-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/a6XSP4xrl8GwOO6ZtV31CfVf.png",
		style: "Lato-Regular",
		url: "https://fonts.gstatic.com/s/lato/v20/S6uyw4BMUTPHvxk6XweuBCY.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_uiVYks6hbbRaQS0PwQnzrivK",
		family: "Lato",
		fullName: "Lato Italic",
		postScriptName: "Lato-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BhOxRGw9wqEb8h4AIlGGLjq4.png",
		style: "Lato-Italic",
		url: "https://fonts.gstatic.com/s/lato/v20/S6u8w4BMUTPHjxswWyWrFCbw7A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_voQBodeeJK5iBPdqCHsHg5A8",
		family: "Lato",
		fullName: "Lato Bold Italic",
		postScriptName: "Lato-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NIBveo6ecfDLF5l5B6Y9EzS7.png",
		style: "Lato-BoldItalic",
		url: "https://fonts.gstatic.com/s/lato/v20/S6u_w4BMUTPHjxsI5wqPHA3s5dwt7w.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NrU5lLH1gggqkyY3CnRK2FTz",
		family: "Lato",
		fullName: "Lato Black Italic",
		postScriptName: "Lato-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/F8bvT_G__q1pD8mSun9FsLMC.png",
		style: "Lato-BlackItalic",
		url: "https://fonts.gstatic.com/s/lato/v20/S6u_w4BMUTPHjxsI3wiPHA3s5dwt7w.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Cm9USZE1F6oxJocYRBe53kQd",
		family: "Lora",
		fullName: "Lora Medium",
		postScriptName: "Lora-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/UMsEKYD3uDilucTsBxyZcZ7S.png",
		style: "Lora-Medium",
		url: "https://fonts.gstatic.com/s/lora/v20/0QI6MX1D_JOuGQbT0gvTJPa787wsuyJGmKxemMeZ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GTvN9xT4tBzCMPszrS7eugKN",
		family: "Lora",
		fullName: "Lora SemiBold",
		postScriptName: "Lora-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aerpVWaH3wlbkQRHmo2D4aCI.png",
		style: "Lora-SemiBold",
		url: "https://fonts.gstatic.com/s/lora/v20/0QI6MX1D_JOuGQbT0gvTJPa787zAvCJGmKxemMeZ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_G_4dw_rlfDjC36H7PwaqQ2LZ",
		family: "Lora",
		fullName: "Lora Bold",
		postScriptName: "Lora-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/clEOBYWtlm0iLr8f2rjpaedD.png",
		style: "Lora-Bold",
		url: "https://fonts.gstatic.com/s/lora/v20/0QI6MX1D_JOuGQbT0gvTJPa787z5vCJGmKxemMeZ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__nU53P6G0pzoXk4AzBDhX__t",
		family: "Lora",
		fullName: "Lora Regular",
		postScriptName: "Lora-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/k24laRyu4RC7RwvYQ9QgruKT.png",
		style: "Lora-Regular",
		url: "https://fonts.gstatic.com/s/lora/v20/0QI6MX1D_JOuGQbT0gvTJPa787weuyJGmKxemMeZ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7t0tatUvGHbNWeEV_Vjj4aiV",
		family: "Lora",
		fullName: "Lora Italic",
		postScriptName: "Lora-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bz1wpdDr9xZrPCaZESe5iYcS.png",
		style: "Lora-Italic",
		url: "https://fonts.gstatic.com/s/lora/v20/0QI8MX1D_JOuMw_hLdO6T2wV9KnW-MoFkqh8ndeZzZ0.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YZis8tRIn1Gz9vrhmpUAhchP",
		family: "Lora",
		fullName: "Lora Medium Italic",
		postScriptName: "Lora-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NvV1sFDGd3f0F4e0C7hLAYN3.png",
		style: "Lora-MediumItalic",
		url: "https://fonts.gstatic.com/s/lora/v20/0QI8MX1D_JOuMw_hLdO6T2wV9KnW-PgFkqh8ndeZzZ0.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ysiJzvqJDfYZ8mbsex9cWMSb",
		family: "Lora",
		fullName: "Lora SemiBold Italic",
		postScriptName: "Lora-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6VpzNNsONixcaawyrieWlEVV.png",
		style: "Lora-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/lora/v20/0QI8MX1D_JOuMw_hLdO6T2wV9KnW-BQCkqh8ndeZzZ0.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0bq1uOjUOlRRy5kahY0ZC6Lj",
		family: "Lora",
		fullName: "Lora Bold Italic",
		postScriptName: "Lora-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OrVbKvjX4XNynfEm9hxgYKfK.png",
		style: "Lora-BoldItalic",
		url: "https://fonts.gstatic.com/s/lora/v20/0QI8MX1D_JOuMw_hLdO6T2wV9KnW-C0Ckqh8ndeZzZ0.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zXCseXzSRztH8inpMqtSgqi4",
		family: "Maven Pro",
		fullName: "Maven Pro Medium",
		postScriptName: "MavenPro-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/H00HT8Gyd6fDMq2vrVAOVoan.png",
		style: "MavenPro-Medium",
		url: "https://fonts.gstatic.com/s/mavenpro/v25/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8Rf25nCpozp5GvU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lyqqTHecIk0iFrPy26lei0Rr",
		family: "Maven Pro",
		fullName: "Maven Pro SemiBold",
		postScriptName: "MavenPro-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/hLfBs5ysWM04m9VPgF0uHprf.png",
		style: "MavenPro-SemiBold",
		url: "https://fonts.gstatic.com/s/mavenpro/v25/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8fvx5nCpozp5GvU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vezY4KgqXraqefBMGlCS1_Mw",
		family: "Maven Pro",
		fullName: "Maven Pro Bold",
		postScriptName: "MavenPro-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AwohTEZU4HMEjNU53gZ6MULj.png",
		style: "MavenPro-Bold",
		url: "https://fonts.gstatic.com/s/mavenpro/v25/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8cLx5nCpozp5GvU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PCCcoY3apGdmnVKmC8sdOwMO",
		family: "Maven Pro",
		fullName: "Maven Pro ExtraBold",
		postScriptName: "MavenPro-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/TJzFcrwXuEHkQiiEvmJ2DsKI.png",
		style: "MavenPro-ExtraBold",
		url: "https://fonts.gstatic.com/s/mavenpro/v25/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8aXx5nCpozp5GvU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5vAH2gL_0F1CCv6z7DHVE0rz",
		family: "Maven Pro",
		fullName: "Maven Pro Black",
		postScriptName: "MavenPro-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/P0r6Jl0G_dSB5IKHlfzk7quJ.png",
		style: "MavenPro-Black",
		url: "https://fonts.gstatic.com/s/mavenpro/v25/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8Yzx5nCpozp5GvU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QAVeu9QwSZ0RC4RKxq_SLXO1",
		family: "Maven Pro",
		fullName: "Maven Pro Regular",
		postScriptName: "MavenPro-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Hvr7HWTOm3tugwNccxMRj9UY.png",
		style: "MavenPro-Regular",
		url: "https://fonts.gstatic.com/s/mavenpro/v25/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8SX25nCpozp5GvU.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_yT8ri3iZQLcg1zxpJB7iHoYX",
		family: "Noto Serif",
		fullName: "Noto Serif Bold",
		postScriptName: "NotoSerif-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9qGunvhoKvZ4ZlHBOr3lwXir.png",
		style: "NotoSerif-Bold",
		url: "https://fonts.gstatic.com/s/notoserif/v16/ga6Law1J5X9T9RW6j9bNdOwzTRCUcM1IKoY.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xlylugGo0QCSp5ILxO07tSDq",
		family: "Noto Serif",
		fullName: "Noto Serif Regular",
		postScriptName: "NotoSerif",
		preview: "https://ik.imagekit.io/lh/fonts/v2/TzoMugJCYzyM2h6QKv5KvExq.png",
		style: "NotoSerif",
		url: "https://fonts.gstatic.com/s/notoserif/v16/ga6Iaw1J5X9T9RW6j9bNTFAcaRi_bMQ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_alWYuccoX6_Z8EVM3tYbF2vo",
		family: "Noto Serif",
		fullName: "Noto Serif Italic",
		postScriptName: "NotoSerif-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/frHl2Bq6LwG5vDp5Yn1OqS3y.png",
		style: "NotoSerif-Italic",
		url: "https://fonts.gstatic.com/s/notoserif/v16/ga6Kaw1J5X9T9RW6j9bNfFIWbTq6fMRRMw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WmnkPMgeJF53XGWVqrCwivb9",
		family: "Noto Serif",
		fullName: "Noto Serif Bold Italic",
		postScriptName: "NotoSerif-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KJQuoLwZKkojaJ5qjjOQ4UU0.png",
		style: "NotoSerif-BoldItalic",
		url: "https://fonts.gstatic.com/s/notoserif/v16/ga6Vaw1J5X9T9RW6j9bNfFIu0RWedO9NOoYIDg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3HbB29ags7XhsRaxvCtn6Vw4",
		family: "Handlee",
		fullName: "Handlee Regular",
		postScriptName: "Handlee-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/dWFlBbUD3GT5f7QiRMVCYgNc.png",
		style: "Handlee-Regular",
		url: "https://fonts.gstatic.com/s/handlee/v9/-F6xfjBsISg9aMakDmr6oilJ3ik.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jDLJmE1uXYsHbqk3OYeDq6rE",
		family: "Iceland",
		fullName: "Iceland Regular",
		postScriptName: "Iceland-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ytdlqGz7fhnGwSLrF7BSxzga.png",
		style: "Iceland-Regular",
		url: "https://fonts.gstatic.com/s/iceland/v11/rax9HiuFsdMNOnWPWKxGADBbg0s.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fhWYSIjgWcWdFmB9UNplPLK4",
		family: "Kaushan Script",
		fullName: "Kaushan Script Regular",
		postScriptName: "KaushanScript-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Cw9FEcROuoHKX8w1maX5rZ8k.png",
		style: "KaushanScript-Regular",
		url: "https://fonts.gstatic.com/s/kaushanscript/v9/vm8vdRfvXFLG3OLnsO15WYS5DF7_ytN3M48a.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KvWRcsakolVKqhHH8MyiYquq",
		family: "Knewave",
		fullName: "Knewave Regular",
		postScriptName: "Knewave-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/clyCGLqveGALERgaWGauw7dJ.png",
		style: "Knewave-Regular",
		url: "https://fonts.gstatic.com/s/knewave/v9/sykz-yx0lLcxQaSItSq9-trEvlQ.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__WW6fResZyRp89xKcvqykjEq",
		family: "Mukta",
		fullName: "Mukta ExtraLight",
		postScriptName: "Mukta-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jSYNfKsncdvkOoPe0mTg835N.png",
		style: "Mukta-ExtraLight",
		url: "https://fonts.gstatic.com/s/mukta/v8/iJWHBXyXfDDVXbEOjFma-2HW7ZB_.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_rnllwZLOi30fSrbf52bytIB6",
		family: "Mukta",
		fullName: "Mukta Light",
		postScriptName: "Mukta-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZL0RABfhkr0sQjj6GMj7xw_z.png",
		style: "Mukta-Light",
		url: "https://fonts.gstatic.com/s/mukta/v8/iJWHBXyXfDDVXbFqj1ma-2HW7ZB_.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SDr84CT4qdAgu5Yt5yJsTjSu",
		family: "Mukta",
		fullName: "Mukta Medium",
		postScriptName: "Mukta-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_hMuPmRo8vnI4IzO7ZPoeK70.png",
		style: "Mukta-Medium",
		url: "https://fonts.gstatic.com/s/mukta/v8/iJWHBXyXfDDVXbEyjlma-2HW7ZB_.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_2Mm7KnhzAqrDVUo196vqQG4L",
		family: "Mukta",
		fullName: "Mukta SemiBold",
		postScriptName: "Mukta-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/GkpvxDbQvipe9jCyJAuU3muR.png",
		style: "Mukta-SemiBold",
		url: "https://fonts.gstatic.com/s/mukta/v8/iJWHBXyXfDDVXbEeiVma-2HW7ZB_.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kKQfQVHgu2rtniUIJRBGkiG2",
		family: "Mukta",
		fullName: "Mukta Bold",
		postScriptName: "Mukta-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5ztYLRBLOpB4vqbgLyBbLdV3.png",
		style: "Mukta-Bold",
		url: "https://fonts.gstatic.com/s/mukta/v8/iJWHBXyXfDDVXbF6iFma-2HW7ZB_.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_BIt4gCkeGzfwAv3Xe1vLzZ7c",
		family: "Mukta",
		fullName: "Mukta ExtraBold",
		postScriptName: "Mukta-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SbZiOuwGhLtyY0XcGrKl6vGw.png",
		style: "Mukta-ExtraBold",
		url: "https://fonts.gstatic.com/s/mukta/v8/iJWHBXyXfDDVXbFmi1ma-2HW7ZB_.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YwpkYiVA8O57KDbI7LwCHBoi",
		family: "Mukta",
		fullName: "Mukta Regular",
		postScriptName: "Mukta-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FGtLZSSxQQoYKaGMFPJ4L8_4.png",
		style: "Mukta-Regular",
		url: "https://fonts.gstatic.com/s/mukta/v8/iJWKBXyXfDDVXYnGp32S0H3f.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pJUKkbELxCsFk8feWr1UumnM",
		family: "Offside",
		fullName: "Offside Regular",
		postScriptName: "Offside-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/htjLxUDtHDfp5LVbUpX0Rnz2.png",
		style: "Offside-Regular",
		url: "https://fonts.gstatic.com/s/offside/v10/HI_KiYMWKa9QrAykQ5HiRp-dhpQ.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Tbopj8l7f17_zGLKjQlvzEjX",
		family: "Old Standard TT",
		fullName: "Old Standard TT Bold",
		postScriptName: "OldStandardTT-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/invRhCciKJ9sdLiMPuk3DSLF.png",
		style: "OldStandardTT-Bold",
		url: "https://fonts.gstatic.com/s/oldstandardtt/v13/MwQrbh3o1vLImiwAVvYawgcf2eVWEX-dTFxeb80flQ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_CJ3HLOAjW2qzACdEdpdjdoyt",
		family: "Old Standard TT",
		fullName: "Old Standard TT Regular",
		postScriptName: "OldStandardTT-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4CKQjLiuPtQpOdKX1lLTgWUj.png",
		style: "OldStandardTT-Regular",
		url: "https://fonts.gstatic.com/s/oldstandardtt/v13/MwQubh3o1vLImiwAVvYawgcf2eVurVC5RHdCZg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qHUaPldTxRuNs8Cxupa8XGwU",
		family: "Old Standard TT",
		fullName: "Old Standard TT Italic",
		postScriptName: "OldStandardTT-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/xzHKC3RRqPVlUOKRLIRuc4vO.png",
		style: "OldStandardTT-Italic",
		url: "https://fonts.gstatic.com/s/oldstandardtt/v13/MwQsbh3o1vLImiwAVvYawgcf2eVer1q9ZnJSZtQG.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_S2B04Vy2rH7Vh11yVeODJID5",
		family: "Overpass",
		fullName: "Overpass Thin",
		postScriptName: "Overpass-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/h4beCQJXEXJXnXSWsg4ZZuGl.png",
		style: "Overpass-Thin",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFda35WCmI96Ajtm83upeyoaX6QPnlo6_PLrOZCLtce-og.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_G1YBSNbkNIgvXJtKAWJJmgEt",
		family: "Overpass",
		fullName: "Overpass ExtraLight",
		postScriptName: "Overpass-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NyQM0IONIUlWjgmMNzrHbh1C.png",
		style: "Overpass-ExtraLight",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFda35WCmI96Ajtm83upeyoaX6QPnlo6fPPrOZCLtce-og.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_h_L5N3msQruceuG25KRXiMtl",
		family: "Overpass",
		fullName: "Overpass Light",
		postScriptName: "Overpass-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Pg5VdGSsCrli6FsVM7PDwFpa.png",
		style: "Overpass-Light",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFda35WCmI96Ajtm83upeyoaX6QPnlo6ovPrOZCLtce-og.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_poYDMojQkwC82AyAX4Bp2dUh",
		family: "Overpass",
		fullName: "Overpass Medium",
		postScriptName: "Overpass-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jTH9cbgOrMcLUNbmqvxvOyAk.png",
		style: "Overpass-Medium",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFda35WCmI96Ajtm83upeyoaX6QPnlo6zvPrOZCLtce-og.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HWCSF3hTqBFpr9x0ewwEND6O",
		family: "Overpass",
		fullName: "Overpass SemiBold",
		postScriptName: "Overpass-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tZJJY9FtX8thASnoZo2PZDd9.png",
		style: "Overpass-SemiBold",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFda35WCmI96Ajtm83upeyoaX6QPnlo6IvTrOZCLtce-og.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_izyFIwoE_09NCvC0sm_HRjrF",
		family: "Overpass",
		fullName: "Overpass Bold",
		postScriptName: "Overpass-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AkIqQ6tV2E6T0G3c4QDhsxXm.png",
		style: "Overpass-Bold",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFda35WCmI96Ajtm83upeyoaX6QPnlo6G_TrOZCLtce-og.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Jvwvx0B8QBOYdy7fjoPg1UQQ",
		family: "Overpass",
		fullName: "Overpass ExtraBold",
		postScriptName: "Overpass-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4DzQJa4DbpLcPSVLYs8e6NMk.png",
		style: "Overpass-ExtraBold",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFda35WCmI96Ajtm83upeyoaX6QPnlo6fPTrOZCLtce-og.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4iGVjAl9FCUjKhZIi9aUuhtr",
		family: "Overpass",
		fullName: "Overpass Black",
		postScriptName: "Overpass-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nGrS3CFa3gYH2uVwNpnH8jRx.png",
		style: "Overpass-Black",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFda35WCmI96Ajtm83upeyoaX6QPnlo6VfTrOZCLtce-og.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_36x5GILnd_0RtVzXBNKEpUx1",
		family: "Overpass",
		fullName: "Overpass Regular",
		postScriptName: "Overpass-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/dyiHffYpliTby7XihPfP1El1.png",
		style: "Overpass-Regular",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFda35WCmI96Ajtm83upeyoaX6QPnlo6_PPrOZCLtce-og.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_acGVJd9K_GNKjlMXREoNBTG8",
		family: "Overpass",
		fullName: "Overpass Thin Italic",
		postScriptName: "Overpass-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/eduhKjewd90B6KS2YSBRBkuu.png",
		style: "Overpass-ThinItalic",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLADe5qPl8Kuosgz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_b6dJr4krw0yjgOP_PnrSdsZk",
		family: "Overpass",
		fullName: "Overpass ExtraLight Italic",
		postScriptName: "Overpass-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/N4Zzh3Fuj3ZryAvxE2LCrzG4.png",
		style: "Overpass-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLCDepqPl8Kuosgz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JC0FhRFRLcWZGbqg85lxxihS",
		family: "Overpass",
		fullName: "Overpass Light Italic",
		postScriptName: "Overpass-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5mL1l8P57G5dQAk3eaED8rtx.png",
		style: "Overpass-LightItalic",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLBdepqPl8Kuosgz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Uj88Fkg5mVhd6B_7Jns6Jm9L",
		family: "Overpass",
		fullName: "Overpass Italic",
		postScriptName: "Overpass-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/l73org3T97w0YoifPF6zwyW4.png",
		style: "Overpass-Italic",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLADepqPl8Kuosgz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fzT08B9vHmv0XSx5Odabcpte",
		family: "Overpass",
		fullName: "Overpass Medium Italic",
		postScriptName: "Overpass-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/g6p_ni_Wpf5q1Y2Qx6oJ8wyS.png",
		style: "Overpass-MediumItalic",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLAxepqPl8Kuosgz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0Au5oX8yn5V7IKKh44TbTbwW",
		family: "Overpass",
		fullName: "Overpass SemiBold Italic",
		postScriptName: "Overpass-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wkWs7IekHwa9x_ku9OrQF0Hx.png",
		style: "Overpass-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLDdfZqPl8Kuosgz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dKs2wwz_fqaZlJddKv_jeJkf",
		family: "Overpass",
		fullName: "Overpass Bold Italic",
		postScriptName: "Overpass-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DdZuex5m8TCaDvJrwqk7kbq2.png",
		style: "Overpass-BoldItalic",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLDkfZqPl8Kuosgz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_67bhhCz6VYOBLA8c0CKTZfnm",
		family: "Overpass",
		fullName: "Overpass ExtraBold Italic",
		postScriptName: "Overpass-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vW8a6KZpdpRWiVnIQXwKLbfB.png",
		style: "Overpass-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLCDfZqPl8Kuosgz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wCSCmX3AGotYogYg5AzjqTgs",
		family: "Overpass",
		fullName: "Overpass Black Italic",
		postScriptName: "Overpass-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kxrHY_Z8huppglZjfWMP4VSE.png",
		style: "Overpass-BlackItalic",
		url: "https://fonts.gstatic.com/s/overpass/v7/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLCqfZqPl8Kuosgz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wL4NQHqxk_tNn7iKbqUxHR8i",
		family: "PT Serif",
		fullName: "PT Serif Bold",
		postScriptName: "PTSerif-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/E7EO051_I20GChEptrOtAAPi.png",
		style: "PTSerif-Bold",
		url: "https://fonts.gstatic.com/s/ptserif/v12/EJRSQgYoZZY2vCFuvAnt65qVXSr3pNNB.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8rdniV6zqFl28DaEArgf96lD",
		family: "PT Serif",
		fullName: "PT Serif Regular",
		postScriptName: "PTSerif-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nuC6WrCl3VNH8q4EUzsdqJ1I.png",
		style: "PTSerif-Regular",
		url: "https://fonts.gstatic.com/s/ptserif/v12/EJRVQgYoZZY2vCFuvDFRxL6ddjb-.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_n8ZPd6NfE3mhzJgtqU8yIVP5",
		family: "PT Serif",
		fullName: "PT Serif Italic",
		postScriptName: "PTSerif-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wNsIe1GpzuLeOHcEulisN482.png",
		style: "PTSerif-Italic",
		url: "https://fonts.gstatic.com/s/ptserif/v12/EJRTQgYoZZY2vCFuvAFTzrq_cyb-vco.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_rNmk7mJIon_BehcZEDlHo0y3",
		family: "PT Serif",
		fullName: "PT Serif Bold Italic",
		postScriptName: "PTSerif-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lYnSg8dJsJu6NPtnr6Choq8j.png",
		style: "PTSerif-BoldItalic",
		url: "https://fonts.gstatic.com/s/ptserif/v12/EJRQQgYoZZY2vCFuvAFT9gaQVy7VocNB6Iw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_t6NMBkiJsWYlxoKG3Syo9j0w",
		family: "Oranienbaum",
		fullName: "Oranienbaum Regular",
		postScriptName: "Oranienbaum-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SLoGvnMZ_ObbLDG4w9ha6rRK.png",
		style: "Oranienbaum-Regular",
		url: "https://fonts.gstatic.com/s/oranienbaum/v10/OZpHg_txtzZKMuXLIVrx-3zn7kz3dpHc.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TNNO_eN7LB0pp_FK64ETz33m",
		family: "Gothic A1",
		fullName: "Gothic A1 Thin",
		postScriptName: "GothicA1-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_ftsNX7IEMp5UoYDdijw_tZH.png",
		style: "GothicA1-Thin",
		url: "https://fonts.gstatic.com/s/gothica1/v8/CSR74z5ZnPydRjlCCwlCCMcqYtd2vfwk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5gqbakQXkbPJRv5myKR13HtI",
		family: "Gothic A1",
		fullName: "Gothic A1 ExtraLight",
		postScriptName: "GothicA1-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fGmccuDjZGxZniQqnRsGho5p.png",
		style: "GothicA1-ExtraLight",
		url: "https://fonts.gstatic.com/s/gothica1/v8/CSR44z5ZnPydRjlCCwlCpOYKSPl6tOU9Eg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_B36RRnJYnURckE4bxkvc0w5z",
		family: "Gothic A1",
		fullName: "Gothic A1 Light",
		postScriptName: "GothicA1-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uQNl8_93nDZqA3QlfkAF7tBM.png",
		style: "GothicA1-Light",
		url: "https://fonts.gstatic.com/s/gothica1/v8/CSR44z5ZnPydRjlCCwlCwOUKSPl6tOU9Eg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cFNIe1RluoWqfrZ1iBidia7G",
		family: "Gothic A1",
		fullName: "Gothic A1 Medium",
		postScriptName: "GothicA1-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3R19_FCrGudhqRcf5KKtmX1f.png",
		style: "GothicA1-Medium",
		url: "https://fonts.gstatic.com/s/gothica1/v8/CSR44z5ZnPydRjlCCwlCmOQKSPl6tOU9Eg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_CwRCnQW4NPmlM7OIxG154UXn",
		family: "Gothic A1",
		fullName: "Gothic A1 SemiBold",
		postScriptName: "GothicA1-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/S4QImkn95SNzVGhDkKuq71oD.png",
		style: "GothicA1-SemiBold",
		url: "https://fonts.gstatic.com/s/gothica1/v8/CSR44z5ZnPydRjlCCwlCtOMKSPl6tOU9Eg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_I9mWFGfEgREmyQGlh1ca5_tO",
		family: "Gothic A1",
		fullName: "Gothic A1 Bold",
		postScriptName: "GothicA1-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pOrhkL_6bhlNeztLsZmp0SnD.png",
		style: "GothicA1-Bold",
		url: "https://fonts.gstatic.com/s/gothica1/v8/CSR44z5ZnPydRjlCCwlC0OIKSPl6tOU9Eg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GkdubMLvsliW9tzKWhhMTfM4",
		family: "Gothic A1",
		fullName: "Gothic A1 ExtraBold",
		postScriptName: "GothicA1-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DazJYHtcsYdtEzJgc9UCb2Mq.png",
		style: "GothicA1-ExtraBold",
		url: "https://fonts.gstatic.com/s/gothica1/v8/CSR44z5ZnPydRjlCCwlCzOEKSPl6tOU9Eg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_klyWeM8ghTBOpESFBE_LaJfE",
		family: "Gothic A1",
		fullName: "Gothic A1 Black",
		postScriptName: "GothicA1-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BQttUxSYjK9ca1rFlF47rdMV.png",
		style: "GothicA1-Black",
		url: "https://fonts.gstatic.com/s/gothica1/v8/CSR44z5ZnPydRjlCCwlC6OAKSPl6tOU9Eg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QBoWF85i6a0WqNEgbKrm6uut",
		family: "Gothic A1",
		fullName: "Gothic A1 Regular",
		postScriptName: "GothicA1-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/C_Xs8rgW3r1yKvKieSC_fqPe.png",
		style: "GothicA1-Regular",
		url: "https://fonts.gstatic.com/s/gothica1/v8/CSR94z5ZnPydRjlCCwl6bM0uQNJmvQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_M3BWva1oWfkL4KruVSGqS0Vq",
		family: "Josefin Sans",
		fullName: "Josefin Sans Thin",
		postScriptName: "JosefinSans-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5gfpGXjbh7i80aDYd3ZGAoPZ.png",
		style: "JosefinSans-Thin",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_DjRXMFrLgTsQV0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8yTKKfxEj9joC3ZbkM61rZtI",
		family: "Josefin Sans",
		fullName: "Josefin Sans ExtraLight",
		postScriptName: "JosefinSans-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/unTKSpudi1YdKhFksF2xPksP.png",
		style: "JosefinSans-ExtraLight",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_LjQXMFrLgTsQV0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7o4ECmUVXLTvJBtewpVnSjBd",
		family: "Josefin Sans",
		fullName: "Josefin Sans Light",
		postScriptName: "JosefinSans-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gZE_vKivOGlHs1Bm6TTYrDxv.png",
		style: "JosefinSans-Light",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_GbQXMFrLgTsQV0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lAm_ltkNuv238vh0Y2xoyeWm",
		family: "Josefin Sans",
		fullName: "Josefin Sans Medium",
		postScriptName: "JosefinSans-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AfD_gcdf553iLFFNlOta7c00.png",
		style: "JosefinSans-Medium",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_ArQXMFrLgTsQV0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8XyXaBLFB012k5ZkrCuMo_kp",
		family: "Josefin Sans",
		fullName: "Josefin Sans SemiBold",
		postScriptName: "JosefinSans-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8dZvNcWho5nJpYJ7T8cpcP_u.png",
		style: "JosefinSans-SemiBold",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_ObXXMFrLgTsQV0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_05E4txZ9lXgLbVnsa1fSWbBf",
		family: "Josefin Sans",
		fullName: "Josefin Sans Bold",
		postScriptName: "JosefinSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/dP1YfLnuEBBSsVyp3rvdCFHy.png",
		style: "JosefinSans-Bold",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_N_XXMFrLgTsQV0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_yeZiheWUQevFOKmtbcuh3zFD",
		family: "Josefin Sans",
		fullName: "Josefin Sans Regular",
		postScriptName: "JosefinSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/o7hotKGCPmrncqguZ_OJUk7O.png",
		style: "JosefinSans-Regular",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_DjQXMFrLgTsQV0.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TPiW_y845aZzlEmtv9jANqRK",
		family: "Josefin Sans",
		fullName: "Josefin Sans Thin Italic",
		postScriptName: "JosefinSans-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OvPIA_IaV4Qk4M0KDW0QOaf9.png",
		style: "JosefinSans-ThinItalic",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTtINhKibpUV3MEQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4XbvwY64QMtTkfmC9xdKRmqS",
		family: "Josefin Sans",
		fullName: "Josefin Sans ExtraLight Italic",
		postScriptName: "JosefinSans-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/cNXo0WI_U6qmy9Aiz5jJRt4z.png",
		style: "JosefinSans-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTNIJhKibpUV3MEQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_bVa8DEH6GC4QS1eQ8HJxUXh7",
		family: "Josefin Sans",
		fullName: "Josefin Sans Light Italic",
		postScriptName: "JosefinSans-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rwbv6gOAnE89dpb_6U_kb3jR.png",
		style: "JosefinSans-LightItalic",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCT6oJhKibpUV3MEQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ziWlYTbfEb_FQis4p2nHDn0e",
		family: "Josefin Sans",
		fullName: "Josefin Sans Italic",
		postScriptName: "JosefinSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/UTdPiAVCjMJlSnicDWOB73La.png",
		style: "JosefinSans-Italic",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTtIJhKibpUV3MEQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Ko8KAjB8tNUXcNPU9Bpj8DRZ",
		family: "Josefin Sans",
		fullName: "Josefin Sans Medium Italic",
		postScriptName: "JosefinSans-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/C6EhqjFx0kw1G8n66t9eNuR2.png",
		style: "JosefinSans-MediumItalic",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCThoJhKibpUV3MEQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_bIxelcbA1QlLQl34Gxj1gxAM",
		family: "Josefin Sans",
		fullName: "Josefin Sans SemiBold Italic",
		postScriptName: "JosefinSans-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/dSgBcAjr5NKEfeR38mFN6NXh.png",
		style: "JosefinSans-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTaoVhKibpUV3MEQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_B3oKFRSuNYTX1sqkTW3yRFLb",
		family: "Josefin Sans",
		fullName: "Josefin Sans Bold Italic",
		postScriptName: "JosefinSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tWhPXDOMS9WdLwUqTK3utbix.png",
		style: "JosefinSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/josefinsans/v20/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTU4VhKibpUV3MEQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8IcBxdQ1ZSk1ZFw_aaK8y37a",
		family: "Kanit",
		fullName: "Kanit Thin",
		postScriptName: "Kanit-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fNnrTullY_3tTK1wsGZAhawB.png",
		style: "Kanit-Thin",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKX-Go6G5tXcr72GwWKcaxALFs.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MN91ZyTAvUM0t4hTkXKB73oR",
		family: "Kanit",
		fullName: "Kanit ExtraLight",
		postScriptName: "Kanit-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZMrMwDV3efXq6A1WAoh9gmul.png",
		style: "Kanit-ExtraLight",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKU-Go6G5tXcr5aOiWgX6BJNUJy.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_S09G4Cncn_IHT1qycdBZI0sz",
		family: "Kanit",
		fullName: "Kanit Light",
		postScriptName: "Kanit-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DCVJPi2eEobrgUaZmU9ujt7t.png",
		style: "Kanit-Light",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKU-Go6G5tXcr4-OSWgX6BJNUJy.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_2LodQL3hFfuSHyRVrYGuADZu",
		family: "Kanit",
		fullName: "Kanit Medium",
		postScriptName: "Kanit-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BUPZFvTznJ8Y1rm5cJfICi0q.png",
		style: "Kanit-Medium",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKU-Go6G5tXcr5mOCWgX6BJNUJy.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cy53zg3sQrYO1RMmRrVx__Hu",
		family: "Kanit",
		fullName: "Kanit SemiBold",
		postScriptName: "Kanit-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4Zs2OZZ05iCL830tQOBLAtDq.png",
		style: "Kanit-SemiBold",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKU-Go6G5tXcr5KPyWgX6BJNUJy.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6Ep3d4hm6HSo9wqeq00ic_32",
		family: "Kanit",
		fullName: "Kanit Bold",
		postScriptName: "Kanit-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1PyF2BPSnfGEXGDc97k284E4.png",
		style: "Kanit-Bold",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKU-Go6G5tXcr4uPiWgX6BJNUJy.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_2o6y1QPAn8RsdbB0xBOTwuRP",
		family: "Kanit",
		fullName: "Kanit ExtraBold",
		postScriptName: "Kanit-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Y_nnqW51gjrFV4XFd_BwNqvl.png",
		style: "Kanit-ExtraBold",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKU-Go6G5tXcr4yPSWgX6BJNUJy.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xV6eP2T8FWr3UgRTNXF0NXuk",
		family: "Kanit",
		fullName: "Kanit Black",
		postScriptName: "Kanit-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/p7ifu3WKQK7o3c8MABC3vVoj.png",
		style: "Kanit-Black",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKU-Go6G5tXcr4WPCWgX6BJNUJy.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KGOuf9r15PR0fZ3HiSDOdPqU",
		family: "Kanit",
		fullName: "Kanit Thin Italic",
		postScriptName: "Kanit-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pVJGiq3FLWn9sIcDBB0W56Ih.png",
		style: "Kanit-ThinItalic",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKV-Go6G5tXcraQI2GAdY5FPFtrGw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9HoIb5XDhJhfda_3RryrMk6U",
		family: "Kanit",
		fullName: "Kanit ExtraLight Italic",
		postScriptName: "Kanit-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3Ugsqzqzi0BiOJRuSqElANdI.png",
		style: "Kanit-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKS-Go6G5tXcraQI82hVaRrMFJyAu4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_giABFTzFMcrlaMU_NIVz50nW",
		family: "Kanit",
		fullName: "Kanit Light Italic",
		postScriptName: "Kanit-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/l7ZZNf98_lQZFiyY6pHgns2D.png",
		style: "Kanit-LightItalic",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKS-Go6G5tXcraQI6miVaRrMFJyAu4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_epvkecCcbFkkcwo3RW8z9RiT",
		family: "Kanit",
		fullName: "Kanit Regular",
		postScriptName: "Kanit-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vXy4k1NQ2wxdOtJBofkxvM5E.png",
		style: "Kanit-Regular",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKZ-Go6G5tXcoaSEQGodLxA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qSKH2nnC51ALlYUlnKzj9_LW",
		family: "Kanit",
		fullName: "Kanit Italic",
		postScriptName: "Kanit-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Jhsrk02kSojEqVoU1QBtEjnb.png",
		style: "Kanit-Italic",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKX-Go6G5tXcraQGwWKcaxALFs.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_1g88qM3KGT8EmQx9m90sWdWx",
		family: "Kanit",
		fullName: "Kanit Medium Italic",
		postScriptName: "Kanit-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JzWEUNLiTRQMeQxeKVHnWrtX.png",
		style: "Kanit-MediumItalic",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKS-Go6G5tXcraQI_GjVaRrMFJyAu4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_AWPcXZUtxnllZ6jZjfSy_OvX",
		family: "Kanit",
		fullName: "Kanit SemiBold Italic",
		postScriptName: "Kanit-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/iRau5HkiMvZ5Be9y8FFLd7lo.png",
		style: "Kanit-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKS-Go6G5tXcraQI92kVaRrMFJyAu4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_X3OhvZvaZGft24Bel8HNd1yq",
		family: "Kanit",
		fullName: "Kanit Bold Italic",
		postScriptName: "Kanit-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/eBGBLOSI3eUllvpIsNEoo9lL.png",
		style: "Kanit-BoldItalic",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKS-Go6G5tXcraQI7mlVaRrMFJyAu4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7reuDcAl1t72fnWWRsrPgQpH",
		family: "Kanit",
		fullName: "Kanit ExtraBold Italic",
		postScriptName: "Kanit-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2je4eDiWtdFcSApoVz5JwZRY.png",
		style: "Kanit-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKS-Go6G5tXcraQI6WmVaRrMFJyAu4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Suj9v8cqxn3QAFiW3kl0OLUd",
		family: "Kanit",
		fullName: "Kanit Black Italic",
		postScriptName: "Kanit-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VGlOzgIaOaO3sPKgWXt0irZh.png",
		style: "Kanit-BlackItalic",
		url: "https://fonts.gstatic.com/s/kanit/v7/nKKS-Go6G5tXcraQI4GnVaRrMFJyAu4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cqOFKuVDqJhqrXxpUn4NJ6FQ",
		family: "Libre Franklin",
		fullName: "Libre Franklin Thin",
		postScriptName: "LibreFranklin-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nGpddcYErpA7oTiqyp9qLFKD.png",
		style: "LibreFranklin-Thin",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsSUB9rIb-JH1g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vmTTpwvvzzDgD1sXZ6iZpmGl",
		family: "Libre Franklin",
		fullName: "Libre Franklin ExtraLight",
		postScriptName: "LibreFranklin-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/sg6umqtLzZZi5P03chqSUejw.png",
		style: "LibreFranklin-ExtraLight",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhrsWUB9rIb-JH1g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9ek3kWr0gr3S3QugoVQ8ZycD",
		family: "Libre Franklin",
		fullName: "Libre Franklin Light",
		postScriptName: "LibreFranklin-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/h67_P29FiiWqNFPjWwimQD_c.png",
		style: "LibreFranklin-Light",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhcMWUB9rIb-JH1g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ijzp12906obpKJSvLkE2_tW8",
		family: "Libre Franklin",
		fullName: "Libre Franklin Medium",
		postScriptName: "LibreFranklin-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1irfIZBKqM2arMHb1zQyTg09.png",
		style: "LibreFranklin-Medium",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhHMWUB9rIb-JH1g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hW92Fx1MRXH5_B4BTwmcqeY5",
		family: "Libre Franklin",
		fullName: "Libre Franklin SemiBold",
		postScriptName: "LibreFranklin-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/F_O9IYcI4nwjfrX6Zh9_3viT.png",
		style: "LibreFranklin-SemiBold",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduh8MKUB9rIb-JH1g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WT4iBLKvdbmmX2kcMXUwmFb2",
		family: "Libre Franklin",
		fullName: "Libre Franklin Bold",
		postScriptName: "LibreFranklin-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/a3WrqixfmNbUT1IXJFnpJFd6.png",
		style: "LibreFranklin-Bold",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhycKUB9rIb-JH1g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_65Zo9wSecmBCvs_vkQDdqUbc",
		family: "Libre Franklin",
		fullName: "Libre Franklin ExtraBold",
		postScriptName: "LibreFranklin-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FWkCBLHpxrihEeieWNWKcuLC.png",
		style: "LibreFranklin-ExtraBold",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhrsKUB9rIb-JH1g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6va9uWImWoONANNBlVCaDTCn",
		family: "Libre Franklin",
		fullName: "Libre Franklin Black",
		postScriptName: "LibreFranklin-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fNdvSyU4xTDhIxfVI4tXwUaz.png",
		style: "LibreFranklin-Black",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhh8KUB9rIb-JH1g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EpIDaYINjHVnoc9r_g8bP_Ed",
		family: "Libre Franklin",
		fullName: "Libre Franklin Regular",
		postScriptName: "LibreFranklin-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WiyA12V3DWbA7rQIYLUtlvKL.png",
		style: "LibreFranklin-Regular",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsWUB9rIb-JH1g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wX70mtONi2QSa2nNVA0IINPl",
		family: "Libre Franklin",
		fullName: "Libre Franklin Thin Italic",
		postScriptName: "LibreFranklin-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/TL_3FSA5fIjvvw8C7e04D4Qi.png",
		style: "LibreFranklin-ThinItalic",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oZ8RdDMTedX1sGE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3UKM3YE8gGO8_qj_8DDzOm8U",
		family: "Libre Franklin",
		fullName: "Libre Franklin ExtraLight Italic",
		postScriptName: "LibreFranklin-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/npoxtU83DarKdJf46h88_Whx.png",
		style: "LibreFranklin-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05ob8RNDMTedX1sGE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ODvILe64aX4LPFeMxz1W7Qop",
		family: "Libre Franklin",
		fullName: "Libre Franklin Light Italic",
		postScriptName: "LibreFranklin-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Q47DUKxClZMpH5QovKy5Sx0m.png",
		style: "LibreFranklin-LightItalic",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oYiRNDMTedX1sGE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YHU_Ka1prlPvsWqeKZhmKbZb",
		family: "Libre Franklin",
		fullName: "Libre Franklin Italic",
		postScriptName: "LibreFranklin-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OV6zZOScvEICeWJaAjgXW2hA.png",
		style: "LibreFranklin-Italic",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oZ8RNDMTedX1sGE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8txMclLLTcLJAkM3n_1PT_1t",
		family: "Libre Franklin",
		fullName: "Libre Franklin Medium Italic",
		postScriptName: "LibreFranklin-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nXKk2i0bcsu2OLlmUY9lEySQ.png",
		style: "LibreFranklin-MediumItalic",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oZORNDMTedX1sGE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_l5kE7YToH_juVyv7SgVjXq50",
		family: "Libre Franklin",
		fullName: "Libre Franklin SemiBold Italic",
		postScriptName: "LibreFranklin-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/g8wVACcxzSxkLQwBGVKeLKmE.png",
		style: "LibreFranklin-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oaiQ9DMTedX1sGE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wNXOv4lUaiYICo3djfbssFYb",
		family: "Libre Franklin",
		fullName: "Libre Franklin Bold Italic",
		postScriptName: "LibreFranklin-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BvbZW69OnmX1bLiCwAE_V_ye.png",
		style: "LibreFranklin-BoldItalic",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oabQ9DMTedX1sGE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UJePMkPvB2iDnL1npYrs_I9q",
		family: "Libre Franklin",
		fullName: "Libre Franklin ExtraBold Italic",
		postScriptName: "LibreFranklin-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IWCI0oUzawCzDKm5N3PpKddw.png",
		style: "LibreFranklin-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05ob8Q9DMTedX1sGE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7d_5LwMDqKC8qEJUwZAdhibq",
		family: "Libre Franklin",
		fullName: "Libre Franklin Black Italic",
		postScriptName: "LibreFranklin-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/53Vxw1Frj7MAcGVpGGTe569P.png",
		style: "LibreFranklin-BlackItalic",
		url: "https://fonts.gstatic.com/s/librefranklin/v7/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05obVQ9DMTedX1sGE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_OeLp525XvM9I4CzR2snno8bh",
		family: "Luckiest Guy",
		fullName: "Luckiest Guy Regular",
		postScriptName: "LuckiestGuy-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LpNN0Ij6QgPZttOziO7oYyEU.png",
		style: "LuckiestGuy-Regular",
		url: "https://fonts.gstatic.com/s/luckiestguy/v11/_gP_1RrxsjcxVyin9l9n_j2RStR3qDpraA.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZDb9vozMilDEvF6nKRG1Jc_w",
		family: "Marmelad",
		fullName: "Marmelad Regular",
		postScriptName: "Marmelad-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZG_uJJWhhqDm6ieEI8ZL99QW.png",
		style: "Marmelad-Regular",
		url: "https://fonts.gstatic.com/s/marmelad/v10/Qw3eZQdSHj_jK2e-8tFLG-YMC0R8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_j45c1khyIC332RbMFkc0Quqp",
		family: "Mukta Mahee",
		fullName: "Mukta Mahee ExtraLight",
		postScriptName: "MuktaMahee-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AKu4VJdnaraWUfatzWxipkbO.png",
		style: "MuktaMahee-ExtraLight",
		url: "https://fonts.gstatic.com/s/muktamahee/v10/XRXN3IOIi0hcP8iVU67hA9MFcBoHJndqZCsW.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_w91l5bKyh2E1ObbhXt9fhZQ3",
		family: "Mukta Mahee",
		fullName: "Mukta Mahee Light",
		postScriptName: "MuktaMahee-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Y_TRdMTYbIWMORmObV3qoZAv.png",
		style: "MuktaMahee-Light",
		url: "https://fonts.gstatic.com/s/muktamahee/v10/XRXN3IOIi0hcP8iVU67hA9NhcxoHJndqZCsW.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_K3pcYAcnW4fZ740NrVQpdOjh",
		family: "Mukta Mahee",
		fullName: "Mukta Mahee Medium",
		postScriptName: "MuktaMahee-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/QRhn4tvB4kww_uf7cDCUem_b.png",
		style: "MuktaMahee-Medium",
		url: "https://fonts.gstatic.com/s/muktamahee/v10/XRXN3IOIi0hcP8iVU67hA9M5choHJndqZCsW.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_U0nLDBj9RJ5oEK5zIpG6EZcq",
		family: "Mukta Mahee",
		fullName: "Mukta Mahee SemiBold",
		postScriptName: "MuktaMahee-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5OVA59VvkknSCjKXRF4vzYtA.png",
		style: "MuktaMahee-SemiBold",
		url: "https://fonts.gstatic.com/s/muktamahee/v10/XRXN3IOIi0hcP8iVU67hA9MVdRoHJndqZCsW.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Dz3_V2yfkrH6p7AGf2MCTqzd",
		family: "Mukta Mahee",
		fullName: "Mukta Mahee Bold",
		postScriptName: "MuktaMahee-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4SE7LJ9BCHpoja7FEFxjHuHK.png",
		style: "MuktaMahee-Bold",
		url: "https://fonts.gstatic.com/s/muktamahee/v10/XRXN3IOIi0hcP8iVU67hA9NxdBoHJndqZCsW.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_werCUNcVw1V8I_x2Kbj6dm4K",
		family: "Mukta Mahee",
		fullName: "Mukta Mahee ExtraBold",
		postScriptName: "MuktaMahee-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9lKPKMz8GPElFCWbPYTZJtcO.png",
		style: "MuktaMahee-ExtraBold",
		url: "https://fonts.gstatic.com/s/muktamahee/v10/XRXN3IOIi0hcP8iVU67hA9NtdxoHJndqZCsW.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9oZEiV12bXBpmEez82ivlnrc",
		family: "Mukta Mahee",
		fullName: "Mukta Mahee Regular",
		postScriptName: "MuktaMahee-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bJU1xygQazKbnmie6xzTsNCD.png",
		style: "MuktaMahee-Regular",
		url: "https://fonts.gstatic.com/s/muktamahee/v10/XRXQ3IOIi0hcP8iVU67hA-vNWz4PDWtj.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_evijy3S_lbVT7k1fl8KNus4T",
		family: "Nunito",
		fullName: "Nunito ExtraLight",
		postScriptName: "Nunito-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MUNxkJIoOuF9JfTXUUWkAfv9.png",
		style: "Nunito-ExtraLight",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXI3I6Li01BKofiOc5wtlZ2di8HDDshRTM9jo7eTWk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__24MKsUd9rAXzuFx23xTY9zu",
		family: "Nunito",
		fullName: "Nunito Light",
		postScriptName: "Nunito-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/YoGmoI1NCHscmViX0uejICLX.png",
		style: "Nunito-Light",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXI3I6Li01BKofiOc5wtlZ2di8HDOUhRTM9jo7eTWk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HUJxBc1Bf2cWXBoQsKFwHKv8",
		family: "Nunito",
		fullName: "Nunito Medium",
		postScriptName: "Nunito-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VigPsit5DRSbcmPH7YhhpOsE.png",
		style: "Nunito-Medium",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXI3I6Li01BKofiOc5wtlZ2di8HDIkhRTM9jo7eTWk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_CUP8T1WEMSzmyl5NODmlGwNX",
		family: "Nunito",
		fullName: "Nunito SemiBold",
		postScriptName: "Nunito-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/0H4L2g7VldsQdSgrONQKTc3m.png",
		style: "Nunito-SemiBold",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXI3I6Li01BKofiOc5wtlZ2di8HDGUmRTM9jo7eTWk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_F3ZoDjLL0aN2h1O6mu13ydgc",
		family: "Nunito",
		fullName: "Nunito Bold",
		postScriptName: "Nunito-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/so7jFYhaNe7aD7kjCULjvtdh.png",
		style: "Nunito-Bold",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXI3I6Li01BKofiOc5wtlZ2di8HDFwmRTM9jo7eTWk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xZ7ydPpAo4jKqsIKFdiHI_Ls",
		family: "Nunito",
		fullName: "Nunito ExtraBold",
		postScriptName: "Nunito-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IjghwvlJXzOK8BDEazSH1qyq.png",
		style: "Nunito-ExtraBold",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXI3I6Li01BKofiOc5wtlZ2di8HDDsmRTM9jo7eTWk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_exDTIDW3I170RlaaYUPxe4sj",
		family: "Nunito",
		fullName: "Nunito Black",
		postScriptName: "Nunito-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ELDMVnlg3wTPyVUvTRQid8r0.png",
		style: "Nunito-Black",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXI3I6Li01BKofiOc5wtlZ2di8HDBImRTM9jo7eTWk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9rFeCJj8ylyR7OsH9bGp9hOu",
		family: "Nunito",
		fullName: "Nunito Regular",
		postScriptName: "Nunito-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ek7uxSVplTinfdL_cmlu1VCz.png",
		style: "Nunito-Regular",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXI3I6Li01BKofiOc5wtlZ2di8HDLshRTM9jo7eTWk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JWTaBMXbY3N6urd6xBh7wFqm",
		family: "Nunito",
		fullName: "Nunito ExtraLight Italic",
		postScriptName: "Nunito-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6m7BndJy6h_1unWEgDKvw6cL.png",
		style: "Nunito-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNiLXA3iqzbXWnoeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TY8HFLwViW90n6VEswAUzn_S",
		family: "Nunito",
		fullName: "Nunito Light Italic",
		postScriptName: "Nunito-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/sIYYvEAsrkuhJR9n9qgk6wZU.png",
		style: "Nunito-LightItalic",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNi83A3iqzbXWnoeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_udKI5qagBiFOLyPpvwjdRMbk",
		family: "Nunito",
		fullName: "Nunito Italic",
		postScriptName: "Nunito-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6WcKnrfLqjw3zdbv11SRtFgD.png",
		style: "Nunito-Italic",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNirXA3iqzbXWnoeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ssWeoN67aVgZ6L6GRrnYP0W5",
		family: "Nunito",
		fullName: "Nunito Medium Italic",
		postScriptName: "Nunito-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pXogonAC8hTFDqnZkPYn52O1.png",
		style: "Nunito-MediumItalic",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNin3A3iqzbXWnoeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZR1s_D3LTrGgNehQqyDI2Gep",
		family: "Nunito",
		fullName: "Nunito SemiBold Italic",
		postScriptName: "Nunito-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4PwythJY5VNlsS9wgC2f3ELr.png",
		style: "Nunito-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNic3c3iqzbXWnoeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7nYIYKEQ4OQkzzzvf1K2Ph5J",
		family: "Nunito",
		fullName: "Nunito Bold Italic",
		postScriptName: "Nunito-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Rx492EtLPFlzxCqlQIiOQLtK.png",
		style: "Nunito-BoldItalic",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNiSnc3iqzbXWnoeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Rlpuwh7Fe6ZjG8__qKoNTQZW",
		family: "Nunito",
		fullName: "Nunito ExtraBold Italic",
		postScriptName: "Nunito-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/enss_aTsmUAYpQ8BBWavud8Q.png",
		style: "Nunito-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNiLXc3iqzbXWnoeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dDmMRtbyPSWXBiHt9xIM2VMc",
		family: "Nunito",
		fullName: "Nunito Black Italic",
		postScriptName: "Nunito-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nc9nblWWzFeqp0JLlZ8CfKx6.png",
		style: "Nunito-BlackItalic",
		url: "https://fonts.gstatic.com/s/nunito/v20/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNiBHc3iqzbXWnoeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NJwj5PhDqPY44PKhHPpSnmK3",
		family: "Open Sans",
		fullName: "Open Sans Light",
		postScriptName: "OpenSans-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/taiUnXrtWWJYMyCMSGTkam6f.png",
		style: "OpenSans-Light",
		url: "https://fonts.gstatic.com/s/opensans/v27/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4nY1M2xLER.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_AaM7GR8HIW32f60SuDUeKICU",
		family: "Open Sans",
		fullName: "Open Sans Medium",
		postScriptName: "OpenSans-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HkIWyeAjXwUabeS4yyx2nGFh.png",
		style: "OpenSans-Medium",
		url: "https://fonts.gstatic.com/s/opensans/v27/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjr0C4nY1M2xLER.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_L9MJNFwBBzJVGiaHXBC4wGDo",
		family: "Open Sans",
		fullName: "Open Sans SemiBold",
		postScriptName: "OpenSans-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/CMjj_iBGnILPegZ25CESDN8M.png",
		style: "OpenSans-SemiBold",
		url: "https://fonts.gstatic.com/s/opensans/v27/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4nY1M2xLER.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Mc0f3UpRlHEecz6tUao8Ozy0",
		family: "Open Sans",
		fullName: "Open Sans Bold",
		postScriptName: "OpenSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/oMqk67FiyVvJ3YSRD2P8SbXY.png",
		style: "OpenSans-Bold",
		url: "https://fonts.gstatic.com/s/opensans/v27/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4nY1M2xLER.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fK7BEy6UyGAzokUpvFKn_HoH",
		family: "Open Sans",
		fullName: "Open Sans ExtraBold",
		postScriptName: "OpenSans-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RaKrVBcGEp46ro96VsfvUhcg.png",
		style: "OpenSans-ExtraBold",
		url: "https://fonts.gstatic.com/s/opensans/v27/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgshZ1y4nY1M2xLER.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EVPKbE4mYXI1C6DFRmNIE50R",
		family: "Open Sans",
		fullName: "Open Sans Regular",
		postScriptName: "OpenSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pPQJIndt5wxVyrt8YaVd76Bf.png",
		style: "OpenSans-Regular",
		url: "https://fonts.gstatic.com/s/opensans/v27/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4nY1M2xLER.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3QF8l9PDrkXUlS5q9B30vcaj",
		family: "Open Sans",
		fullName: "Open Sans Light Italic",
		postScriptName: "OpenSans-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rTPKodKu7S3bz5yuMY_QSnrz.png",
		style: "OpenSans-LightItalic",
		url: "https://fonts.gstatic.com/s/opensans/v27/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0Rk5hkaVcUwaERZjA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_24j9X6_gcSn_lJgH6WjerqdR",
		family: "Open Sans",
		fullName: "Open Sans Italic",
		postScriptName: "OpenSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3xVHEANkbfNR1L1zPz1QzpHD.png",
		style: "OpenSans-Italic",
		url: "https://fonts.gstatic.com/s/opensans/v27/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0Rk8ZkaVcUwaERZjA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Eya8OnvLk8s2jzDZlzMAJMld",
		family: "Open Sans",
		fullName: "Open Sans Medium Italic",
		postScriptName: "OpenSans-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wrwxo_SByb7lbet56g4osAsF.png",
		style: "OpenSans-MediumItalic",
		url: "https://fonts.gstatic.com/s/opensans/v27/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0Rk_RkaVcUwaERZjA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KU0GuYdRTKmLqSr_UZBeGUHn",
		family: "Open Sans",
		fullName: "Open Sans SemiBold Italic",
		postScriptName: "OpenSans-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vFVhvQhEaPkfsPyl1PZh1Elh.png",
		style: "OpenSans-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/opensans/v27/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0RkxhjaVcUwaERZjA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Se4GBF7QiyhIQD0oWnj47KAN",
		family: "Open Sans",
		fullName: "Open Sans Bold Italic",
		postScriptName: "OpenSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/oF8bPpXo5a3Wtoo4QKGV6ElC.png",
		style: "OpenSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/opensans/v27/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0RkyFjaVcUwaERZjA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_yLFlTPgdpthzqLeJJqZscsrs",
		family: "Open Sans",
		fullName: "Open Sans ExtraBold Italic",
		postScriptName: "OpenSans-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/t9pe8zGLEg6l3LfL5yAixKEN.png",
		style: "OpenSans-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/opensans/v27/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0Rk0ZjaVcUwaERZjA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_REa1nGCvC4ZO1RORQmAODRMf",
		family: "PT Sans",
		fullName: "PT Sans Bold",
		postScriptName: "PTSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MVWc4jrSRLSHJWhpImCyA18n.png",
		style: "PTSans-Bold",
		url: "https://fonts.gstatic.com/s/ptsans/v12/jizfRExUiTo99u79B_mh4OmnLD0Z4zM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Cv8STS0YORUO5vmQ0fB1w7Cw",
		family: "PT Sans",
		fullName: "PT Sans Regular",
		postScriptName: "PTSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bgf5BqiXlPZREhLygL4dVXbC.png",
		style: "PTSans-Regular",
		url: "https://fonts.gstatic.com/s/ptsans/v12/jizaRExUiTo99u79P0WOxOGMMDQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_BLxmFoIw0Yy9aTWE_jCFIjRi",
		family: "PT Sans",
		fullName: "PT Sans Italic",
		postScriptName: "PTSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/byANHuUBSuKZkkMxfIh63aPE.png",
		style: "PTSans-Italic",
		url: "https://fonts.gstatic.com/s/ptsans/v12/jizYRExUiTo99u79D0eEwMOJIDQA-g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MCqpg1jnzt6NNc065nNdPVI9",
		family: "PT Sans",
		fullName: "PT Sans Bold Italic",
		postScriptName: "PTSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/0ReBK0zatiB8qZLK9xxfwuZy.png",
		style: "PTSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/ptsans/v12/jizdRExUiTo99u79D0e8fOytKB8c8zMrig.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ch8IkY19twzqEX5ZOtExxTal",
		family: "Pacifico",
		fullName: "Pacifico Regular",
		postScriptName: "Pacifico-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FwHmtrq_9yBS7yt8Jh5QEcdv.png",
		style: "Pacifico-Regular",
		url: "https://fonts.gstatic.com/s/pacifico/v17/FwZY7-Qmy14u9lezJ96A4sijpFu_.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_R94wQBeEwGrAQO1ajewQzmaV",
		family: "Palanquin",
		fullName: "Palanquin Thin",
		postScriptName: "Palanquin-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AyOFaz3jQXRrD49Y2p8OnuWk.png",
		style: "Palanquin-Thin",
		url: "https://fonts.gstatic.com/s/palanquin/v10/9XUhlJ90n1fBFg7ceXwUEltI7rWmZzTH.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_F_clSsgTkT8nA49JAFEbkjuz",
		family: "Palanquin",
		fullName: "Palanquin ExtraLight",
		postScriptName: "Palanquin-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4ElZFBQCh8qcg4XbWHa90ERx.png",
		style: "Palanquin-ExtraLight",
		url: "https://fonts.gstatic.com/s/palanquin/v10/9XUilJ90n1fBFg7ceXwUvnpoxJuqbi3ezg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_g0PcgKttltqZJoR7FnnhVjYP",
		family: "Palanquin",
		fullName: "Palanquin Light",
		postScriptName: "Palanquin-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RqvllGiRyZHHd8h1xl_Q1akV.png",
		style: "Palanquin-Light",
		url: "https://fonts.gstatic.com/s/palanquin/v10/9XUilJ90n1fBFg7ceXwU2nloxJuqbi3ezg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IrdbPmljnOIU8J3P0KMgbL6c",
		family: "Palanquin",
		fullName: "Palanquin Medium",
		postScriptName: "Palanquin-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/kzIl14VkKUowIN1b9NiUduQT.png",
		style: "Palanquin-Medium",
		url: "https://fonts.gstatic.com/s/palanquin/v10/9XUilJ90n1fBFg7ceXwUgnhoxJuqbi3ezg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IBzmtlCy4MN1nfEK3Kcu2ztk",
		family: "Palanquin",
		fullName: "Palanquin SemiBold",
		postScriptName: "Palanquin-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jaFXyTfK6seXSOFuU8yg0mup.png",
		style: "Palanquin-SemiBold",
		url: "https://fonts.gstatic.com/s/palanquin/v10/9XUilJ90n1fBFg7ceXwUrn9oxJuqbi3ezg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5TTLZoVKIz_zqSwkV99SPBK8",
		family: "Palanquin",
		fullName: "Palanquin Bold",
		postScriptName: "Palanquin-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/sSGyBO5yjNmt1Ep_RNPc26zG.png",
		style: "Palanquin-Bold",
		url: "https://fonts.gstatic.com/s/palanquin/v10/9XUilJ90n1fBFg7ceXwUyn5oxJuqbi3ezg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TuVj6qzqBN4n7rRUwx2Hsomk",
		family: "Palanquin",
		fullName: "Palanquin Regular",
		postScriptName: "Palanquin-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jK3EvJ4ugYFcwKNt4nczJ_Lo.png",
		style: "Palanquin-Regular",
		url: "https://fonts.gstatic.com/s/palanquin/v10/9XUnlJ90n1fBFg7ceXwsdlFMzLC2Zw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Ks2haMDM6qlviQfrceYJVFSS",
		family: "Press Start 2P",
		fullName: "Press Start 2P Regular",
		postScriptName: "PressStart2P-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mu37eQuMoFE26rRqty4vc3IY.png",
		style: "PressStart2P-Regular",
		url: "https://fonts.gstatic.com/s/pressstart2p/v9/e3t4euO8T-267oIAQAu6jDQyK0nSgPJE4580.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4DT7Mhq6FDUdzeQ33_FG1MNw",
		family: "Poiret One",
		fullName: "Poiret One Regular",
		postScriptName: "PoiretOne-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fI9fzHU8D4acbW3yxq6N7bbP.png",
		style: "PoiretOne-Regular",
		url: "https://fonts.gstatic.com/s/poiretone/v9/UqyVK80NJXN4zfRgbdfbk5lWVscxdKE.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kMOXW5ulFkqu93sfS1d6wyxQ",
		family: "Quicksand",
		fullName: "Quicksand Light",
		postScriptName: "Quicksand-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zLVhrIZ_C4GzRn8013oo4bDU.png",
		style: "Quicksand-Light",
		url: "https://fonts.gstatic.com/s/quicksand/v24/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkKEo18G0wx40QDw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SS_hKLPcxJr0Arh1LpujzwXZ",
		family: "Quicksand",
		fullName: "Quicksand Medium",
		postScriptName: "Quicksand-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/PW5klKg6uR1qLG959DNdhpQY.png",
		style: "Quicksand-Medium",
		url: "https://fonts.gstatic.com/s/quicksand/v24/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkM0o18G0wx40QDw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_D0USh4A6Mx61sLufLGXcbU8C",
		family: "Quicksand",
		fullName: "Quicksand SemiBold",
		postScriptName: "Quicksand-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ZfLIYJ9XIkTJSV06kQJnSZS8.png",
		style: "Quicksand-SemiBold",
		url: "https://fonts.gstatic.com/s/quicksand/v24/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkCEv18G0wx40QDw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_oLvhqCqc8ce5l2UW9Tw4goRF",
		family: "Quicksand",
		fullName: "Quicksand Bold",
		postScriptName: "Quicksand-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/oXtv09z3q18hDdSpnD22DUy9.png",
		style: "Quicksand-Bold",
		url: "https://fonts.gstatic.com/s/quicksand/v24/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkBgv18G0wx40QDw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fb9eM_jF_VcvfprigzoESvJn",
		family: "Quicksand",
		fullName: "Quicksand Regular",
		postScriptName: "Quicksand-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/usM2rsIe5hRaRAqL1FMdXywr.png",
		style: "Quicksand-Regular",
		url: "https://fonts.gstatic.com/s/quicksand/v24/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkP8o18G0wx40QDw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZFXoEaK20bCkv0ivDNI8YWqS",
		family: "Roboto Condensed",
		fullName: "Roboto Condensed Light",
		postScriptName: "RobotoCondensed-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rX3u9TsvBeHSMVbjzGgGcGpk.png",
		style: "RobotoCondensed-Light",
		url: "https://fonts.gstatic.com/s/robotocondensed/v19/ieVi2ZhZI2eCN5jzbjEETS9weq8-33mZKCMSbvtdYyQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Gnp9oGUTxUgtgaWO42v1bS5J",
		family: "Roboto Condensed",
		fullName: "Roboto Condensed Bold",
		postScriptName: "RobotoCondensed-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Xtxi1d0zQXEHXaUqwIRRBUSR.png",
		style: "RobotoCondensed-Bold",
		url: "https://fonts.gstatic.com/s/robotocondensed/v19/ieVi2ZhZI2eCN5jzbjEETS9weq8-32meKCMSbvtdYyQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0iNpzuDztSG_GGmZkN6q9359",
		family: "Roboto Condensed",
		fullName: "Roboto Condensed Light Italic",
		postScriptName: "RobotoCondensed-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/QvDFsLiyboAUNIGIFEwDMkLH.png",
		style: "RobotoCondensed-LightItalic",
		url: "https://fonts.gstatic.com/s/robotocondensed/v19/ieVg2ZhZI2eCN5jzbjEETS9weq8-19eDpCEYatlYcyRi4A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tde9dcPXp9ajH149sYHbNA7n",
		family: "Roboto Condensed",
		fullName: "Roboto Condensed Regular",
		postScriptName: "RobotoCondensed-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/QhzN7ckruDN7Oy8fm8xsNt6w.png",
		style: "RobotoCondensed-Regular",
		url: "https://fonts.gstatic.com/s/robotocondensed/v19/ieVl2ZhZI2eCN5jzbjEETS9weq8-59WxDCs5cvI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EqpAer5a4BMKrCdGCLdps9al",
		family: "Roboto Condensed",
		fullName: "Roboto Condensed Italic",
		postScriptName: "RobotoCondensed-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/84fFMBFOLIAaoZ8cUs3cQt1g.png",
		style: "RobotoCondensed-Italic",
		url: "https://fonts.gstatic.com/s/robotocondensed/v19/ieVj2ZhZI2eCN5jzbjEETS9weq8-19e7CAk8YvJEeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lQ7pMg8kB7wHEOIAqevCQEKh",
		family: "Roboto Condensed",
		fullName: "Roboto Condensed Bold Italic",
		postScriptName: "RobotoCondensed-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pASeC8theHRbM1SfHu6n7d1w.png",
		style: "RobotoCondensed-BoldItalic",
		url: "https://fonts.gstatic.com/s/robotocondensed/v19/ieVg2ZhZI2eCN5jzbjEETS9weq8-19eDtCYYatlYcyRi4A.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xkLhUhfZnJCP6MpAqCV5EQ84",
		family: "Roboto Slab",
		fullName: "Roboto Slab Thin",
		postScriptName: "RobotoSlab-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/CykRewG1Nvy24fH6Osy0A0M5.png",
		style: "RobotoSlab-Thin",
		url: "https://fonts.gstatic.com/s/robotoslab/v16/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojIWWaG5iddG-1A.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_mHVj26Tjm5CUIw1PTiv3Msy6",
		family: "Roboto Slab",
		fullName: "Roboto Slab ExtraLight",
		postScriptName: "RobotoSlab-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/T7CFSjqQVpYCp5Sszmt11lQ9.png",
		style: "RobotoSlab-ExtraLight",
		url: "https://fonts.gstatic.com/s/robotoslab/v16/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoDISWaG5iddG-1A.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_q2Ck1zarIrZ2jqqI4pOeagLk",
		family: "Roboto Slab",
		fullName: "Roboto Slab Light",
		postScriptName: "RobotoSlab-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Tjgo450aIcD5NeKIKU44gwmd.png",
		style: "RobotoSlab-Light",
		url: "https://fonts.gstatic.com/s/robotoslab/v16/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjo0oSWaG5iddG-1A.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_W8UyfG9wFWRTpIA0kCThFTxD",
		family: "Roboto Slab",
		fullName: "Roboto Slab Medium",
		postScriptName: "RobotoSlab-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gSNhR_djtJqo2cj_wnp12Y4M.png",
		style: "RobotoSlab-Medium",
		url: "https://fonts.gstatic.com/s/robotoslab/v16/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjovoSWaG5iddG-1A.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TH2b_gaHMuyP6VNsMzL0TSWu",
		family: "Roboto Slab",
		fullName: "Roboto Slab SemiBold",
		postScriptName: "RobotoSlab-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NjNIxGQzjxDdfi3HlX45faqV.png",
		style: "RobotoSlab-SemiBold",
		url: "https://fonts.gstatic.com/s/robotoslab/v16/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoUoOWaG5iddG-1A.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZAvV5b_d26fae3V4yTq1IIvt",
		family: "Roboto Slab",
		fullName: "Roboto Slab Bold",
		postScriptName: "RobotoSlab-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DM0bFI66Tnz8PMv6_7uirfsZ.png",
		style: "RobotoSlab-Bold",
		url: "https://fonts.gstatic.com/s/robotoslab/v16/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoa4OWaG5iddG-1A.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_aVwwzxymZAmWFfrv06GWpSNj",
		family: "Roboto Slab",
		fullName: "Roboto Slab ExtraBold",
		postScriptName: "RobotoSlab-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WaCGLHduwFYi9MXudn4S0cJl.png",
		style: "RobotoSlab-ExtraBold",
		url: "https://fonts.gstatic.com/s/robotoslab/v16/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoDIOWaG5iddG-1A.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_CCtkr6nuMImDJ1wQIlS3RdXx",
		family: "Roboto Slab",
		fullName: "Roboto Slab Black",
		postScriptName: "RobotoSlab-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7wr7SBzqDVTospNnt6AEIQ4C.png",
		style: "RobotoSlab-Black",
		url: "https://fonts.gstatic.com/s/robotoslab/v16/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoJYOWaG5iddG-1A.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fOAogwwPxKlniPnexldaescS",
		family: "Roboto Slab",
		fullName: "Roboto Slab Regular",
		postScriptName: "RobotoSlab-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rwqRlnVQDhJ_j_4eP07uB1F5.png",
		style: "RobotoSlab-Regular",
		url: "https://fonts.gstatic.com/s/robotoslab/v16/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojISWaG5iddG-1A.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4KM66NdxCcv0FWeWO00PQXSt",
		family: "Teko",
		fullName: "Teko Light",
		postScriptName: "Teko-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Xfg9Mnrt61oOQBTw3wZs2LtR.png",
		style: "Teko-Light",
		url: "https://fonts.gstatic.com/s/teko/v10/LYjCdG7kmE0gdQhfgCNqqVIuTN4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_J0u9rEGWXcebbca70uMBNjrQ",
		family: "Teko",
		fullName: "Teko Medium",
		postScriptName: "Teko-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Ui5G73pdQ_VY8PIaAPaOoNoy.png",
		style: "Teko-Medium",
		url: "https://fonts.gstatic.com/s/teko/v10/LYjCdG7kmE0gdVBegCNqqVIuTN4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JM7X4H5vkXVIZod27pzx6qKz",
		family: "Teko",
		fullName: "Teko SemiBold",
		postScriptName: "Teko-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/F_O8wa6ImMMnSazVHrZK5JlC.png",
		style: "Teko-SemiBold",
		url: "https://fonts.gstatic.com/s/teko/v10/LYjCdG7kmE0gdXxZgCNqqVIuTN4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_XmulrNQ3uGHmyOXx5wRmj3HZ",
		family: "Teko",
		fullName: "Teko Bold",
		postScriptName: "Teko-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/g3qIkAx4LqB1vI9lkLqMtWbL.png",
		style: "Teko-Bold",
		url: "https://fonts.gstatic.com/s/teko/v10/LYjCdG7kmE0gdRhYgCNqqVIuTN4.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JeZypwcNHnlWkLaO5n_c4Dtq",
		family: "Teko",
		fullName: "Teko Regular",
		postScriptName: "Teko-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/x78Yig2Jh0_8jN1SkYcTFwGc.png",
		style: "Teko-Regular",
		url: "https://fonts.gstatic.com/s/teko/v10/LYjNdG7kmE0gTaR3pCtBtVs.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QoF41AaPULTEKHPouTT5CSOC",
		family: "Vollkorn",
		fullName: "Vollkorn Medium",
		postScriptName: "Vollkorn-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/TmtXrYMYQH6pD3bVdyBavSQ0.png",
		style: "Vollkorn-Medium",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2AnGuGWOdEbD63w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IQxDlh_PxscmbvITuUtMzmCx",
		family: "Vollkorn",
		fullName: "Vollkorn SemiBold",
		postScriptName: "Vollkorn-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lfnwax7v39baypS5ihM9p69a.png",
		style: "Vollkorn-SemiBold",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df27nauGWOdEbD63w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_B6ZUERUrwltADCJLq08ZXJQp",
		family: "Vollkorn",
		fullName: "Vollkorn Bold",
		postScriptName: "Vollkorn-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KfAeHCP1zlJ4CRPEM10i0Cz6.png",
		style: "Vollkorn-Bold",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df213auGWOdEbD63w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_P0drutOzCPpjvjTYk98bqrmW",
		family: "Vollkorn",
		fullName: "Vollkorn ExtraBold",
		postScriptName: "Vollkorn-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/YoB7RkwJUgyU5D0YmIWEvXqN.png",
		style: "Vollkorn-ExtraBold",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2sHauGWOdEbD63w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WOpVyMrauy3D8kNOFt6gO9nP",
		family: "Vollkorn",
		fullName: "Vollkorn Black",
		postScriptName: "Vollkorn-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/noR6KJeTTK36hzpieo3CY3Od.png",
		style: "Vollkorn-Black",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2mXauGWOdEbD63w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vZIk2s0WgShXpk3qIWSn0ToK",
		family: "Vollkorn",
		fullName: "Vollkorn Regular",
		postScriptName: "Vollkorn-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AIUskmjP5z3bjiFI6RWx1DFZ.png",
		style: "Vollkorn-Regular",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2MHGuGWOdEbD63w.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UL9_hDFxbK7_n5oSHJPH3rOR",
		family: "Vollkorn",
		fullName: "Vollkorn Italic",
		postScriptName: "Vollkorn-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JcZqfgqh_tDYfuQYnJxT_xGP.png",
		style: "Vollkorn-Italic",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DJGWmmZM7Xq34g9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6luq1VCPlRDjCFeK25fNrtOH",
		family: "Vollkorn",
		fullName: "Vollkorn Medium Italic",
		postScriptName: "Vollkorn-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JEFpHwq4vh7N39LV3HdfBMhU.png",
		style: "Vollkorn-MediumItalic",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DJ0WmmZM7Xq34g9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_iKrWYLFA6mHKpqs7C4JjXQn6",
		family: "Vollkorn",
		fullName: "Vollkorn SemiBold Italic",
		postScriptName: "Vollkorn-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/642Ba6Zk0SprQfE8JWg2xbdO.png",
		style: "Vollkorn-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DKYXWmZM7Xq34g9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pkuhv8q6xR2jFbmL2jG4cqDL",
		family: "Vollkorn",
		fullName: "Vollkorn Bold Italic",
		postScriptName: "Vollkorn-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Lr107JTnXYNc4CcxRXcQ_sUO.png",
		style: "Vollkorn-BoldItalic",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DKhXWmZM7Xq34g9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_56szh2uXyO3ZzV6UMJPupVCd",
		family: "Vollkorn",
		fullName: "Vollkorn ExtraBold Italic",
		postScriptName: "Vollkorn-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/xs_IfVfU_lgiMhZnvDdzxCpW.png",
		style: "Vollkorn-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DLGXWmZM7Xq34g9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xurLAPG3w4CR_yXw029f43ZM",
		family: "Vollkorn",
		fullName: "Vollkorn Black Italic",
		postScriptName: "Vollkorn-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WgxWWm6ogdibQMeG3QdpUi8C.png",
		style: "Vollkorn-BlackItalic",
		url: "https://fonts.gstatic.com/s/vollkorn/v13/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DLvXWmZM7Xq34g9.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_OIziTlP2euGfshtTDB17g34l",
		family: "Prompt",
		fullName: "Prompt Thin",
		postScriptName: "Prompt-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/A7h8e__tsgc1cipAEWIKq2jU.png",
		style: "Prompt-Thin",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_9XJnvUD7dzB2CA9oYREcjeo0k.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Y9I_gIAdRr_TKp1h1lEQxOeR",
		family: "Prompt",
		fullName: "Prompt ExtraLight",
		postScriptName: "Prompt-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/T2XZydBay3D8HYiD7_0Wwj2I.png",
		style: "Prompt-ExtraLight",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_8XJnvUD7dzB2Cr_s4bmkvc5Q9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PpgRU3M2MQntlT55_LTdOb4G",
		family: "Prompt",
		fullName: "Prompt Light",
		postScriptName: "Prompt-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pRkbGsvKLW2UmRwb2ULy_Saq.png",
		style: "Prompt-Light",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_8XJnvUD7dzB2Cy_g4bmkvc5Q9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TqFNH7yiPag_mMMt7_4obrpb",
		family: "Prompt",
		fullName: "Prompt Medium",
		postScriptName: "Prompt-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/l41bysPha8L9gRAGFDEVVuq_.png",
		style: "Prompt-Medium",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_8XJnvUD7dzB2Ck_k4bmkvc5Q9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_D9YYo8ws71UQzLWv7u46QVZc",
		family: "Prompt",
		fullName: "Prompt SemiBold",
		postScriptName: "Prompt-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SQqASq_Jprh_9ezaQ7KpxjU0.png",
		style: "Prompt-SemiBold",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_8XJnvUD7dzB2Cv_44bmkvc5Q9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_oCbUOkRK5JB3OegFOXymhQPc",
		family: "Prompt",
		fullName: "Prompt Bold",
		postScriptName: "Prompt-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/TEBxquVHloX1D5Jv_L4Mwhsi.png",
		style: "Prompt-Bold",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_8XJnvUD7dzB2C2_84bmkvc5Q9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GnyV2j6XyTtpcL_jlBMhz9zB",
		family: "Prompt",
		fullName: "Prompt ExtraBold",
		postScriptName: "Prompt-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uj9FoF1nAEVIQYAx6gXWRyhi.png",
		style: "Prompt-ExtraBold",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_8XJnvUD7dzB2Cx_w4bmkvc5Q9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IvTv1nJsxNzrCEb9OrtkCkWL",
		family: "Prompt",
		fullName: "Prompt Black",
		postScriptName: "Prompt-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9Nygtr1P6b64yfk9DO8xJPGB.png",
		style: "Prompt-Black",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_8XJnvUD7dzB2C4_04bmkvc5Q9dw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QeNyIjAfj0IG7bIo2fNiUJod",
		family: "Prompt",
		fullName: "Prompt Thin Italic",
		postScriptName: "Prompt-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aJbO11TIDEiLA_LDjN1dDO7N.png",
		style: "Prompt-ThinItalic",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_7XJnvUD7dzB2KZeJ8TkMBf50kbiM.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FImseSW8NVePx1iaNDn_zp3G",
		family: "Prompt",
		fullName: "Prompt ExtraLight Italic",
		postScriptName: "Prompt-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9KbYk_dkfFiDH373ls_Uz_Kf.png",
		style: "Prompt-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_6XJnvUD7dzB2KZeLQb2MrUZEtdzow.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xZoPcSxqMwvtJBWbOR1pFlI_",
		family: "Prompt",
		fullName: "Prompt Light Italic",
		postScriptName: "Prompt-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4HbLTJ6AJyZK66T7OjnNWPib.png",
		style: "Prompt-LightItalic",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_6XJnvUD7dzB2KZeK0bGMrUZEtdzow.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NUbWLrRYL4s0nPNr9G1giyt4",
		family: "Prompt",
		fullName: "Prompt Regular",
		postScriptName: "Prompt-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aO8QuAXoZi2XfhC9vfm9vj3M.png",
		style: "Prompt-Regular",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W__XJnvUD7dzB26Z9AcZkIzeg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UhzP6PlgwU061w89LISxLm2P",
		family: "Prompt",
		fullName: "Prompt Italic",
		postScriptName: "Prompt-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7PGvTKbhXdTRjDvpjKSL4otX.png",
		style: "Prompt-Italic",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_9XJnvUD7dzB2KZdoYREcjeo0k.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tl9BAhr8YxkiqenScEcQV7ij",
		family: "Prompt",
		fullName: "Prompt Medium Italic",
		postScriptName: "Prompt-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/US98z81lpT_fDw7ixNb_GtZE.png",
		style: "Prompt-MediumItalic",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_6XJnvUD7dzB2KZeLsbWMrUZEtdzow.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_aWkBnfsaLdRxY9eea89mS7sZ",
		family: "Prompt",
		fullName: "Prompt SemiBold Italic",
		postScriptName: "Prompt-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5rFFKdydJJNjMStCwJH_lxiw.png",
		style: "Prompt-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_6XJnvUD7dzB2KZeLAamMrUZEtdzow.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nqD1Ba8yKQFt08ZptnTMxmmZ",
		family: "Prompt",
		fullName: "Prompt Bold Italic",
		postScriptName: "Prompt-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AD0PTSWzs8xIeQFv5wFiM85x.png",
		style: "Prompt-BoldItalic",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_6XJnvUD7dzB2KZeKka2MrUZEtdzow.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tasbNR23d9d4Vta5O0JEgVUy",
		family: "Prompt",
		fullName: "Prompt ExtraBold Italic",
		postScriptName: "Prompt-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/cE7hRfHJxGvXZaa5G2iUNpeL.png",
		style: "Prompt-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_6XJnvUD7dzB2KZeK4aGMrUZEtdzow.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ZOIxhk3ffM3Ow5aYXkSx0n_H",
		family: "Prompt",
		fullName: "Prompt Black Italic",
		postScriptName: "Prompt-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fJwvc4KrqC80HGCuNoGg7EFJ.png",
		style: "Prompt-BlackItalic",
		url: "https://fonts.gstatic.com/s/prompt/v5/-W_6XJnvUD7dzB2KZeKcaWMrUZEtdzow.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6lOl3AWgKBYsCWz7TBrm56zV",
		family: "Rajdhani",
		fullName: "Rajdhani Light",
		postScriptName: "Rajdhani-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_zx51pJWCJQict7Ekr5p5JIX.png",
		style: "Rajdhani-Light",
		url: "https://fonts.gstatic.com/s/rajdhani/v10/LDI2apCSOBg7S-QT7pasEcOsc-bGkqIw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_myJ1MrSEi3BAdDflLVxdGmLZ",
		family: "Rajdhani",
		fullName: "Rajdhani Medium",
		postScriptName: "Rajdhani-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_aocmXQLjOC3JiwM2uGycBTw.png",
		style: "Rajdhani-Medium",
		url: "https://fonts.gstatic.com/s/rajdhani/v10/LDI2apCSOBg7S-QT7pb0EMOsc-bGkqIw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ECw5fCnRS0hrIWjWHvwxr73e",
		family: "Rajdhani",
		fullName: "Rajdhani SemiBold",
		postScriptName: "Rajdhani-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/iRF47rcfzc06UFB8P0Q3lUSo.png",
		style: "Rajdhani-SemiBold",
		url: "https://fonts.gstatic.com/s/rajdhani/v10/LDI2apCSOBg7S-QT7pbYF8Osc-bGkqIw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_my7pTXnV6gA8ipL766jSghQl",
		family: "Rajdhani",
		fullName: "Rajdhani Bold",
		postScriptName: "Rajdhani-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Z7BnB1qkJtvlSzwEz_9zWIMf.png",
		style: "Rajdhani-Bold",
		url: "https://fonts.gstatic.com/s/rajdhani/v10/LDI2apCSOBg7S-QT7pa8FsOsc-bGkqIw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Po4q1ruBOeZKUpbjenFRZbgv",
		family: "Rajdhani",
		fullName: "Rajdhani Regular",
		postScriptName: "Rajdhani-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/f8kwyEqY2C3ZbK8xv07DlvlP.png",
		style: "Rajdhani-Regular",
		url: "https://fonts.gstatic.com/s/rajdhani/v10/LDIxapCSOBg7S-QT7q4AOeekWPrP.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ScbhBRFc4eW5jztDHMe8Zzg2",
		family: "Rye",
		fullName: "Rye Regular",
		postScriptName: "Rye-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zqYzbYppCxCEfmYJZ3gkHcFL.png",
		style: "Rye-Regular",
		url: "https://fonts.gstatic.com/s/rye/v8/r05XGLJT86YDFpTsXOqx4w.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_U9_HeoJ0W24LkBy8S4HdDo8D",
		family: "Shadows Into Light",
		fullName: "Shadows Into Light Regular",
		postScriptName: "ShadowsIntoLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/K4WzJgYX02r10MerF7nPOtgW.png",
		style: "ShadowsIntoLight",
		url: "https://fonts.gstatic.com/s/shadowsintolight/v10/UqyNK9UOIntux_czAvDQx_ZcHqZXBNQDcsr4xzSMYA.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WeCpQpkHdonL4yoxJWSDSJ3Z",
		family: "Tinos",
		fullName: "Tinos Bold",
		postScriptName: "Tinos-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/SSk9mR8k85s7ep6jcQBFjZcI.png",
		style: "Tinos-Bold",
		url: "https://fonts.gstatic.com/s/tinos/v16/buE1poGnedXvwj1AW0Fp2i43-cxL.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_W491vTgbSB4A3No8UfJpD71v",
		family: "Tinos",
		fullName: "Tinos Regular",
		postScriptName: "Tinos-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RWEZxqVK4bUYwTTjJ5pznpTk.png",
		style: "Tinos-Regular",
		url: "https://fonts.gstatic.com/s/tinos/v16/buE4poGnedXvwgX8dGVh8TI-.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8CDBb90KrwqnkoVRK72wLFN7",
		family: "Tinos",
		fullName: "Tinos Italic",
		postScriptName: "Tinos-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RaUzGcxUoUxQ3qZtcarU8HpK.png",
		style: "Tinos-Italic",
		url: "https://fonts.gstatic.com/s/tinos/v16/buE2poGnedXvwjX-fmFD9CI-4NU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QBGLFc4vJajtRoCLMqJZwE9Q",
		family: "Tinos",
		fullName: "Tinos Bold Italic",
		postScriptName: "Tinos-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/jQkiq09y5KLdWvwLPuJzHTxA.png",
		style: "Tinos-BoldItalic",
		url: "https://fonts.gstatic.com/s/tinos/v16/buEzpoGnedXvwjX-Rt1s0CoV_NxLeiw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8zCteihMY8S1igcXSwXJUvHI",
		family: "Yanone Kaffeesatz",
		fullName: "Yanone Kaffeesatz ExtraLight",
		postScriptName: "YanoneKaffeesatz-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MSo3D69fwMHL4lvOfKuMmy0H.png",
		style: "YanoneKaffeesatz-ExtraLight",
		url: "https://fonts.gstatic.com/s/yanonekaffeesatz/v18/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftodtWpcGuLCnXkVA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9q1ebbNIvsDxW29KGleNta0G",
		family: "Yanone Kaffeesatz",
		fullName: "Yanone Kaffeesatz Light",
		postScriptName: "YanoneKaffeesatz-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OUxPVZiDmIRx7IU8N0fJS50Y.png",
		style: "YanoneKaffeesatz-Light",
		url: "https://fonts.gstatic.com/s/yanonekaffeesatz/v18/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoqNWpcGuLCnXkVA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YClcJvxWe1DMRq6PdOkJExtP",
		family: "Yanone Kaffeesatz",
		fullName: "Yanone Kaffeesatz Medium",
		postScriptName: "YanoneKaffeesatz-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mpeUNU5hl78shXIc58MK3e6u.png",
		style: "YanoneKaffeesatz-Medium",
		url: "https://fonts.gstatic.com/s/yanonekaffeesatz/v18/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoxNWpcGuLCnXkVA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pVHP4UznClVizHgolanxoKIA",
		family: "Yanone Kaffeesatz",
		fullName: "Yanone Kaffeesatz SemiBold",
		postScriptName: "YanoneKaffeesatz-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vC4e7a6xzwmevQ3wGCHXMD7f.png",
		style: "YanoneKaffeesatz-SemiBold",
		url: "https://fonts.gstatic.com/s/yanonekaffeesatz/v18/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoKNKpcGuLCnXkVA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Kx_q3Dhdip4erafk0fN2xHfM",
		family: "Yanone Kaffeesatz",
		fullName: "Yanone Kaffeesatz Bold",
		postScriptName: "YanoneKaffeesatz-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/EQo_BlYulsPQr5PEh9khSvlr.png",
		style: "YanoneKaffeesatz-Bold",
		url: "https://fonts.gstatic.com/s/yanonekaffeesatz/v18/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoEdKpcGuLCnXkVA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_W5jbzpmu5YS5y5uHnnkVuxyO",
		family: "Yanone Kaffeesatz",
		fullName: "Yanone Kaffeesatz Regular",
		postScriptName: "YanoneKaffeesatz-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lYzdnSHNQ9ChngyxtpWifwOy.png",
		style: "YanoneKaffeesatz-Regular",
		url: "https://fonts.gstatic.com/s/yanonekaffeesatz/v18/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIfto9tWpcGuLCnXkVA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Rno44Z91kQt2e_UOPmWg4Ue6",
		family: "Zilla Slab",
		fullName: "Zilla Slab Light",
		postScriptName: "ZillaSlab-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6DY_QtXMdMXjs8hXFLzlYM6w.png",
		style: "ZillaSlab-Light",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFa5ZfeM_74wlPZtksIFYpEY2HSjWlhzbaw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tpPfpgqyr_caGI670dYy9oqy",
		family: "Zilla Slab",
		fullName: "Zilla Slab Medium",
		postScriptName: "ZillaSlab-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/q4J74zcorRfLVe3C30qYkMkY.png",
		style: "ZillaSlab-Medium",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFa5ZfeM_74wlPZtksIFYskZ2HSjWlhzbaw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pIHFJPGh4zPyct7vP7aKFZQD",
		family: "Zilla Slab",
		fullName: "Zilla Slab SemiBold",
		postScriptName: "ZillaSlab-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/yKEmqS7woIKvaOps_1q3Gjed.png",
		style: "ZillaSlab-SemiBold",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFa5ZfeM_74wlPZtksIFYuUe2HSjWlhzbaw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_XWtyzjAp6wONB0PAVyTc5nJt",
		family: "Zilla Slab",
		fullName: "Zilla Slab Bold",
		postScriptName: "ZillaSlab-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OtZZkrO2TQBDZK4bJrSxJNSF.png",
		style: "ZillaSlab-Bold",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFa5ZfeM_74wlPZtksIFYoEf2HSjWlhzbaw.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_edF1lEGuwzX50BqUq2OA8bbT",
		family: "Zilla Slab",
		fullName: "Zilla Slab Light Italic",
		postScriptName: "ZillaSlab-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/j0bXeYeBOcKJpdhiI3YfJYg5.png",
		style: "ZillaSlab-LightItalic",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFanZfeM_74wlPZtksIFaj8CVHapXnp2fazkfg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xIov_YKjX5tlLU7rMTGG1yFu",
		family: "Zilla Slab",
		fullName: "Zilla Slab Regular",
		postScriptName: "ZillaSlab-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/cz7Yr4R2mn9bfhzRvGyVVbZy.png",
		style: "ZillaSlab-Regular",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFa6ZfeM_74wlPZtksIFWj0w_HyIRlE.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Ti1KXcrQiF50m_eTNmaZrOhb",
		family: "Zilla Slab",
		fullName: "Zilla Slab Italic",
		postScriptName: "ZillaSlab-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pUs6KIKLqAtPgRmZftFJyWza.png",
		style: "ZillaSlab-Italic",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFa4ZfeM_74wlPZtksIFaj86-F6NVlFqdA.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GAlqmLQPV_UNegVwWnq3ZyXD",
		family: "Zilla Slab",
		fullName: "Zilla Slab Medium Italic",
		postScriptName: "ZillaSlab-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DjZgPm8EuomnTyhCamfbvTg1.png",
		style: "ZillaSlab-MediumItalic",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFanZfeM_74wlPZtksIFaj8CDHepXnp2fazkfg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_826zCenrrcc8bts7f5wfNVdB",
		family: "Zilla Slab",
		fullName: "Zilla Slab SemiBold Italic",
		postScriptName: "ZillaSlab-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/31iLY850WY59f86lpjxdnTeF.png",
		style: "ZillaSlab-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFanZfeM_74wlPZtksIFaj8CIHCpXnp2fazkfg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ppDuxNoJSUKpYbmhN5CsnotX",
		family: "Zilla Slab",
		fullName: "Zilla Slab Bold Italic",
		postScriptName: "ZillaSlab-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MNzIJ1N_9Ss4i0ypBpz2PvCv.png",
		style: "ZillaSlab-BoldItalic",
		url: "https://fonts.gstatic.com/s/zillaslab/v6/dFanZfeM_74wlPZtksIFaj8CRHGpXnp2fazkfg.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_8z94CiQQrONYsE7EFapLhWlY",
		family: "Poppins",
		fullName: "Poppins Thin",
		postScriptName: "Poppins-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JEfO4mAzvZp4OPKaurbMKDs3.png",
		style: "Poppins-Thin",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_n7IFuIk38AxGKb2Zkc5whnbD",
		family: "Poppins",
		fullName: "Poppins ExtraLight",
		postScriptName: "Poppins-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3RcJHlQtzBt03ReNASBsnbts.png",
		style: "Poppins-ExtraLight",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xHHfgtAF6djXtR4Y_JzMDUDi",
		family: "Poppins",
		fullName: "Poppins Light",
		postScriptName: "Poppins-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/L9DKQVxdTPZ_BKBvpvJyNL2v.png",
		style: "Poppins-Light",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EABG1UqnAk8drHoGg5qg3XD3",
		family: "Poppins",
		fullName: "Poppins Medium",
		postScriptName: "Poppins-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/JkeSEUjjHx6GRm34Bl2IqL0e.png",
		style: "Poppins-Medium",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_BFWZiP2cYZqizs2IuVh7anVR",
		family: "Poppins",
		fullName: "Poppins SemiBold",
		postScriptName: "Poppins-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ajl7zAp35HbNLGWrVOFgmklt.png",
		style: "Poppins-SemiBold",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ockIHIpXw3k6VsJUsyeHIAV7",
		family: "Poppins",
		fullName: "Poppins Bold",
		postScriptName: "Poppins-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6pfxNhSnTOzGSCCxGVjMi7pw.png",
		style: "Poppins-Bold",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dAVKZjksTsycn6X8hxm_jnx2",
		family: "Poppins",
		fullName: "Poppins ExtraBold",
		postScriptName: "Poppins-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/YFiuvZThYod1ftNb9iFHhjyI.png",
		style: "Poppins-ExtraBold",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_H2NUBjPMdIlowvCNyk61leXr",
		family: "Poppins",
		fullName: "Poppins Black",
		postScriptName: "Poppins-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4JNRZ_0jxIEJ8Da3PPqQVpd2.png",
		style: "Poppins-Black",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_iV1vYKkFzr7ZUul04mkWoBH5",
		family: "Poppins",
		fullName: "Poppins Thin Italic",
		postScriptName: "Poppins-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qktXvIGb4aHl8Iy91MLTAX5m.png",
		style: "Poppins-ThinItalic",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TU41gLI5LrwC82dzfFHHPtrp",
		family: "Poppins",
		fullName: "Poppins ExtraLight Italic",
		postScriptName: "Poppins-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Py4zBvI3j6PJJqd9bIycQYBk.png",
		style: "Poppins-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_sFOHXKuE5JMcJszNOC7gQEvC",
		family: "Poppins",
		fullName: "Poppins Light Italic",
		postScriptName: "Poppins-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/B1ANz1cLel8eGco_fz3ernEa.png",
		style: "Poppins-LightItalic",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_I4Rkr7FvfEtsgp_MUeXV8H9V",
		family: "Poppins",
		fullName: "Poppins Regular",
		postScriptName: "Poppins-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ccEbFeISsjNbApzPM7iEwX4X.png",
		style: "Poppins-Regular",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qzMJ6oHn2AmPanWgVqHenjlR",
		family: "Poppins",
		fullName: "Poppins Italic",
		postScriptName: "Poppins-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IVgiKrdnoY4sPGWnRVVb5Tyi.png",
		style: "Poppins-Italic",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hTYybK2OlhP07yUPEdpOYuwE",
		family: "Poppins",
		fullName: "Poppins Medium Italic",
		postScriptName: "Poppins-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BRuR2lmqAeLsQ5jfJ1QwaPPs.png",
		style: "Poppins-MediumItalic",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JnZNjP_xap8kVsaXAYw7wFGP",
		family: "Poppins",
		fullName: "Poppins SemiBold Italic",
		postScriptName: "Poppins-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7t1Vw0NKTOfQgcBIbk5KY71p.png",
		style: "Poppins-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fdfm5vsFPofj1moy7lW1TLhG",
		family: "Poppins",
		fullName: "Poppins Bold Italic",
		postScriptName: "Poppins-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LYAaz4qrpWZilc3rhjKKecRg.png",
		style: "Poppins-BoldItalic",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Es8KIWrAxU1Ci1rSUxeqDo9d",
		family: "Poppins",
		fullName: "Poppins ExtraBold Italic",
		postScriptName: "Poppins-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NE_RYDgkxmgHmppIcp4BAln5.png",
		style: "Poppins-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GSfKlXjVM2GDvo0p1LiOhOnP",
		family: "Poppins",
		fullName: "Poppins Black Italic",
		postScriptName: "Poppins-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AB0opbAgDCOPcv7h4vd3sz1B.png",
		style: "Poppins-BlackItalic",
		url: "https://fonts.gstatic.com/s/poppins/v15/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5TnojAYKunCanifqbwzD7y6O",
		family: "Quattrocento Sans",
		fullName: "Quattrocento Sans Bold",
		postScriptName: "QuattrocentoSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/THMCzbiLbNByN0EKUhbZB9g8.png",
		style: "QuattrocentoSans-Bold",
		url: "https://fonts.gstatic.com/s/quattrocentosans/v13/va9Z4lja2NVIDdIAAoMR5MfuElaRB0RykmrWN33AiasJ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vLPdpRZVDZIofN1nWVwspzDd",
		family: "Quattrocento Sans",
		fullName: "Quattrocento Sans Regular",
		postScriptName: "QuattrocentoSans",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_8fVCGqVBrqgGUkhgiKiEirl.png",
		style: "QuattrocentoSans",
		url: "https://fonts.gstatic.com/s/quattrocentosans/v13/va9c4lja2NVIDdIAAoMR5MfuElaRB3zOvU7eHGHJ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6ABj2NJIXr7RhBsBw_Ts5Vyj",
		family: "Quattrocento Sans",
		fullName: "Quattrocento Sans Italic",
		postScriptName: "QuattrocentoSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fQwsKUbjKjCXgcjREaHJ67sc.png",
		style: "QuattrocentoSans-Italic",
		url: "https://fonts.gstatic.com/s/quattrocentosans/v13/va9a4lja2NVIDdIAAoMR5MfuElaRB0zMt0r8GXHJkLI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Dg3PaCH5gnn2AmrfFYUrMT7J",
		family: "Quattrocento Sans",
		fullName: "Quattrocento Sans Bold Italic",
		postScriptName: "QuattrocentoSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zs3BnTTk0k66eE15BFgQ96rT.png",
		style: "QuattrocentoSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/quattrocentosans/v13/va9X4lja2NVIDdIAAoMR5MfuElaRB0zMj_bTPXnijLsJV7E.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Jz2oE3v7dTf_2tcfyN6gQx0k",
		family: "Roboto",
		fullName: "Roboto Thin",
		postScriptName: "Roboto-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2N4jb07XFIdUc6b_1yidQZO_.png",
		style: "Roboto-Thin",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOkCnqEu92Fr1MmgWxPKTM1K9nz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_R0M4Ry6AQIimxdlV0u_dU1SO",
		family: "Roboto",
		fullName: "Roboto Light",
		postScriptName: "Roboto-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/QKJvXNHqNQvdEhGNwUHieLGP.png",
		style: "Roboto-Light",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmSU5vAx05IsDqlA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JoC2cZnrz27Y4MzQbwdQYZUj",
		family: "Roboto",
		fullName: "Roboto Medium",
		postScriptName: "Roboto-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/gRfll2gzdaXRbciYXZY_EjQ9.png",
		style: "Roboto-Medium",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmEU9vAx05IsDqlA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UwdNKSyVq2iiMiuHSRRsUIOu",
		family: "Roboto",
		fullName: "Roboto Bold",
		postScriptName: "Roboto-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/5zQgS86djScKA0ri67BBCqW7.png",
		style: "Roboto-Bold",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmWUlvAx05IsDqlA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_u8FAS8rHbjGNC5ot46Be97Wc",
		family: "Roboto",
		fullName: "Roboto Black",
		postScriptName: "Roboto-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/TK1qFiUnO6p3SYz_P2oG0ksm.png",
		style: "Roboto-Black",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmYUtvAx05IsDqlA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9Q53iQNPZheaEClpkul2DbbU",
		family: "Roboto",
		fullName: "Roboto Thin Italic",
		postScriptName: "Roboto-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/juavQeQoI2bucoE0_N_IxiED.png",
		style: "Roboto-ThinItalic",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOiCnqEu92Fr1Mu51QrIzcXLsnzjYk.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_EhVjRFtG1d6bV11qieGWn2DD",
		family: "Roboto",
		fullName: "Roboto Light Italic",
		postScriptName: "Roboto-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wkW3Xl41brcrtiLqJ0kSaE7Y.png",
		style: "Roboto-LightItalic",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOjCnqEu92Fr1Mu51TjARc9AMX6lJBP.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_i_SpDQoUdylmuhVSjlQoHnLD",
		family: "Roboto",
		fullName: "Roboto Regular",
		postScriptName: "Roboto-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1hKi5Ze9LQSUaOYYDK3Wdaf0.png",
		style: "Roboto-Regular",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Me5WZLCzYlKw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_R1cCwVYmGJxBzcHMpIsaUugL",
		family: "Roboto",
		fullName: "Roboto Italic",
		postScriptName: "Roboto-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/VdOA9tafBGCbwlRKXSqgC47F.png",
		style: "Roboto-Italic",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOkCnqEu92Fr1Mu52xPKTM1K9nz.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_uqz0be4YjdVPE1oB__B24d7c",
		family: "Roboto",
		fullName: "Roboto Medium Italic",
		postScriptName: "Roboto-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/cbwyGbiGBuUWBHBRmtaVtHtd.png",
		style: "Roboto-MediumItalic",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOjCnqEu92Fr1Mu51S7ABc9AMX6lJBP.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_MYG787h7Eait_wXHeIzZUOCp",
		family: "Roboto",
		fullName: "Roboto Bold Italic",
		postScriptName: "Roboto-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/msNF0OUWsQQ0MTvJqyz6TcAc.png",
		style: "Roboto-BoldItalic",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOjCnqEu92Fr1Mu51TzBhc9AMX6lJBP.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_GdOaCrOChUb_sn1NZ1tGiMfC",
		family: "Roboto",
		fullName: "Roboto Black Italic",
		postScriptName: "Roboto-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/D9qbuuGKNAaFsa_NS8CVn20y.png",
		style: "Roboto-BlackItalic",
		url: "https://fonts.gstatic.com/s/roboto/v29/KFOjCnqEu92Fr1Mu51TLBBc9AMX6lJBP.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6MryIuJLYGVAuWxz1I6v1Cnu",
		family: "Special Elite",
		fullName: "Special Elite Regular",
		postScriptName: "SpecialElite-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2zDq6BaQXER9_2ZNypZ3DA94.png",
		style: "SpecialElite-Regular",
		url: "https://fonts.gstatic.com/s/specialelite/v11/XLYgIZbkc4JPUL5CVArUVL0nhncESXFtUsM.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4BFp9ApYkuzIFEDSwsxg1vC6",
		family: "Stint Ultra Condensed",
		fullName: "Stint Ultra Condensed Regular",
		postScriptName: "StintUltraCondensed-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/sDgwg5P8d8l2EWVQGFVBzdMz.png",
		style: "StintUltraCondensed-Regular",
		url: "https://fonts.gstatic.com/s/stintultracondensed/v11/-W_gXIrsVjjeyEnPC45qD2NoFPtBE0xCh2A-qhUO2cNvdg.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jJMfceMO3JmEqwMomVjPE7xd",
		family: "Ubuntu",
		fullName: "Ubuntu Light",
		postScriptName: "Ubuntu-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pDeuHuhLyDK5bBbDtRfIfCwn.png",
		style: "Ubuntu-Light",
		url: "https://fonts.gstatic.com/s/ubuntu/v15/4iCv6KVjbNBYlgoC1CzTt2aMH4V_gg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lPbmeJBldc08rkCLCF3ERabR",
		family: "Ubuntu",
		fullName: "Ubuntu Medium",
		postScriptName: "Ubuntu-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FUJoDmaXWGccWrD0laf8eEWB.png",
		style: "Ubuntu-Medium",
		url: "https://fonts.gstatic.com/s/ubuntu/v15/4iCv6KVjbNBYlgoCjC3Tt2aMH4V_gg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qzOdNDsx4pNyNOJskF7IKch8",
		family: "Ubuntu",
		fullName: "Ubuntu Bold",
		postScriptName: "Ubuntu-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ci2KSo91zDn7td_Npp9akp2N.png",
		style: "Ubuntu-Bold",
		url: "https://fonts.gstatic.com/s/ubuntu/v15/4iCv6KVjbNBYlgoCxCvTt2aMH4V_gg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qs3wkp1tchfX5biph4kzG0Ve",
		family: "Ubuntu",
		fullName: "Ubuntu Light Italic",
		postScriptName: "Ubuntu-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/z2WGuVFVSXQBJoB5wCnScXDM.png",
		style: "Ubuntu-LightItalic",
		url: "https://fonts.gstatic.com/s/ubuntu/v15/4iCp6KVjbNBYlgoKejZftWyIPYBvgpUI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_LauKJmYKzFFzfL5p7Iep324H",
		family: "Ubuntu",
		fullName: "Ubuntu Regular",
		postScriptName: "Ubuntu-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MvtJb0dKQIe9P3gvpVseewzO.png",
		style: "Ubuntu-Regular",
		url: "https://fonts.gstatic.com/s/ubuntu/v15/4iCs6KVjbNBYlgo6eAT3v02QFg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_pqkkpHssDQC4xwSWHtxwNsyx",
		family: "Ubuntu",
		fullName: "Ubuntu Italic",
		postScriptName: "Ubuntu-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/7RzRz5p1OldVGEUfKoMDlE1m.png",
		style: "Ubuntu-Italic",
		url: "https://fonts.gstatic.com/s/ubuntu/v15/4iCu6KVjbNBYlgoKeg7znUiAFpxm.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Jp_F0O1Yiff3vsKFmcmyhSx5",
		family: "Ubuntu",
		fullName: "Ubuntu Medium Italic",
		postScriptName: "Ubuntu-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HnbxuDWnaFx1wamparxN_0V3.png",
		style: "Ubuntu-MediumItalic",
		url: "https://fonts.gstatic.com/s/ubuntu/v15/4iCp6KVjbNBYlgoKejYHtGyIPYBvgpUI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_AZxjrDQ2XG_znwFX3xu9JJRV",
		family: "Ubuntu",
		fullName: "Ubuntu Bold Italic",
		postScriptName: "Ubuntu-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uMnxQWY7Z2y6FjoRbGLnaiyr.png",
		style: "Ubuntu-BoldItalic",
		url: "https://fonts.gstatic.com/s/ubuntu/v15/4iCp6KVjbNBYlgoKejZPsmyIPYBvgpUI.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FIHZ4SlwP4lydONXyRzIow29",
		family: "Ubuntu Condensed",
		fullName: "Ubuntu Condensed Regular",
		postScriptName: "UbuntuCondensed-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/bNOZy67NWPoCpcpJcgEKqk9p.png",
		style: "UbuntuCondensed-Regular",
		url: "https://fonts.gstatic.com/s/ubuntucondensed/v11/u-4k0rCzjgs5J7oXnJcM_0kACGMtf-fVqvHoJXw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_4WL_FEcSd5PHv4erz8Djkuep",
		family: "Yrsa",
		fullName: "Yrsa Light",
		postScriptName: "Yrsa-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/RKw_btVKTXW7GHOLm8h4nmiX.png",
		style: "Yrsa-Light",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlprgwnQFlxs_wD3CFSMYmFaaCjASNNV9rRPfrKu.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_V7Kf975XXwoOLefMHr_dY4iB",
		family: "Yrsa",
		fullName: "Yrsa Medium",
		postScriptName: "Yrsa-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IJ4jzazNeTV07id94tQWK_6Q.png",
		style: "Yrsa-Medium",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlprgwnQFlxs_wD3CFSMYmFaaCisSNNV9rRPfrKu.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_1Gsb5qD9feWqz4eFqJBDn_ne",
		family: "Yrsa",
		fullName: "Yrsa SemiBold",
		postScriptName: "Yrsa-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/NXjBpHkbVABtCP_oOQw7XcXi.png",
		style: "Yrsa-SemiBold",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlprgwnQFlxs_wD3CFSMYmFaaChAT9NV9rRPfrKu.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_PwwncvkAHWcAbqk1gEZ4obSL",
		family: "Yrsa",
		fullName: "Yrsa Bold",
		postScriptName: "Yrsa-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/oZ8wZUmuC_Hfqfi4uYNEqfDE.png",
		style: "Yrsa-Bold",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlprgwnQFlxs_wD3CFSMYmFaaCh5T9NV9rRPfrKu.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_F1EBAyrbopSABrqtCfamSwgo",
		family: "Yrsa",
		fullName: "Yrsa Regular",
		postScriptName: "Yrsa-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wFUu3GyiJvYY7Yl_qUFEc6Ex.png",
		style: "Yrsa-Regular",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlprgwnQFlxs_wD3CFSMYmFaaCieSNNV9rRPfrKu.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_f8P0v3Ngqwm_PCsHxkUiyF4X",
		family: "Yrsa",
		fullName: "Yrsa Light Italic",
		postScriptName: "Yrsa-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rq75W0hTH7JgDGK12gfDsBGM.png",
		style: "Yrsa-LightItalic",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlptgwnQFlxs1QnF94zlCfv0bz1WC2UW_LBte6KuGEo.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KUYC8kDh6QRUQnrR8z6XQGy_",
		family: "Yrsa",
		fullName: "Yrsa Italic",
		postScriptName: "Yrsa-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zya0SjLxVCqpJXPHofpRRNWq.png",
		style: "Yrsa-Italic",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlptgwnQFlxs1QnF94zlCfv0bz1WCzsW_LBte6KuGEo.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_1VsMkmFhVY3yFURXSsk7AwS4",
		family: "Yrsa",
		fullName: "Yrsa Medium Italic",
		postScriptName: "Yrsa-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/52t6IcikPMgeG5aGeYA65UlU.png",
		style: "Yrsa-MediumItalic",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlptgwnQFlxs1QnF94zlCfv0bz1WCwkW_LBte6KuGEo.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_54VYhxbBIuZ_gJ7fnyWlk1jB",
		family: "Yrsa",
		fullName: "Yrsa SemiBold Italic",
		postScriptName: "Yrsa-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lpHUCUIEzKbPHtTRmubGNgIw.png",
		style: "Yrsa-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlptgwnQFlxs1QnF94zlCfv0bz1WC-UR_LBte6KuGEo.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_9swuhX1iL4sh9EiXROXI2mw3",
		family: "Yrsa",
		fullName: "Yrsa Bold Italic",
		postScriptName: "Yrsa-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mOOSVBedmlYAOFvqKUZ8PoNV.png",
		style: "Yrsa-BoldItalic",
		url: "https://fonts.gstatic.com/s/yrsa/v8/wlptgwnQFlxs1QnF94zlCfv0bz1WC9wR_LBte6KuGEo.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ymKNPyjIBHTMkwAkh9QSq4W6",
		family: "Raleway",
		fullName: "Raleway Thin",
		postScriptName: "Raleway-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vYdlLhs20MQALtpEIgesBwjK.png",
		style: "Raleway-Thin",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvao4CPNLA3JC9c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3j07VgTHItI9hcJ8SSr8FBst",
		family: "Raleway",
		fullName: "Raleway ExtraLight",
		postScriptName: "Raleway-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HDKjTvMBo8pWDjjF20Ay0UJ3.png",
		style: "Raleway-ExtraLight",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtaooCPNLA3JC9c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_W5mqozI6mrZt51WLdtVxsyRT",
		family: "Raleway",
		fullName: "Raleway Light",
		postScriptName: "Raleway-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fwNe5F30q8eCQed5mbLr1k5y.png",
		style: "Raleway-Light",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVuEooCPNLA3JC9c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_2SGRfewt2uLamO0hDcYgKLdC",
		family: "Raleway",
		fullName: "Raleway Medium",
		postScriptName: "Raleway-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DiwxBRZN7_oz1_yablq70azU.png",
		style: "Raleway-Medium",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvoooCPNLA3JC9c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jzIROKXIiHy_2G2ZovyRbU_h",
		family: "Raleway",
		fullName: "Raleway SemiBold",
		postScriptName: "Raleway-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Z9dQTFBlI9tY3Lnw9rsSbCIF.png",
		style: "Raleway-SemiBold",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVsEpYCPNLA3JC9c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_lywF1FTuCAZ0iU3CwYp6v74a",
		family: "Raleway",
		fullName: "Raleway Bold",
		postScriptName: "Raleway-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2ucvdXcXOl4q8bQmInc__YJS.png",
		style: "Raleway-Bold",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVs9pYCPNLA3JC9c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_14fxxI3Ky0gUvSUzYkG6g4bU",
		family: "Raleway",
		fullName: "Raleway ExtraBold",
		postScriptName: "Raleway-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nk_cKShxqE_4Pw3Sa9wsE0Hc.png",
		style: "Raleway-ExtraBold",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtapYCPNLA3JC9c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QBFLSGFdtOfhJ7mjywI1Y05b",
		family: "Raleway",
		fullName: "Raleway Black",
		postScriptName: "Raleway-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/tWu2F_qcTRAUOclwLG5Oo5dH.png",
		style: "Raleway-Black",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtzpYCPNLA3JC9c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_R_UesSsiF608U6zVc3Wyzi3e",
		family: "Raleway",
		fullName: "Raleway Regular",
		postScriptName: "Raleway-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WfdqFB0g0bh5gEPOjCwVJ6BM.png",
		style: "Raleway-Regular",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaooCPNLA3JC9c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Hx5jIfxJZMmTC3jHfi1zdsCj",
		family: "Raleway",
		fullName: "Raleway Thin Italic",
		postScriptName: "Raleway-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rScFK_kvBP02pUEEelfwCasl.png",
		style: "Raleway-ThinItalic",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4WjNPrQVIT9c2c8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_xTQOSCE79c_EZsfQ5slZO5Ee",
		family: "Raleway",
		fullName: "Raleway ExtraLight Italic",
		postScriptName: "Raleway-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6jXX04A8zssg2QzcamAYA6Lh.png",
		style: "Raleway-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4ejMPrQVIT9c2c8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__pqkJRpCkXQjI2wXnkEZiM4i",
		family: "Raleway",
		fullName: "Raleway Light Italic",
		postScriptName: "Raleway-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/XpZjxp8DOiZpuvoPpN2fVln5.png",
		style: "Raleway-LightItalic",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4TbMPrQVIT9c2c8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qTyP_anHHg06zm7KjZNL6cIL",
		family: "Raleway",
		fullName: "Raleway Italic",
		postScriptName: "Raleway-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Jwk5uaNbUIRzJ_1pxnwbYl2Q.png",
		style: "Raleway-Italic",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4WjMPrQVIT9c2c8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gFgNbbRt26gJ8XrjvmqTI6mf",
		family: "Raleway",
		fullName: "Raleway Medium Italic",
		postScriptName: "Raleway-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/osBWM2zoUmoKJ4A6y0gLzLNy.png",
		style: "Raleway-MediumItalic",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4VrMPrQVIT9c2c8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_rXaxBGvvrkoV_iUQNNl0q1Q5",
		family: "Raleway",
		fullName: "Raleway SemiBold Italic",
		postScriptName: "Raleway-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ysLIVZyXo7xvpoAcfWj_wi99.png",
		style: "Raleway-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4bbLPrQVIT9c2c8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_HCWr2f0qYIqC4jQK65Klh0T1",
		family: "Raleway",
		fullName: "Raleway Bold Italic",
		postScriptName: "Raleway-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FGqMc0dbBVI6rannKpbLO5jV.png",
		style: "Raleway-BoldItalic",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4Y_LPrQVIT9c2c8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_iR4L0pdFJqw259lszYmHvl74",
		family: "Raleway",
		fullName: "Raleway ExtraBold Italic",
		postScriptName: "Raleway-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OLV9GOl1r_wO_45aCqqFRhMm.png",
		style: "Raleway-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4ejLPrQVIT9c2c8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dCGOTN3YXmymXEu_aiGqhwbZ",
		family: "Raleway",
		fullName: "Raleway Black Italic",
		postScriptName: "Raleway-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/GzLVBDTxVk4jJJGFqLt8Xu4H.png",
		style: "Raleway-BlackItalic",
		url: "https://fonts.gstatic.com/s/raleway/v22/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4cHLPrQVIT9c2c8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tpmmEOlIR6p8VWCIGprfzqwc",
		family: "Roboto Mono",
		fullName: "Roboto Mono Thin",
		postScriptName: "RobotoMono-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/grkdcxFe4uk8Xt3bQQDlp4Y4.png",
		style: "RobotoMono-Thin",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vuPQ--5Ip2sSQ.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Pqg_WXZXzfYaDqxC78wc8I9m",
		family: "Roboto Mono",
		fullName: "Roboto Mono ExtraLight",
		postScriptName: "RobotoMono-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lWK_Qm_trqVsvWM82FRG95xi.png",
		style: "RobotoMono-ExtraLight",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_XvqPQ--5Ip2sSQ.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fuJimPM6rdasPFj1vKlHwj2P",
		family: "Roboto Mono",
		fullName: "Roboto Mono Light",
		postScriptName: "RobotoMono-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/0u2uOanmx0ETLf6rDiZ61DCc.png",
		style: "RobotoMono-Light",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_gPqPQ--5Ip2sSQ.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jp0ghc0ZuIh3LnktugaAVJXM",
		family: "Roboto Mono",
		fullName: "Roboto Mono Medium",
		postScriptName: "RobotoMono-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2OznHhytLLaPXlu4pmqu98PY.png",
		style: "RobotoMono-Medium",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_7PqPQ--5Ip2sSQ.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_DhZ8t1VHl_18zEt41FRbdPgG",
		family: "Roboto Mono",
		fullName: "Roboto Mono SemiBold",
		postScriptName: "RobotoMono-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Hn0DBK0cSVi_fcRRHmzlWHs8.png",
		style: "RobotoMono-SemiBold",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_AP2PQ--5Ip2sSQ.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QryuIDoWn4UVtnVl2Q6mpgMM",
		family: "Roboto Mono",
		fullName: "Roboto Mono Bold",
		postScriptName: "RobotoMono-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MqQVdJPVaB_pl8fJD7EhByDK.png",
		style: "RobotoMono-Bold",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_Of2PQ--5Ip2sSQ.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wcf2SyXx2DigIWQ8qYfxCvBo",
		family: "Roboto Mono",
		fullName: "Roboto Mono Regular",
		postScriptName: "RobotoMono-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1nL1NXBAsTnGcK7Q7G4Y_6zn.png",
		style: "RobotoMono-Regular",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vqPQ--5Ip2sSQ.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SpQHcyGJJNIR1YaysDZygiKq",
		family: "Roboto Mono",
		fullName: "Roboto Mono Thin Italic",
		postScriptName: "RobotoMono-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/owFp_YyxGxUqm6FX2MZSdywF.png",
		style: "RobotoMono-ThinItalic",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrlnAeW9AJi8SZwt.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_b5MOpZwDG8hWj3WirrQsZRk7",
		family: "Roboto Mono",
		fullName: "Roboto Mono ExtraLight Italic",
		postScriptName: "RobotoMono-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4RWGFhUNSet9mKXgBPPbRL5d.png",
		style: "RobotoMono-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrnnAOW9AJi8SZwt.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_LP_wteLLvbmoJu91YQxf9r_H",
		family: "Roboto Mono",
		fullName: "Roboto Mono Light Italic",
		postScriptName: "RobotoMono-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/pR4n6mY63ca4vr4__isbMR_u.png",
		style: "RobotoMono-LightItalic",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrk5AOW9AJi8SZwt.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_qDMTpqVWw0XE04ld6qrUMuF0",
		family: "Roboto Mono",
		fullName: "Roboto Mono Italic",
		postScriptName: "RobotoMono-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1jIEabC63tpgRK3LS_7SyB68.png",
		style: "RobotoMono-Italic",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrlnAOW9AJi8SZwt.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_38t7hoiNCfqjqm6d4MfFfWB_",
		family: "Roboto Mono",
		fullName: "Roboto Mono Medium Italic",
		postScriptName: "RobotoMono-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/ndcNb9My1MWyASBjnZ9wHxuw.png",
		style: "RobotoMono-MediumItalic",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrlVAOW9AJi8SZwt.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_P3j84r4VVjezOTQbQJYzbUsv",
		family: "Roboto Mono",
		fullName: "Roboto Mono SemiBold Italic",
		postScriptName: "RobotoMono-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/6Mcneu5sQ0vHCRXlGQGsgXbp.png",
		style: "RobotoMono-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrm5B-W9AJi8SZwt.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KocTdVXJ3tT68Yi1bosoJ6Tn",
		family: "Roboto Mono",
		fullName: "Roboto Mono Bold Italic",
		postScriptName: "RobotoMono-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/63jb6WEJi4jDJ4G4sVT1h0OU.png",
		style: "RobotoMono-BoldItalic",
		url: "https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrmAB-W9AJi8SZwt.ttf",
		category: "monospace",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vCgmcM3G4NQIeNFS9uemARxg",
		family: "Satisfy",
		fullName: "Satisfy Regular",
		postScriptName: "Satisfy-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/64CoZPIV8jGSTJsmMKbCZTdW.png",
		style: "Satisfy-Regular",
		url: "https://fonts.gstatic.com/s/satisfy/v11/rP2Hp2yn6lkG50LoOZSCHBeHFl0.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_m8IIgGgvy30hQmCja0PHQ_iy",
		family: "Permanent Marker",
		fullName: "Permanent Marker Regular",
		postScriptName: "PermanentMarker-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/GJgKqKdjLrFgDrythT3O8ozB.png",
		style: "PermanentMarker-Regular",
		url: "https://fonts.gstatic.com/s/permanentmarker/v10/Fh4uPib9Iyv2ucM6pGQMWimMp004HaqIfrT5nlk.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_UVN8WJwNcvGTmhnsICHPYvgR",
		family: "Philosopher",
		fullName: "Philosopher Bold",
		postScriptName: "Philosopher-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/g02pK1bdJgRyCNKvh2MXYJ3p.png",
		style: "Philosopher-Bold",
		url: "https://fonts.gstatic.com/s/philosopher/v14/vEFI2_5QCwIS4_Dhez5jcWjVamgc-NaXXq7H.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_81iCHF5dvEUMnp_eacbobkmz",
		family: "Philosopher",
		fullName: "Philosopher Regular",
		postScriptName: "Philosopher-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wqcK2Xo1VpjLueB52NNlmCuS.png",
		style: "Philosopher-Regular",
		url: "https://fonts.gstatic.com/s/philosopher/v14/vEFV2_5QCwIS4_Dhez5jcVBpRUwU08qe.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_eoN6UksSkH9ggRwlCTerC_gh",
		family: "Philosopher",
		fullName: "Philosopher Italic",
		postScriptName: "Philosopher-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rprgEzzBoce36NSplCnZ2Tk3.png",
		style: "Philosopher-Italic",
		url: "https://fonts.gstatic.com/s/philosopher/v14/vEFX2_5QCwIS4_Dhez5jcWBrT0g21tqeR7c.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tzfncOLx2VWP2DUaNMTG3PaH",
		family: "Philosopher",
		fullName: "Philosopher Bold Italic",
		postScriptName: "Philosopher-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/at6trsWwpl8apwBDeDihDz2L.png",
		style: "Philosopher-BoldItalic",
		url: "https://fonts.gstatic.com/s/philosopher/v14/vEFK2_5QCwIS4_Dhez5jcWBrd_QZ8tK1W77HtMo.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TQtWnMUXJWJhM3JGrT1PLAzN",
		family: "Rambla",
		fullName: "Rambla Bold",
		postScriptName: "Rambla-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/OQEGj6kVe94PWgMdABYqjbv7.png",
		style: "Rambla-Bold",
		url: "https://fonts.gstatic.com/s/rambla/v8/snfos0ip98hx6mrMn50qPvN4yJuDYQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fUapk2wzYjpu63YF_kzlsG7v",
		family: "Rambla",
		fullName: "Rambla Regular",
		postScriptName: "Rambla-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/XhQPVsgS6xuAbnfo8EqrwhLG.png",
		style: "Rambla-Regular",
		url: "https://fonts.gstatic.com/s/rambla/v8/snfrs0ip98hx6mr0I7IONthkwQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NmRLEXcsiR8X7TSBCQTEELhu",
		family: "Rambla",
		fullName: "Rambla Italic",
		postScriptName: "Rambla-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KZCGqsep60mLJj4DM0MyiLdx.png",
		style: "Rambla-Italic",
		url: "https://fonts.gstatic.com/s/rambla/v8/snfps0ip98hx6mrEIbgKFN10wYKa.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_R9BwiGXiwwj_Bl2yZlVpW7A9",
		family: "Rambla",
		fullName: "Rambla Bold Italic",
		postScriptName: "Rambla-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/M4k3vpdLspHBfcqWmR_klitv.png",
		style: "Rambla-BoldItalic",
		url: "https://fonts.gstatic.com/s/rambla/v8/snfus0ip98hx6mrEIYC2O_l86p6TYS-Y.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_gc1DS2Q2p2XIbw7vQZcVzxld",
		family: "Righteous",
		fullName: "Righteous Regular",
		postScriptName: "Righteous-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Xbtu8v8VIaYz9aN6qjv000i0.png",
		style: "Righteous-Regular",
		url: "https://fonts.gstatic.com/s/righteous/v9/1cXxaUPXBpj2rGoU7C9mj3uEicG01A.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ln4M8VRzvHjqLPacv8VujYns",
		family: "Schoolbell",
		fullName: "Schoolbell Regular",
		postScriptName: "Schoolbell-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vPUUz_Uy9flMYzuSiTfzLMS8.png",
		style: "Schoolbell-Regular",
		url: "https://fonts.gstatic.com/s/schoolbell/v11/92zQtBZWOrcgoe-fgnJIVxIQ6mRqfiQ.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_o_g6IbqhkrMdI9pt3YiKxnOX",
		family: "Work Sans",
		fullName: "Work Sans Thin",
		postScriptName: "WorkSans-Thin",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uS_UitHm6wX8a441h6NMde46.png",
		style: "WorkSans-Thin",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nWNigDp6_cOyA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fx8vlvCFuWcG9Rwc4_N4PKGh",
		family: "Work Sans",
		fullName: "Work Sans ExtraLight",
		postScriptName: "WorkSans-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_hsTn_12d6boxa4SbtIw1vZe.png",
		style: "WorkSans-ExtraLight",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K8nXNigDp6_cOyA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_fxKxH726h3o2FleHSKIgclxr",
		family: "Work Sans",
		fullName: "Work Sans Light",
		postScriptName: "WorkSans-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/EiM5AMcWpbw3nQUwcVl_Bb6y.png",
		style: "WorkSans-Light",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32KxfXNigDp6_cOyA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Caetb_bcbOn4lnGGwb3D4b28",
		family: "Work Sans",
		fullName: "Work Sans Medium",
		postScriptName: "WorkSans-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fu0K17ojRqdlW7OQX8Xmjn1q.png",
		style: "WorkSans-Medium",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K3vXNigDp6_cOyA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_o9pnIFoYFAawVjt5Lg4sDB5v",
		family: "Work Sans",
		fullName: "Work Sans SemiBold",
		postScriptName: "WorkSans-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/glxxtZ6ZyZ98GtkkiAkeVyxK.png",
		style: "WorkSans-SemiBold",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K5fQNigDp6_cOyA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_X9WkNcQiqF0zpR9Tj2RdTBnG",
		family: "Work Sans",
		fullName: "Work Sans Bold",
		postScriptName: "WorkSans-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/wPEqId7BKAY1Xv0s5HNEi237.png",
		style: "WorkSans-Bold",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K67QNigDp6_cOyA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_0gKCOPXUKEeTUw15uaRzLkoN",
		family: "Work Sans",
		fullName: "Work Sans ExtraBold",
		postScriptName: "WorkSans-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_aMmx9PInYaqZJvBbbrGQX9k.png",
		style: "WorkSans-ExtraBold",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K8nQNigDp6_cOyA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_QODe6W70qjiO3Un6CSYCwc96",
		family: "Work Sans",
		fullName: "Work Sans Black",
		postScriptName: "WorkSans-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/YkWBngfIHYjK_wCo0DOrt_VR.png",
		style: "WorkSans-Black",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K-DQNigDp6_cOyA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_81HtOEqhN5vKCfJ544Pf4w9r",
		family: "Work Sans",
		fullName: "Work Sans Regular",
		postScriptName: "WorkSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Eh_2FDHFgxoAd0LKYtJ52ido.png",
		style: "WorkSans-Regular",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nXNigDp6_cOyA.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_DkZuCPWRGt0UOV28tqiLKsPP",
		family: "Work Sans",
		fullName: "Work Sans Thin Italic",
		postScriptName: "WorkSans-ThinItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/8XktO7yQsMqnv7C6GmdWDctC.png",
		style: "WorkSans-ThinItalic",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGU3moJo43ZKyDSQQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nUKH1HtPfHzbq7taxxzdyVih",
		family: "Work Sans",
		fullName: "Work Sans ExtraLight Italic",
		postScriptName: "WorkSans-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/PlHiyYv8kFosFszAYGuqNRCi.png",
		style: "WorkSans-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUXmsJo43ZKyDSQQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_CHpcG5m4sQLvHNfP6_KGeCPA",
		family: "Work Sans",
		fullName: "Work Sans Light Italic",
		postScriptName: "WorkSans-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/f1fWMmvbsT4mj6IQe_4OEaSk.png",
		style: "WorkSans-LightItalic",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUgGsJo43ZKyDSQQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_00ull0vbRedi2QdVq4FiGAKn",
		family: "Work Sans",
		fullName: "Work Sans Italic",
		postScriptName: "WorkSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FBR9hqSwI9ZRNKo1F90jJ1z2.png",
		style: "WorkSans-Italic",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGU3msJo43ZKyDSQQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6s8k7oGY0zxHmxRmsZfThVRQ",
		family: "Work Sans",
		fullName: "Work Sans Medium Italic",
		postScriptName: "WorkSans-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2NDr__SUyqoY6_8S89iOvynU.png",
		style: "WorkSans-MediumItalic",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGU7GsJo43ZKyDSQQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_z6f9dUUGNbzusn6ARf018AwF",
		family: "Work Sans",
		fullName: "Work Sans SemiBold Italic",
		postScriptName: "WorkSans-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9h2Bn7wk40i0cZ5Np_mzkAEn.png",
		style: "WorkSans-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUAGwJo43ZKyDSQQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_5DNNHZdq5d8c8ZCYLXd8UB5F",
		family: "Work Sans",
		fullName: "Work Sans Bold Italic",
		postScriptName: "WorkSans-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DLYpz1Sp0LZpW4EQig_B8Avy.png",
		style: "WorkSans-BoldItalic",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUOWwJo43ZKyDSQQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_N3iTg_LgfKUtHYT0mNfhe6TQ",
		family: "Work Sans",
		fullName: "Work Sans ExtraBold Italic",
		postScriptName: "WorkSans-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zIe2D54M5JShPUy7utu6a4bn.png",
		style: "WorkSans-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUXmwJo43ZKyDSQQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vsPyyys6BxKEGaZzgcU6Qr1z",
		family: "Work Sans",
		fullName: "Work Sans Black Italic",
		postScriptName: "WorkSans-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/9Lws_CYre_5jvbQW792MP2rY.png",
		style: "WorkSans-BlackItalic",
		url: "https://fonts.gstatic.com/s/worksans/v13/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUd2wJo43ZKyDSQQ.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SdVEhl3MKZoj69cKsOfBIGkv",
		family: "Rationale",
		fullName: "Rationale Regular",
		postScriptName: "Rationale-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/I8ndz1tTTL1M2pdFnUSMOJOr.png",
		style: "Rationale-Regular",
		url: "https://fonts.gstatic.com/s/rationale/v14/9XUnlJ92n0_JFxHIfHcsdlFMzLC2Zw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Mr_2UvRVKn9qBz3IJq80oLsS",
		family: "Sigmar One",
		fullName: "Sigmar One Regular",
		postScriptName: "SigmarOne-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4XCciYO4F0OGBcU7WjzUsBHn.png",
		style: "SigmarOne-Regular",
		url: "https://fonts.gstatic.com/s/sigmarone/v11/co3DmWZ8kjZuErj9Ta3dk6Pjp3Di8U0.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_2poKFegq_ft6vBHcMZlMiRKh",
		family: "Spectral",
		fullName: "Spectral ExtraLight",
		postScriptName: "Spectral-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/amDcyGbhzXdA5s364vG87DBc.png",
		style: "Spectral-ExtraLight",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCs-xNNww_2s0amA9v2s13GY_etWWIJ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SrXFx2zCbQC4E0NGUNy1BQhz",
		family: "Spectral",
		fullName: "Spectral Light",
		postScriptName: "Spectral-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/BYSLLATvkQYuw1RaoJa2OLBC.png",
		style: "Spectral-Light",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCs-xNNww_2s0amA9uSsF3GY_etWWIJ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_FSz2F858c1pn_K6I9EAuQsyB",
		family: "Spectral",
		fullName: "Spectral Medium",
		postScriptName: "Spectral-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/AgYehT3CTk1R1S8nGt3gLHZg.png",
		style: "Spectral-Medium",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCs-xNNww_2s0amA9vKsV3GY_etWWIJ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_C3n2Q7iaMTKiKTc_pYrJOPMF",
		family: "Spectral",
		fullName: "Spectral SemiBold",
		postScriptName: "Spectral-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KlthC7KKOJYJGw2UVyEHJ5RF.png",
		style: "Spectral-SemiBold",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCs-xNNww_2s0amA9vmtl3GY_etWWIJ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cxK6K3UiGGYpEWJtohJzlsjF",
		family: "Spectral",
		fullName: "Spectral Bold",
		postScriptName: "Spectral-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qXpjS4s4NrKrCel92F0G1xpK.png",
		style: "Spectral-Bold",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCs-xNNww_2s0amA9uCt13GY_etWWIJ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_6Ya2xoGxeIDLpUT8CSMDHWEv",
		family: "Spectral",
		fullName: "Spectral ExtraBold",
		postScriptName: "Spectral-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vYtZQ6KI0Idbv3wSzRHFH4Zi.png",
		style: "Spectral-ExtraBold",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCs-xNNww_2s0amA9uetF3GY_etWWIJ.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JSLxfV7P3zE9djABGdfab62v",
		family: "Spectral",
		fullName: "Spectral ExtraLight Italic",
		postScriptName: "Spectral-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/veterOYNRzB_Imdlz25eDUay.png",
		style: "Spectral-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCu-xNNww_2s0amA9M8qrXHafOPXHIJErY.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tNdDipRQv7MpveVJBzEr44ty",
		family: "Spectral",
		fullName: "Spectral Light Italic",
		postScriptName: "Spectral-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KmpMWUSm89osqfSvgNy46_e5.png",
		style: "Spectral-LightItalic",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCu-xNNww_2s0amA9M8qtHEafOPXHIJErY.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_shYSnEKqq2Yqjq9g7wZxmS2Y",
		family: "Spectral",
		fullName: "Spectral Regular",
		postScriptName: "Spectral-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/uaMgRR3Kja9SocOEZs32ZAv4.png",
		style: "Spectral-Regular",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCr-xNNww_2s0amA-M-mHnOSOuk.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_WWq5k4C8dxRez4iqudRksxow",
		family: "Spectral",
		fullName: "Spectral Italic",
		postScriptName: "Spectral-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/V812l11iPimoGZm5ZUUoFE_z.png",
		style: "Spectral-Italic",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCt-xNNww_2s0amA9M8kn3sTfukQHs.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_l7EvtoKTeoroJznOyxkRTV_h",
		family: "Spectral",
		fullName: "Spectral Medium Italic",
		postScriptName: "Spectral-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/c04WlXZ6hgox6gCDoYY4mBsQ.png",
		style: "Spectral-MediumItalic",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCu-xNNww_2s0amA9M8qonFafOPXHIJErY.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_msnPuezDvs9xBPfE4e4ZjHIB",
		family: "Spectral",
		fullName: "Spectral SemiBold Italic",
		postScriptName: "Spectral-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/nt5c2Re5mqrd0iks0lF6ouXi.png",
		style: "Spectral-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCu-xNNww_2s0amA9M8qqXCafOPXHIJErY.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KYli9jaP4E9r1Dxa1cLBvOK1",
		family: "Spectral",
		fullName: "Spectral Bold Italic",
		postScriptName: "Spectral-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/smlixdZeEvRulj2P5HSsOmd_.png",
		style: "Spectral-BoldItalic",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCu-xNNww_2s0amA9M8qsHDafOPXHIJErY.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YZD3BxYq9fuw7y_JPID2ZltK",
		family: "Spectral",
		fullName: "Spectral ExtraBold Italic",
		postScriptName: "Spectral-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lzqFi_60tBr9Di02ehHY6g5u.png",
		style: "Spectral-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/spectral/v7/rnCu-xNNww_2s0amA9M8qt3AafOPXHIJErY.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dvMCv2zb1l28R1CoQ2ILut5P",
		family: "ZCOOL XiaoWei",
		fullName: "ZCOOL XiaoWei Regular",
		postScriptName: "ZCOOLXiaoWei-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KgdyHt3Sn0_U1rNUGFZqw6Hi.png",
		style: "ZCOOLXiaoWei-Regular",
		url: "https://fonts.gstatic.com/s/zcoolxiaowei/v5/i7dMIFFrTRywPpUVX9_RJyM1YFKQHwyVd3U.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zM11BTc5mmhsaFyT4ma8W3Ts",
		family: "Playfair Display",
		fullName: "Playfair Display Medium",
		postScriptName: "PlayfairDisplay-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LhepIr1HTfc1WwB2KMz8eN3v.png",
		style: "PlayfairDisplay-Medium",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKd3vUDQZNLo_U2r.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ECvpxCm9GyyIHDXCLcWllKOn",
		family: "Playfair Display",
		fullName: "Playfair Display SemiBold",
		postScriptName: "PlayfairDisplay-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DTRPnaywOY0yoJr6Eta2Yyoo.png",
		style: "PlayfairDisplay-SemiBold",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKebukDQZNLo_U2r.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tDaLZY1qv6aC0cJY7Th0B8Ug",
		family: "Playfair Display",
		fullName: "Playfair Display Bold",
		postScriptName: "PlayfairDisplay-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/g9kP5j1g3mdsXSMa0hpztThu.png",
		style: "PlayfairDisplay-Bold",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKeiukDQZNLo_U2r.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_L3XDKGMFbx08hkeH8R7HjzD3",
		family: "Playfair Display",
		fullName: "Playfair Display ExtraBold",
		postScriptName: "PlayfairDisplay-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/31eFOLTJn8S6eoDqfigJq65v.png",
		style: "PlayfairDisplay-ExtraBold",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKfFukDQZNLo_U2r.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__yOlDGNLKYmODxxBAMTteAKN",
		family: "Playfair Display",
		fullName: "Playfair Display Black",
		postScriptName: "PlayfairDisplay-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mIlF89xjfXhnKl1sQTjzZ2Vi.png",
		style: "PlayfairDisplay-Black",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKfsukDQZNLo_U2r.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_uBM2GSyQRKRb8wnvq8J0rZ5o",
		family: "Playfair Display",
		fullName: "Playfair Display Regular",
		postScriptName: "PlayfairDisplay-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/mQu_uQvNZlp3CxtvhJAiJrTs.png",
		style: "PlayfairDisplay-Regular",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKdFvUDQZNLo_U2r.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Xe6moYIF_YO6mRCtyoZ__xcu",
		family: "Playfair Display",
		fullName: "Playfair Display Italic",
		postScriptName: "PlayfairDisplay-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/LtUqwuxiPXla5KYC1a9Twk3F.png",
		style: "PlayfairDisplay-Italic",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_qiTbtbK-F2rA0s.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_wJocyg8aoT9V9GTWczrlzyGl",
		family: "Playfair Display",
		fullName: "Playfair Display Medium Italic",
		postScriptName: "PlayfairDisplay-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/F5XiZRp33oORVcuAch2zx9QT.png",
		style: "PlayfairDisplay-MediumItalic",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_pqTbtbK-F2rA0s.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cSv1RQWbLELuynUCF6fdlrxe",
		family: "Playfair Display",
		fullName: "Playfair Display SemiBold Italic",
		postScriptName: "PlayfairDisplay-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/yAtRpSaYyBSw8CTlN_SygA7h.png",
		style: "PlayfairDisplay-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_naUbtbK-F2rA0s.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_okVV75dJLNc2Q6Egp7y9rNIW",
		family: "Playfair Display",
		fullName: "Playfair Display Bold Italic",
		postScriptName: "PlayfairDisplay-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/V4zprNyU6EwynVZxqxbDnNjc.png",
		style: "PlayfairDisplay-BoldItalic",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_k-UbtbK-F2rA0s.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_knud6DLnikUc3mVb2wwo86xm",
		family: "Playfair Display",
		fullName: "Playfair Display ExtraBold Italic",
		postScriptName: "PlayfairDisplay-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Nd_O97pXA695M3g6Gd0nWkv2.png",
		style: "PlayfairDisplay-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_iiUbtbK-F2rA0s.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_dvCG2sWse2gs7ZJ2wc3Dw_XY",
		family: "Playfair Display",
		fullName: "Playfair Display Black Italic",
		postScriptName: "PlayfairDisplay-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DlRc__BtkLVNfep5CopeONnE.png",
		style: "PlayfairDisplay-BlackItalic",
		url: "https://fonts.gstatic.com/s/playfairdisplay/v25/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_gGUbtbK-F2rA0s.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_7A_XM80jXSX5gQbKnPJY9wq1",
		family: "Russo One",
		fullName: "Russo One Regular",
		postScriptName: "RussoOne-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/_bJWsHpCg60s6AgMBDxIwWHf.png",
		style: "RussoOne-Regular",
		url: "https://fonts.gstatic.com/s/russoone/v9/Z9XUDmZRWg6M1LvRYsH-yMOInrib9Q.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_vtsvMNjzuuIUCnvKpf5B3CjO",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro ExtraLight",
		postScriptName: "SourceSansPro-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/2NF0ERCvBeWvh6bcYVTu085c.png",
		style: "SourceSansPro-ExtraLight",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKydSBYKcSV-LCoeQqfX1RYOo3i94_AkB1v_8CGxg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_nXuF6YCMH1WEwhXAB1eJDCag",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro Light",
		postScriptName: "SourceSansPro-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IQ_441EcUIR1oztAtp9AcaPN.png",
		style: "SourceSansPro-Light",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKydSBYKcSV-LCoeQqfX1RYOo3ik4zAkB1v_8CGxg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_N07l4gdnL4sFSQyXi59aiJUK",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro SemiBold",
		postScriptName: "SourceSansPro-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/zgoLPB0gTMSXEdr1ngukueoc.png",
		style: "SourceSansPro-SemiBold",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKydSBYKcSV-LCoeQqfX1RYOo3i54rAkB1v_8CGxg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_ULBmI0Jn5EL6ICR5kz9xsMNF",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro Bold",
		postScriptName: "SourceSansPro-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Zja6hXQQq75vyAcBtGle6qrg.png",
		style: "SourceSansPro-Bold",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKydSBYKcSV-LCoeQqfX1RYOo3ig4vAkB1v_8CGxg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_cXgORFQnssPYy8oNi50pLmeO",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro Black",
		postScriptName: "SourceSansPro-Black",
		preview: "https://ik.imagekit.io/lh/fonts/v2/MBE5W6EYmEGvFNi_CnfR8Pg7.png",
		style: "SourceSansPro-Black",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKydSBYKcSV-LCoeQqfX1RYOo3iu4nAkB1v_8CGxg.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_T9nDhLD2yU5vFBluFv2c396w",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro ExtraLight Italic",
		postScriptName: "SourceSansPro-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/j131eoAL8NKp64BzVKt4eKOp.png",
		style: "SourceSansPro-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZYokRdr3cWWxg40.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_yjN9I9ukG98ZjETXDd6kA18U",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro Light Italic",
		postScriptName: "SourceSansPro-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/KtLqGxr6Kk7t2hyUGLbOwuJG.png",
		style: "SourceSansPro-LightItalic",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZZMkhdr3cWWxg40.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_resxRGA1hZI9OW98uQ1v_rIX",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro Regular",
		postScriptName: "SourceSansPro-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/fRazBXD0xRhSLjz4NjbgsEaX.png",
		style: "SourceSansPro-Regular",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xK3dSBYKcSV-LCoeQqfX1RYOo3aP6TkmDZz9g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zwMH5PQy2EAiNqOwXnNyKduB",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro Italic",
		postScriptName: "SourceSansPro-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/L00u29G5CXs0IaU85lgRxpm7.png",
		style: "SourceSansPro-Italic",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xK1dSBYKcSV-LCoeQqfX1RYOo3qPa7gujNj9tmf.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_moyndv0oU8q7r1VRhZSZsAjb",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro SemiBold Italic",
		postScriptName: "SourceSansPro-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/oc6tSKpoahfY32Hpgjfk4LVu.png",
		style: "SourceSansPro-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZY4lBdr3cWWxg40.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_NtKseoY_ULXp2zX2U0hAObSW",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro Bold Italic",
		postScriptName: "SourceSansPro-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/rUPEKv84jtMB5YlVbfmzg8VC.png",
		style: "SourceSansPro-BoldItalic",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZZclRdr3cWWxg40.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_jKT5byLVgqjq799tEX1Gri2W",
		family: "Source Sans Pro",
		fullName: "Source Sans Pro Black Italic",
		postScriptName: "SourceSansPro-BlackItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/Np1ZdtQCKbfdaoCo21XJ4HsC.png",
		style: "SourceSansPro-BlackItalic",
		url: "https://fonts.gstatic.com/s/sourcesanspro/v18/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZZklxdr3cWWxg40.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_n6YdYyJM62wkCEkSYzF012i1",
		family: "Viga",
		fullName: "Viga Regular",
		postScriptName: "Viga-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/1ybfjzBmDMxOv2pdzpGhcncU.png",
		style: "Viga-Regular",
		url: "https://fonts.gstatic.com/s/viga/v9/xMQbuFFdSaiX_QIjD4e2OX8.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_kDkGgoEHGNeL7njuUAIfbaIJ",
		family: "ZCOOL KuaiLe",
		fullName: "ZCOOL KuaiLe Regular",
		postScriptName: "ZCOOLKuaiLe-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/C9nlVNTTgl338AphMkB6Hr0a.png",
		style: "ZCOOLKuaiLe-Regular",
		url: "https://fonts.gstatic.com/s/zcoolkuaile/v7/tssqApdaRQokwFjFJjvM6h2WpozzoXhC2g.ttf",
		category: "display",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Je13UnUJSnPv0UrX3v1eLD6g",
		family: "Reenie Beanie",
		fullName: "Reenie Beanie Regular",
		postScriptName: "ReenieBeanie",
		preview: "https://ik.imagekit.io/lh/fonts/v2/IAOCY21gQcK7PBXWtQ8ITwCW.png",
		style: "ReenieBeanie",
		url: "https://fonts.gstatic.com/s/reeniebeanie/v11/z7NSdR76eDkaJKZJFkkjuvWxbP2_qoOgf_w.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_AYvS2Jzdket_cTIbM0eLGvXH",
		family: "Rock Salt",
		fullName: "Rock Salt Regular",
		postScriptName: "RockSalt-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/vGBfeGBRczy95TdZPr9rDIjv.png",
		style: "RockSalt-Regular",
		url: "https://fonts.gstatic.com/s/rocksalt/v11/MwQ0bhv11fWD6QsAVOZbsEk7hbBWrA.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_tw_KolbQ4MI3AZ_rCR082u2K",
		family: "Ropa Sans",
		fullName: "Ropa Sans Regular",
		postScriptName: "RopaSans-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/re9iKRi03eZNMaLMTTl2E5HH.png",
		style: "RopaSans-Regular",
		url: "https://fonts.gstatic.com/s/ropasans/v10/EYqxmaNOzLlWtsZSScyKWjloU5KP2g.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YrgGW8JnViv1wBDIAbTuSEf3",
		family: "Ropa Sans",
		fullName: "Ropa Sans Italic",
		postScriptName: "RopaSans-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/btYdVspznGJVRGEfzJoOwUeJ.png",
		style: "RopaSans-Italic",
		url: "https://fonts.gstatic.com/s/ropasans/v10/EYq3maNOzLlWtsZSScy6WDNscZef2mNE.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_oCCf89qlbA9i0GbsKU17Qm4Y",
		family: "Slabo 27px",
		fullName: "Slabo 27px Regular",
		postScriptName: "Slabo27px-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HwFnUyUVAs_cxAqRys2iv1Sp.png",
		style: "Slabo27px-Regular",
		url: "https://fonts.gstatic.com/s/slabo27px/v7/mFT0WbgBwKPR_Z4hGN2qsxgJ1EJ7i90.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_hKOekf4jFlsQKALKm68REXp1",
		family: "Spectral SC",
		fullName: "Spectral SC ExtraLight",
		postScriptName: "SpectralSC-ExtraLight",
		preview: "https://ik.imagekit.io/lh/fonts/v2/lhVUgJ_igJoDVU_stiNW9UKW.png",
		style: "SpectralSC-ExtraLight",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk0ALCRZonmalTgyPmRfs1qwkTXPYeVXJZB.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_TH1IpHcaVmZOGuh_xhkbkpnb",
		family: "Spectral SC",
		fullName: "Spectral SC Light",
		postScriptName: "SpectralSC-Light",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3OnIrl2r0TXsze70fIExMwZo.png",
		style: "SpectralSC-Light",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk0ALCRZonmalTgyPmRfs0OwUTXPYeVXJZB.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JLYjh2WEmopXq9hWwOfl9F1F",
		family: "Spectral SC",
		fullName: "Spectral SC Medium",
		postScriptName: "SpectralSC-Medium",
		preview: "https://ik.imagekit.io/lh/fonts/v2/N1BJ8mSHqE2jYE17bNeOQKGV.png",
		style: "SpectralSC-Medium",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk0ALCRZonmalTgyPmRfs1WwETXPYeVXJZB.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__q0BRsYpqx7Gs5bZjX5dIgWc",
		family: "Spectral SC",
		fullName: "Spectral SC SemiBold",
		postScriptName: "SpectralSC-SemiBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/A3hFO0F_tWezKofUlesjHojT.png",
		style: "SpectralSC-SemiBold",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk0ALCRZonmalTgyPmRfs16x0TXPYeVXJZB.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_KqLGNPWNsRIZdh00MLh4aE6e",
		family: "Spectral SC",
		fullName: "Spectral SC Bold",
		postScriptName: "SpectralSC-Bold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/aFJL7RMFsb4HlaZ6jYU8c92V.png",
		style: "SpectralSC-Bold",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk0ALCRZonmalTgyPmRfs0exkTXPYeVXJZB.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_niVcKZHREnQfHO3d4tfOQjq6",
		family: "Spectral SC",
		fullName: "Spectral SC ExtraBold",
		postScriptName: "SpectralSC-ExtraBold",
		preview: "https://ik.imagekit.io/lh/fonts/v2/okKkdauvR8pFS0BkspVuvFJP.png",
		style: "SpectralSC-ExtraBold",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk0ALCRZonmalTgyPmRfs0CxUTXPYeVXJZB.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_SkyIrwPVvgB0IJZLSRKQbpN0",
		family: "Spectral SC",
		fullName: "Spectral SC ExtraLight Italic",
		postScriptName: "SpectralSC-ExtraLightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/WbsyHQjeqgAz42DmD8WBNp3o.png",
		style: "SpectralSC-ExtraLightItalic",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk2ALCRZonmalTgyPmRfsWg26zWN4O3WYZB_sU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_zlssAgvYSCNMBbuWcoVEabGl",
		family: "Spectral SC",
		fullName: "Spectral SC Light Italic",
		postScriptName: "SpectralSC-LightItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/HMi8eOV3j4r1KrYxTAU12IvY.png",
		style: "SpectralSC-LightItalic",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk2ALCRZonmalTgyPmRfsWg28jVN4O3WYZB_sU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_JRgmnmR_7HcNU9Ejx1v3ZjVa",
		family: "Spectral SC",
		fullName: "Spectral SC Regular",
		postScriptName: "SpectralSC-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/YIxbVakw6HC4zgaNeK1KHhRs.png",
		style: "SpectralSC-Regular",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/KtkpALCRZonmalTgyPmRfvWi6WDfFpuc.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_IsH4yedOD0oVqbwoJDq_fMd6",
		family: "Spectral SC",
		fullName: "Spectral SC Italic",
		postScriptName: "SpectralSC-Italic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/qsPKW7Dgco6UTDRPAy7eGWzC.png",
		style: "SpectralSC-Italic",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/KtkrALCRZonmalTgyPmRfsWg42T9E4ucRY8.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_Z97FwMGsg8rRVAsNSnUZeYJ7",
		family: "Spectral SC",
		fullName: "Spectral SC Medium Italic",
		postScriptName: "SpectralSC-MediumItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/4iqMGgnUleSxCTezo88EvWKb.png",
		style: "SpectralSC-MediumItalic",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk2ALCRZonmalTgyPmRfsWg25DUN4O3WYZB_sU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_XgUO1ZUTx9HGMdOYgWbZaUb0",
		family: "Spectral SC",
		fullName: "Spectral SC SemiBold Italic",
		postScriptName: "SpectralSC-SemiBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/DvnLYlt92z_9JHCrRWmf_7xC.png",
		style: "SpectralSC-SemiBoldItalic",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk2ALCRZonmalTgyPmRfsWg27zTN4O3WYZB_sU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_YVvCcgJHTsWT6E54URPPHjle",
		family: "Spectral SC",
		fullName: "Spectral SC Bold Italic",
		postScriptName: "SpectralSC-BoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/FzmbbuhCDbVX37dQ9hicN3cH.png",
		style: "SpectralSC-BoldItalic",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk2ALCRZonmalTgyPmRfsWg29jSN4O3WYZB_sU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font__VpSxTC_KbOYlhGyEhzqxRL3",
		family: "Spectral SC",
		fullName: "Spectral SC ExtraBold Italic",
		postScriptName: "SpectralSC-ExtraBoldItalic",
		preview: "https://ik.imagekit.io/lh/fonts/v2/flaFT33jf9SQDeECx5w1u6xt.png",
		style: "SpectralSC-ExtraBoldItalic",
		url: "https://fonts.gstatic.com/s/spectralsc/v6/Ktk2ALCRZonmalTgyPmRfsWg28TRN4O3WYZB_sU.ttf",
		category: "serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_3UGdXJF5Ma6zldgHoviq3i3h",
		family: "Varela Round",
		fullName: "Varela Round Regular",
		postScriptName: "VarelaRound-Regular",
		preview: "https://ik.imagekit.io/lh/fonts/v2/3XU1_ansUWbCtNqFm_I7Mfwu.png",
		style: "VarelaRound-Regular",
		url: "https://fonts.gstatic.com/s/varelaround/v13/w8gdH283Tvk__Lua32TysjIvoMGOD9gxZw.ttf",
		category: "sans-serif",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
	{
		id: "font_12M6f191DQuHy9PpQ2_vRj64",
		family: "Waiting for the Sunrise",
		fullName: "Waiting for the Sunrise Regular",
		postScriptName: "WaitingfortheSunrise",
		preview: "https://ik.imagekit.io/lh/fonts/v2/T7ZwxzsG6zvbVdlw6l9WtNCF.png",
		style: "WaitingfortheSunrise",
		url: "https://fonts.gstatic.com/s/waitingforthesunrise/v11/WBL1rFvOYl9CEv2i1mO6KUW8RKWJ2zoXoz5JsYZQ9h_ZYk5J.ttf",
		category: "handwriting",
		createdAt: "2023-06-20T04:42:55.909Z",
		updatedAt: "2023-06-20T04:42:55.909Z",
		userId: null,
	},
];
